// src/vars/i18nJaen.tsx
export type I18nCode =
  | 'en-US'
  | 'de-AT'
  | 'sl-SI'
  | 'it-IT'
  | 'ja-JP'
  | 'tr-TR'
  | 'ar-EG'

/** Jaen CMS i18n — flat key/value messages (no runtime flattening) */
export function getI18nJaen(code: I18nCode) {
  if (code === 'de-AT') {
    return {
      code,
      strings: {
        Language: 'Deutsch (Österreich)',

        AuthLogin: 'Anmelden',
        AuthSignup: 'Registrieren',
        AuthLogout: 'Abmelden',
        AuthSettings: 'Einstellungen',

        CmsLabelsRoot: 'CMS',

        CmsDashboardTitle: 'Jaen CMS',
        CmsDashboardMenuLabel: 'Dashboard',
        CmsDashboardMenuGroupLabel: 'Jaen CMS',

        CmsFrameStartEditing: 'Bearbeitung starten',
        CmsFrameStopEditing: 'Bearbeitung beenden',
        CmsFrameSaveDraft: 'Entwurf speichern',
        CmsFrameImportDraft: 'Entwurf importieren',
        CmsFrameDiscardChanges: 'Änderungen verwerfen',
        CmsFrameDiscardAll: 'Verwerfen',
        CmsFrameDiscardAllTitle: 'Alle unveröffentlichten Änderungen verwerfen',
        CmsFrameDiscardAllConfirm:
          '{fields, plural, one {# unveröffentlichte Änderung} other {# unveröffentlichte Änderungen}} auf {pages, plural, one {# Seite} other {# Seiten}} werden für alle rückgängig gemacht{who}{when}. Die Website geht auf den Stand der letzten Veröffentlichung zurück.',
        CmsFrameDiscardAllConfirmWho: ', geschrieben von {editors}',
        CmsFrameDiscardAllConfirmWhen: ', seit {since}',
        CmsFrameDiscardAllConfirmText: 'Alles verwerfen',
        CmsFrameDiscardAllCancelText: 'Weiter bearbeiten',
        CmsFrameDiscardNothing:
          'Im Entwurf unterscheidet sich nichts vom veröffentlichten Stand.',
        CmsFrameDiscardedTitle: 'Unveröffentlichte Änderungen verworfen',
        CmsFrameDiscardedDescription:
          '{who} hat um {at} alle unveröffentlichten Änderungen dieser Website verworfen. Was du siehst, ist der veröffentlichte Stand.',
        CmsFrameDiscardedByAnAdmin: 'Jemand mit Admin-Rechten',
        CmsFrameSaveStateSaving: 'Wird gespeichert',
        CmsFrameSaveStateSaved: 'Gespeichert {at}',
        CmsFrameSaveStateSavedUnpublished:
          'Gespeichert {at}, nicht veröffentlicht',
        CmsFramePublished: 'Alles veröffentlicht',
        CmsFrameSaveStateOffline:
          'Offline, {count, plural, one {# Änderung wartet} other {# Änderungen warten}}',
        CmsFrameSaveStateError: 'Speichern fehlgeschlagen, neuer Versuch',
        CmsFrameSaveStatePending: 'Noch nicht gespeichert',
        CmsFramePublish:
          '{isPublishing, select, true {Veröffentlichung läuft} other {Änderungen veröffentlichen}}',
        CmsFrameNewMedia: 'Neue Medien',
        CmsFrameGuest: 'Gast',
        CmsFrameNotificationsEditModeTitle: 'Bearbeitungsmodus',
        CmsFrameNotificationsEditModeOn: 'Du kannst die Seite jetzt bearbeiten',
        CmsFrameNotificationsEditModeOff:
          'Du kannst die Seite nicht mehr bearbeiten',
        CmsFrameNotificationsSaved: 'Gespeichert',
        CmsFrameNotificationsSavedDescription:
          'Deine Änderungen wurden gespeichert',
        CmsFrameNotificationsImported: 'Importiert',
        CmsFrameNotificationsImportedDescription:
          'Deine Änderungen wurden importiert',
        CmsFrameNotificationsImportFailed: 'Import fehlgeschlagen',
        CmsFrameNotificationsImportFailedDescription:
          'Deine Änderungen konnten nicht importiert werden',
        CmsFrameNotificationsDiscarded: 'Verworfen',
        CmsFrameNotificationsDiscardedDescription:
          'Deine Änderungen wurden verworfen',

        CmsPagesTitle: 'Jaen CMS | Seiten',
        CmsPagesMenuLabel: 'Seiten',

        CmsPagesBreadcrumbsPages: 'Seiten',
        CmsPagesBreadcrumbsNew: 'Neu',

        CmsPagesNotificationsCreated: 'Seite erstellt',
        CmsPagesNotificationsCreatedDescription: 'Seite {title} wurde erstellt',
        CmsPagesNotificationsUpdated: 'Seite aktualisiert',
        CmsPagesNotificationsUpdatedDescription:
          'Seite {title} wurde aktualisiert',
        CmsPagesNotificationsDeleted: 'Seite gelöscht',
        CmsPagesNotificationsDeletedDescription: 'Seite {slug} wurde gelöscht',
        CmsPagesNotificationsDuplicated: 'Seite dupliziert',
        CmsPagesNotificationsDuplicatedDescription:
          'Seite {slug} wurde dupliziert',
        CmsPagesNotificationsMoved: 'Seite verschoben',
        CmsPagesNotificationsMovedDescription: 'Seite {slug} wurde verschoben',
        CmsPagesNotificationsSlugUpdated: 'Slug aktualisiert',
        CmsPagesNotificationsSlugUpdatedDescription:
          'Slug wurde auf {slug} geändert',
        CmsPagesNotificationsDuplicateFailed:
          'Seite konnte nicht dupliziert werden',
        CmsPagesNotificationsMoveFailed: 'Seite konnte nicht verschoben werden',
        CmsPagesNotificationsSlugUpdateFailed:
          'Slug konnte nicht aktualisiert werden',

        CmsPagesActionsDuplicate: 'Seite duplizieren',
        CmsPagesActionsMove: 'Seite verschieben',
        CmsPagesActionsUpdateSlug: 'Slug aktualisieren',
        CmsPagesActionsRenameSlug: 'Slug umbenennen',
        CmsPagesActionsDelete: 'Seite löschen',
        CmsPagesActionsDeleteThis: 'Diese Seite löschen',

        CmsPagesDescriptionsDuplicate:
          'Dies dupliziert die Seite samt ihrer Unterseiten.',
        CmsPagesDescriptionsMove:
          'Dies verschiebt die Seite und alle ihre Unterseiten.',
        CmsPagesDescriptionsUpdateSlug:
          'Dies benennt den Slug um und beeinflusst damit den Pfad der Seite und aller Unterseiten.',
        CmsPagesDescriptionsDelete:
          'Dies löscht die Seite und alle ihre Unterseiten.',

        CmsPagesPromptsDuplicateTitle: 'Seite duplizieren',
        CmsPagesPromptsDuplicateMessage:
          'Bitte gib einen neuen Slug für die duplizierte Seite ein. Dies beeinflusst den Pfad.',
        CmsPagesPromptsDuplicateConfirm: 'Duplizieren',
        CmsPagesPromptsDuplicateCancel: 'Abbrechen',
        CmsPagesPromptsDuplicatePlaceholder: '{slug}-kopie',

        CmsPagesPromptsMoveTitle: 'Seite verschieben',
        CmsPagesPromptsMoveMessage: 'Bitte wähle eine neue Elternseite.',
        CmsPagesPromptsMoveConfirm: 'Verschieben',
        CmsPagesPromptsMoveCancel: 'Abbrechen',

        CmsPagesPromptsRenameSlugTitle: 'Slug umbenennen',
        CmsPagesPromptsRenameSlugMessage:
          'Bitte gib einen neuen Slug ein. Dies beeinflusst den Pfad.',
        CmsPagesPromptsRenameSlugConfirm: 'Umbenennen',
        CmsPagesPromptsRenameSlugCancel: 'Abbrechen',

        CmsPagesPromptsDeleteTitle: 'Seite löschen',
        CmsPagesPromptsDeleteMessage:
          'Bist du sicher, dass du diese Seite und alle ihre Unterseiten löschen möchtest?',
        CmsPagesPromptsDeleteConfirm: 'Löschen',

        CmsPagesTableSubpagesHeading: 'Unterseiten',
        CmsPagesTableReorderEnable: 'Neu anordnen',
        CmsPagesTableReorderDisable: 'Fertig',
        CmsPagesTableNewPage: 'Neue Seite',
        CmsPagesTableColumnsTitle: 'Titel',
        CmsPagesTableColumnsDescription: 'Beschreibung',
        CmsPagesTableColumnsDate: 'Datum',
        CmsPagesTableEmptyStateDescription:
          'Diese Seite hat noch keine Unterseiten.',
        CmsPagesTableEmptyStateAction: 'Neue Seite erstellen',
        CmsPagesTableDateCreated: 'Erstellt am {date} um {time}',
        CmsPagesTableDateUpdated: 'Zuletzt geändert am {date} um {time}',
        CmsPagesTableDateEmpty: '-',
        CmsPagesTableReorderError:
          'Beim Neuordnen der Seiten ist ein Fehler aufgetreten.',
        CmsPagesTableDangerZoneHeading: 'Gefahrenbereich',

        CmsPagesLabelsNoTitle: 'Kein Titel',
        CmsPagesLabelsNoDescription: 'Keine Beschreibung',
        CmsPagesLabelsFallbackTitle: 'Seite',
        CmsPagesLabelsYes: 'Ja',

        CmsPagesFormHeadingCreate: 'Neue Seite erstellen',
        CmsPagesFormHeadingEdit: 'Seite bearbeiten',
        CmsPagesFormLeadCreate:
          'Eine Seite ist eine Anordnung von Feldern oder Blöcken, die unter einer bestimmten URL angezeigt werden.',
        CmsPagesFormLeadEdit:
          'Bearbeite die Seite. Verbessere SEO und Auftritt in sozialen Medien.',
        CmsPagesFormTemplateCreate: 'Wähle ein Template für die neue Seite',
        CmsPagesFormTemplateEdit: 'Das Template der Seite',
        CmsPagesFormTemplateHelperTextCreate:
          'Dieses Template wird basierend auf der Elternseite auf die neue Seite angewendet.',
        CmsPagesFormTemplateHelperTextEdit:
          'Wenn du das Template ändern möchtest, erstelle eine neue Seite und übertrage die Inhalte.',
        CmsPagesFormTitleCreate: 'Gib einen Titel für die neue Seite ein',
        CmsPagesFormTitleEdit: 'Der Titel der Seite',
        CmsPagesFormTitleHelperTextCreate:
          'Der Titel der neuen Seite. Der URL-Slug wird automatisch aus dem Titel generiert.',
        CmsPagesFormTitleHelperTextEdit: 'Der Titel der Seite.',
        CmsPagesFormDescriptionCreate: 'Beschreibe die neue Seite',
        CmsPagesFormDescriptionEdit: 'Die Beschreibung der Seite',
        CmsPagesFormDescriptionHelperTextCreate:
          'Die Beschreibung wird von Suchmaschinen und sozialen Medien verwendet. Ziel: 160-165 Zeichen.',
        CmsPagesFormDescriptionHelperTextEdit:
          'Die Beschreibung wird von Suchmaschinen und sozialen Medien verwendet. Ziel: 160-165 Zeichen.',
        CmsPagesFormParentPageCreate: 'Wähle eine Elternseite',
        CmsPagesFormParentPageEdit: 'Die Elternseite der Seite',
        CmsPagesFormParentHelperTextCreate:
          'Dies ist die Elternseite der neuen Seite.',
        CmsPagesFormParentHelperTextEdit:
          'Du kannst die Seite einer passenderen Elternseite zuordnen.',
        CmsPagesFormImageCreate: 'Bild',
        CmsPagesFormImageEdit: 'Bild',
        CmsPagesFormImageHelperTextCreate:
          'Füge ein Bild zur Seite hinzu. Wenn keines gesetzt ist, wird das Bild der Elternseite oder der Website verwendet.',
        CmsPagesFormImageHelperTextEdit:
          'Das Bild der Seite. Wenn keines gesetzt ist, wird das Bild der Elternseite oder der Website verwendet.',
        CmsPagesFormPostCreate: 'Als Beitrag markieren',
        CmsPagesFormPostEdit: 'Beitrag',
        CmsPagesFormPostHelperTextCreate:
          'Markiere die Seite als Beitrag, um Datum und Autor zu nutzen.',
        CmsPagesFormPostHelperTextEdit:
          'Markiere die Seite als Beitrag, um Datum und Autor zu nutzen.',
        CmsPagesFormPostDateCreate: 'Veröffentlichungsdatum eingeben',
        CmsPagesFormPostDateEdit: 'Das Veröffentlichungsdatum der Seite',
        CmsPagesFormPostDateHelperTextCreate:
          'Das Datum wird zur Sortierung von Beiträgen verwendet.',
        CmsPagesFormPostDateHelperTextEdit:
          'Das Datum wird zur Sortierung von Beiträgen verwendet.',
        CmsPagesFormPostAuthorCreate: 'Autor der neuen Seite eingeben',
        CmsPagesFormPostAuthorEdit: 'Der Autor der Seite',
        CmsPagesFormPostAuthorHelperTextCreate:
          'Wird als Autor des Beitrags angezeigt.',
        CmsPagesFormPostAuthorHelperTextEdit:
          'Wird als Autor des Beitrags angezeigt.',
        CmsPagesFormPostCategoryCreate: 'Kategorie für die neue Seite eingeben',
        CmsPagesFormPostCategoryEdit: 'Die Kategorie der Seite',
        CmsPagesFormPostCategoryHelperTextCreate:
          'Die Kategorie dient zur Einteilung der Beiträge.',
        CmsPagesFormPostCategoryHelperTextEdit:
          'Die Kategorie dient zur Einteilung der Beiträge.',
        CmsPagesFormExcludeFromIndexCreate: 'Von Index ausschließen',
        CmsPagesFormExcludeFromIndexEdit: 'Von Index ausschließen',
        CmsPagesFormExcludeFromIndexHelperTextCreate:
          'Schließe diese Seite von allen Index-Feldern aus (z.B. überall, wo Seiten gelistet werden).',
        CmsPagesFormExcludeFromIndexHelperTextEdit:
          'Schließe diese Seite von allen Index-Feldern aus (z.B. überall, wo Seiten gelistet werden).',
        CmsPagesFormPlaceholdersTitle: 'Titel',
        CmsPagesFormPlaceholdersSlug: 'slug',
        CmsPagesFormPlaceholdersDescription: 'Beschreibung',
        CmsPagesFormPlaceholdersAuthor: 'Autor',
        CmsPagesFormPlaceholdersCategory: 'Kategorie',
        CmsPagesFormHelperMediaDescription:
          'Lade ein Bild hoch, das die Organisation repräsentiert.',
        CmsPagesFormErrorsSlugInUse: 'Slug wird bereits verwendet',
        CmsPagesFormErrorsParentRequired: 'Elternseite ist erforderlich',
        CmsPagesFormErrorsTemplateRequired: 'Template ist erforderlich',
        CmsPagesFormErrorsDateRequired: 'Datum ist für Beiträge erforderlich',
        CmsPagesFormErrorsAuthorRequired: 'Autor ist für Beiträge erforderlich',
        CmsPagesFormButtonsPreview: 'Vorschau',
        CmsPagesFormButtonsEdit: 'Seite bearbeiten',
        CmsPagesFormButtonsCancel: 'Abbrechen',
        CmsPagesFormButtonsCreate: 'Seite erstellen',
        CmsPagesFormButtonsSave: 'Seite speichern',

        CmsMediaTitle: 'Jaen CMS | Medien',
        CmsMediaMenuLabel: 'Medien',
        CmsMediaBreadcrumbsMedia: 'Medien',

        CmsSettingsTitle: 'Jaen CMS | Einstellungen',
        CmsSettingsMenuLabel: 'Einstellungen',
        CmsSettingsBreadcrumbsSettings: 'Einstellungen',
        CmsSettingsNotificationsUpdated: 'Einstellungen aktualisiert',
        CmsSettingsFormHeading: 'Einstellungen',
        CmsSettingsFormSiteInfoGroupTitle: 'Website-Informationen',
        CmsSettingsFormSiteInfoTitleLabel: 'Titel',
        CmsSettingsFormSiteInfoTitlePlaceholder: 'Titel',
        CmsSettingsFormSiteInfoTitleTooLong: 'Titel ist zu lang',
        CmsSettingsFormSiteInfoUrlLabel: 'URL',
        CmsSettingsFormSiteInfoUrlPlaceholder: 'https://snek.at',
        CmsSettingsFormSiteInfoUrlInvalid:
          'URL muss mit http:// oder https:// beginnen',
        CmsSettingsFormSiteInfoDescriptionLabel: 'Beschreibung',
        CmsSettingsFormSiteInfoDescriptionPlaceholder:
          'Die Beschreibung, die in Suchmaschinen und sozialen Medien erscheint.',
        CmsSettingsFormSiteInfoDescriptionHelper:
          'Kurze Beschreibung für deine Website.',
        CmsSettingsFormSiteInfoImageLabel: 'Bild',
        CmsSettingsFormSiteInfoImageDescription:
          'Lade ein Bild hoch, das die Website repräsentiert.',
        CmsSettingsFormOrganisationGroupTitle: 'Organisation',
        CmsSettingsFormOrganisationNameLabel: 'Name',
        CmsSettingsFormOrganisationNamePlaceholder: 'Snek',
        CmsSettingsFormOrganisationNameTooLong: 'Name ist zu lang',
        CmsSettingsFormOrganisationUrlLabel: 'URL',
        CmsSettingsFormOrganisationUrlPlaceholder: 'https://snek.at',
        CmsSettingsFormOrganisationUrlInvalid:
          'URL muss mit http:// oder https:// beginnen',
        CmsSettingsFormOrganisationLogoLabel: 'Bild',
        CmsSettingsFormOrganisationLogoDescription:
          'Lade ein Bild hoch, das die Organisation repräsentiert.',
        CmsSettingsFormCancel: 'Abbrechen',
        CmsSettingsFormSave: 'Speichern',

        CmsDebugTitle: 'Jaen CMS | Debug',
        CmsDebugBreadcrumbsDebug: 'Debug',

        CmsNotificationTitle: 'Jaen CMS | Benachrichtigung',
        CmsNotificationMenuLabel: 'Popup',
        CmsNotificationBreadcrumbsPopup: 'Popup',
        CmsNotificationCardTitle: 'Benachrichtigungs-Popup',
        CmsNotificationCardDescription:
          'Konfiguriere das Benachrichtigungs-Popup. Die Benachrichtigung wird angezeigt, wenn der Benutzer die Seite besucht.',
        CmsNotificationPreview: 'Vorschau',
        CmsNotificationNotificationsUpdated: 'Benachrichtigung aktualisiert',
        CmsNotificationNotificationsUpdatedDescription:
          'Die Benachrichtigung wurde aktualisiert',
        CmsNotificationFormTitleLabel: 'Titel',
        CmsNotificationFormTitlePlaceholder: 'Neuigkeiten',
        CmsNotificationFormTitleDescription: 'Der Titel der Benachrichtigung',
        CmsNotificationFormMessageLabel: 'Nachricht',
        CmsNotificationFormMessageExample: 'Dies ist eine Beispielnachricht',
        CmsNotificationFormMessageDescription:
          'Die Nachricht der Benachrichtigung',
        CmsNotificationFormEnterUrl: 'URL eingeben',
        CmsNotificationFormFromLabel: 'Von',
        CmsNotificationFormFromDescription:
          'Die Benachrichtigung wird <b>nach</b> diesem Datum angezeigt',
        CmsNotificationFormToLabel: 'Bis',
        CmsNotificationFormToDescription:
          'Die Benachrichtigung wird <b>bis</b> zu diesem Datum angezeigt',
        CmsNotificationFormPickDate: 'Datum auswählen',
        CmsNotificationFormEnabledLabel:
          'Benachrichtigungs-Popup anzeigen, wenn der Benutzer die Seite besucht',
        CmsNotificationFormSubmit: 'Absenden',

        // Accounts
        CmsAccountsErrorsLoadService:
          'Benutzer konnten nicht vom Identitätsdienst geladen werden.',
        CmsAccountsErrorsLoadGeneric: 'Benutzer konnten nicht geladen werden.',
        CmsAccountsNotificationsCreated: 'Konto erstellt',
        CmsAccountsNotificationsCreatedDescription:
          'Konto {username} wurde erstellt',
        CmsAccountsNotificationsCreateFailed:
          'Konto konnte nicht erstellt werden',
        CmsAccountsTitle: 'Konten',
        CmsAccountsPageTitle: 'Jaen CMS | Konten',
        CmsAccountsMenuLabel: 'Konten',
        CmsAccountsBreadcrumbsAccounts: 'Konten',
        CmsAccountsSubtitle:
          'Durchsuche und verwalte die Benutzerkonten deines Identitätsmandanten.',
        CmsAccountsActionsCreate: 'Neues Konto',
        CmsAccountsSearchPlaceholder:
          'Nach Name, E-Mail oder Anmeldename suchen',
        CmsAccountsErrorsLoadTitle: 'Konten konnten nicht geladen werden',
        CmsAccountsCardUnnamed: 'Unbenannter Benutzer',
        CmsAccountsCardNoEmail: 'Keine E-Mail-Adresse hinterlegt',
        CmsAccountsCardUsername: 'Benutzername',
        CmsAccountsCardLoginNames: 'Anmeldenamen',
        CmsAccountsCardNoLoginNames: 'Keine weiteren Anmeldenamen',
        CmsAccountsCardManage: 'Konto verwalten',
        CmsAccountsEmptyTitle: 'Keine Konten entsprechen deiner Suche',
        CmsAccountsEmptyHint:
          'Passe den Suchbegriff an oder erstelle ein neues Konto.',
        CmsAccountsCreateTitle: 'Neues Konto erstellen',
        CmsAccountsCreateUsername: 'Benutzername',
        CmsAccountsCreateEmail: 'E-Mail',
        CmsAccountsCreateFirstName: 'Vorname',
        CmsAccountsCreateLastName: 'Nachname',
        CmsAccountsCreateInitialPassword: 'Initialpasswort (optional)',
        CmsAccountsCreateSendReset:
          'E-Mail zum Zurücksetzen des Passworts senden, wenn kein Passwort gesetzt ist',
        CmsAccountsActionsCancel: 'Abbrechen',
        CmsAccountsActionsCreateSubmit: 'Konto erstellen',
        CmsAccountsErrorsDetailService:
          'Das Benutzerprofil konnte nicht vom Identitätsdienst geladen werden.',
        CmsAccountsErrorsDetailGeneric:
          'Das Benutzerprofil konnte nicht geladen werden.',
        CmsAccountsNotificationsActionFailed: 'Aktion fehlgeschlagen',
        CmsAccountsNotificationsSaved: 'Änderungen gespeichert',
        CmsAccountsNotificationsSavedDescription:
          'Das Profil wurde aktualisiert.',
        CmsAccountsNotificationsSaveFailed: 'Speichern fehlgeschlagen',
        CmsAccountsNotificationsDeleted: 'Konto gelöscht',
        CmsAccountsNotificationsPasswordSet: 'Passwort gesetzt',
        CmsAccountsNotificationsRolesUpdated: 'Rollen aktualisiert',
        CmsAccountsDetailBack: 'Zurück zu den Konten',
        CmsAccountsErrorsDetailTitle:
          'Dieses Konto konnte nicht geladen werden',
        CmsAccountsDetailNoEmail: 'Keine primäre E-Mail-Adresse hinterlegt',
        CmsAccountsDetailUsername: 'Benutzername',
        CmsAccountsDetailPreferredLogin: 'Bevorzugter Anmeldename',
        CmsAccountsDetailState: 'Kontostatus',
        CmsAccountsDetailCreated: 'Erstellt',
        CmsAccountsDetailLastChange: 'Letzte Änderung',
        CmsAccountsDetailResourceOwner: 'Organisation',
        CmsAccountsProfileTitle: 'Profil',
        CmsAccountsProfileDisplayName: 'Anzeigename',
        CmsAccountsProfileLanguage: 'Bevorzugte Sprache',
        CmsAccountsProfileFirstName: 'Vorname',
        CmsAccountsProfileLastName: 'Nachname',
        CmsAccountsProfileEmail: 'E-Mail',
        CmsAccountsProfilePhone: 'Telefon',
        CmsAccountsProfileReset: 'Zurücksetzen',
        CmsAccountsProfileSave: 'Änderungen speichern',
        CmsAccountsRolesTitle: 'Projektrollen',
        CmsAccountsRolesGrant: 'Rollen zuweisen',
        CmsAccountsRolesEdit: 'Bearbeiten',
        CmsAccountsNotificationsRolesRevoked: 'Rollen entzogen',
        CmsAccountsRolesRevoke: 'Entziehen',
        CmsAccountsRolesEmpty: 'Keine Projektrollen zugewiesen.',
        CmsAccountsActionsTitle: 'Kontoaktionen',
        CmsAccountsActionsSetPassword: 'Passwort setzen',
        CmsAccountsNotificationsResetRequested:
          'Zurücksetzen des Passworts angefordert',
        CmsAccountsActionsRequestReset: 'Zurücksetzen des Passworts anfordern',
        CmsAccountsNotificationsVerificationSent:
          'Verifizierungs-E-Mail gesendet',
        CmsAccountsActionsResendVerification:
          'E-Mail-Verifizierung erneut senden',
        CmsAccountsNotificationsDeactivated: 'Konto deaktiviert',
        CmsAccountsActionsDeactivate: 'Deaktivieren',
        CmsAccountsNotificationsReactivated: 'Konto reaktiviert',
        CmsAccountsActionsReactivate: 'Reaktivieren',
        CmsAccountsNotificationsUnlocked: 'Konto entsperrt',
        CmsAccountsActionsUnlock: 'Entsperren',
        CmsAccountsNotificationsLocked: 'Konto gesperrt',
        CmsAccountsActionsLock: 'Sperren',
        CmsAccountsActionsDelete: 'Konto löschen',
        CmsAccountsDeleteTitle: 'Konto löschen',
        CmsAccountsDeletePrompt:
          'Bist du sicher, dass du {username} löschen möchtest? Dies kann nicht rückgängig gemacht werden.',
        CmsAccountsPasswordTitle: 'Neues Passwort setzen',
        CmsAccountsPasswordNew: 'Neues Passwort',
        CmsAccountsPasswordChangeRequired:
          'Passwortänderung bei der nächsten Anmeldung verlangen',
        CmsAccountsRolesEditTitle: 'Zugewiesene Rollen bearbeiten',
        CmsAccountsRolesGrantTitle: 'Projektrollen zuweisen',
        CmsAccountsRolesProject: 'Projekt',
        CmsAccountsRolesNoneAvailable:
          'Für dieses Projekt sind keine Rollen verfügbar.',
        CmsAccountsRolesSave: 'Rollen speichern',
        SettingsTabGeneral: 'Allgemein',
        SettingsTabPasswordSecurity: 'Passwort & Sicherheit',
        SettingsProfileGenderUnspecified: 'Keine Angabe',
        SettingsProfileGenderMale: 'Männlich',
        SettingsProfileGenderFemale: 'Weiblich',
        SettingsProfileGenderOther: 'Divers',
        SettingsUsernamePromptTitle: 'Benutzernamen ändern',
        SettingsUsernamePromptMessage:
          'Bitte gib deinen neuen Benutzernamen ein',
        SettingsEmailPromptTitle: 'E-Mail-Adresse ändern',
        SettingsEmailPromptMessage: 'Bitte gib deine neue E-Mail-Adresse ein',
        SettingsPhonePromptTitle: 'Telefonnummer ändern',
        SettingsPhonePromptMessage: 'Bitte gib deine neue Telefonnummer ein',
        SettingsPhoneDeleteConfirmTitle: 'Telefonnummer löschen',
        SettingsPhoneDeleteConfirmMessage:
          'Bist du sicher, dass du deine Telefonnummer löschen möchtest?',
        SettingsPhoneVerifyPromptTitle: 'Telefonnummer verifizieren',
        SettingsPhoneVerifyPromptMessage: 'Bitte gib den Bestätigungscode ein',
        SettingsProfileTitle: 'Profil',
        SettingsProfileAvatarNoFileSelected: 'Keine Datei ausgewählt',
        SettingsProfileUsernameLabel: 'Benutzername',
        SettingsProfileUsernameEditAriaLabel: 'Benutzernamen bearbeiten',
        SettingsProfileFirstNameLabel: 'Vorname',
        SettingsProfileLastNameLabel: 'Nachname',
        SettingsProfileNicknameLabel: 'Spitzname',
        SettingsProfileFullNameLabel: 'Vollständiger Name',
        SettingsProfileGenderLabel: 'Geschlecht',
        SettingsProfileLanguageLabel: 'Sprache',
        SettingsProfileLanguageNotSet: 'Nicht festgelegt',
        SettingsSaveButton: 'Speichern',
        SettingsContactTitle: 'Kontaktinformationen',
        SettingsContactRefreshAriaLabel: 'Aktualisieren',
        SettingsContactDescription:
          'Diese Angaben werden verwendet, um dir wichtige Informationen zu senden, etwa E-Mails zum Zurücksetzen des Passworts.',
        SettingsContactEmailLabel: 'E-Mail',
        SettingsContactEmailEditAriaLabel: 'E-Mail-Adresse bearbeiten',
        SettingsContactVerified: 'Verifiziert',
        SettingsContactNotVerified: 'Nicht verifiziert',
        SettingsContactResendCodeButton: 'Code erneut senden',
        SettingsContactPhoneLabel: 'Telefonnummer',
        SettingsContactPhoneDeleteAriaLabel: 'Telefonnummer löschen',
        SettingsContactPhoneEditAriaLabel: 'Telefonnummer bearbeiten',
        SettingsContactVerifyButton: 'Verifizieren',
        SettingsContactPhoneAddAriaLabel: 'Telefonnummer hinzufügen',
        SettingsContactPhoneNone: 'Keine Telefonnummer hinterlegt',
        SettingsPasswordTitle: 'Passwort',
        SettingsPasswordPolicyIntro:
          'Gib das neue Passwort gemäß den folgenden Richtlinien ein.',
        SettingsPasswordCurrentLabel: 'Aktuelles Passwort',
        SettingsPasswordCurrentPlaceholder: 'Aktuelles Passwort',
        SettingsPasswordPolicyMinLength:
          'Muss mindestens {minLength} Zeichen lang sein. ({length} / {minLength})',
        SettingsPasswordPolicySymbol:
          'Muss ein Sonderzeichen oder Satzzeichen enthalten.',
        SettingsPasswordPolicyNumber: 'Muss eine Zahl enthalten.',
        SettingsPasswordPolicyUppercase: 'Muss einen Großbuchstaben enthalten.',
        SettingsPasswordPolicyLowercase:
          'Muss einen Kleinbuchstaben enthalten.',
        SettingsPasswordPolicyMatch: 'Passwörter stimmen überein.',
        SettingsPasswordNewLabel: 'Neues Passwort',
        SettingsPasswordNewPlaceholder: 'Neues Passwort',
        SettingsPasswordConfirmLabel: 'Passwort bestätigen',
        SettingsPasswordConfirmPlaceholder: 'Passwort bestätigen',
        SettingsPasswordResetButton: 'Aktuelles Passwort zurücksetzen',
        SettingsPasswordCancelButton: 'Abbrechen',
        SettingsPasswordHint: 'Ein sicheres Passwort schützt dein Konto',
        SettingsPasswordEditAriaLabel: 'Passwort bearbeiten',
        ProfileFormTitle: 'Konto',
        ProfileFormFirstNameLabel: 'Vorname',
        ProfileFormLastNameLabel: 'Nachname',
        ProfileFormUsernameLabel: 'Benutzername',
        ProfileFormRequiredError: 'Dieses Feld ist erforderlich',
        ProfileFormImageLabel: 'Bild',
        ProfileFormImageDescription:
          'Lade ein Profilbild hoch, damit dein Konto leichter zu erkennen ist.',
        ProfileFormUpdateButton: 'Konto aktualisieren',
        EmailFormTitle: 'E-Mail-Adressen',
        EmailFormPrimaryLabel: 'Primär',
        EmailFormDeleteAriaLabel: 'E-Mail-Adresse löschen',
        EmailFormPrimaryHelpText:
          'Primäre E-Mail-Adressen werden für kontobezogene Mitteilungen verwendet (z.B. Zurücksetzen des Passworts).',
        EmailFormUnverifiedLabel: 'Nicht verifiziert',
        EmailFormResendVerificationLink: 'Verifizierungs-E-Mail erneut senden',
        EmailFormAddDescription: 'Füge deinem Konto eine E-Mail-Adresse hinzu.',
        EmailFormRequiredError: 'Dieses Feld ist erforderlich',
        EmailFormInvalidEmailError: 'Ungültige E-Mail-Adresse',
        EmailFormEmailPlaceholder: 'E-Mail',
        EmailFormAddingLoadingText: 'Wird hinzugefügt...',
        EmailFormAddButton: 'Hinzufügen',
        PasswordFormTitle: 'Passwort',
        PasswordFormPasswordLabel: 'Passwort',
        PasswordFormRequiredError: 'Dieses Feld ist erforderlich',
        PasswordFormConfirmPasswordLabel: 'Passwort bestätigen',
        PasswordFormMismatchError: 'Passwörter stimmen nicht überein',
        PasswordFormHelpText:
          'Dein Passwort muss mindestens 15 Zeichen lang sein ODER mindestens 8 Zeichen inklusive einer Zahl und eines Kleinbuchstabens.',
        PasswordFormUpdateButton: 'Passwort aktualisieren',
        PasswordResetTryAnotherEmailButton: 'Andere E-Mail-Adresse versuchen',
        PasswordResetBackToWebsiteButton: 'Zurück zur Website',
        PasswordResetEmailHeading: 'Passwort zurücksetzen',
        PasswordResetPasswordHeading: 'Gib dein neues Passwort ein',
        PasswordResetOtpHeading: 'Gib deinen Code ein',
        PasswordResetNoAccountPrompt: 'Noch kein Konto?',
        PasswordResetSignUpLink: 'Registrieren',
        PasswordResetPasswordDescription:
          'Gib ein neues Passwort für <b>{email}</b> ein.',
        PasswordResetOtpDescription:
          'Ein Einmalpasswort (OTP) wurde an <strong>{email}</strong> gesendet.',
        PasswordResetStepPasswordPasswordLabel: 'Passwort',
        PasswordResetStepPasswordConfirmPasswordLabel: 'Passwort bestätigen',
        PasswordResetStepPasswordRequiredError: 'Dieses Feld ist erforderlich',
        PasswordResetStepPasswordMismatchError:
          'Passwörter stimmen nicht überein',
        PasswordResetStepPasswordSubmitButton:
          'E-Mail zum Zurücksetzen des Passworts senden',
        SignupSuccessTitle: 'Erfolgreich registriert.',
        SignupSuccessDescription:
          'Bitte überprüfe deine E-Mails auf einen Verifizierungslink.',
        SignupErrorTitle: 'Registrierung fehlgeschlagen.',
        SignupBackToWebsiteButton: 'Zurück zur Website',
        SignupHeading: 'Erstelle dein Konto',
        SignupAlreadyUserPrompt: 'Bereits registriert?',
        SignupLoginLink: 'Anmelden',
        SignupFirstNameLabel: 'Vorname',
        SignupFirstNameRequiredError: 'Vorname ist erforderlich',
        SignupLastNameLabel: 'Nachname',
        SignupLastNameRequiredError: 'Nachname ist erforderlich',
        SignupEmailLabel: 'E-Mail',
        SignupEmailRequiredError: 'E-Mail ist erforderlich',
        SignupUsernameLabel: 'Benutzername',
        SignupSubmitButton: 'Registrieren',
        PasswordFieldLabel: 'Passwort',
        PasswordFieldMaskAriaLabel: 'Passwort verbergen',
        PasswordFieldRevealAriaLabel: 'Passwort anzeigen',
        PasswordFieldRequiredError: 'Passwort ist erforderlich',
        MediaCloseSidebarAriaLabel: 'Seitenleiste schließen',
        MediaPagesHeading: 'Seiten',
        DialogCloseLabel: 'Schließen',
        CmsDebugVersionInformationHeading: 'Versionsinformationen',
        CmsDebugVersionInformationDescription:
          'Hier findest du Informationen zu den in deinem Projekt installierten Versionen von Gatsby, Jaen und Plugins.',
        CmsDebugGatsbyTitle: 'Gatsby',
        CmsDebugGatsbyDescription:
          'Gatsby ist ein beliebter Static-Site-Generator für moderne Webanwendungen. Hier findest du Informationen zu den in deinem Projekt installierten Versionen von Gatsby und der Gatsby CLI.',
        CmsDebugGatsbyVersionLabel: 'Gatsby-Version:',
        CmsDebugGatsbyCliVersionLabel: 'Gatsby-CLI-Version:',
        CmsDebugJaenTitle: 'Jaen',
        CmsDebugJaenDescription:
          'Jaen ist ein Headless-CMS zur Verwaltung der Inhalte deiner Website. Hier findest du Informationen zur in deinem Projekt installierten Jaen-Version.',
        CmsDebugJaenVersionLabel: 'Jaen-Version:',
        CmsDebugPluginsTitle: 'Plugins',
        CmsDebugPluginsDescription:
          'Plugins erweitern die Funktionalität deiner Website. Hier findest du eine Liste der installierten Plugins und ihrer Versionen.',
        CmsDebugWidgetsHeading: 'Widgets',
        CmsDebugWidgetsDescription:
          'Hier findest du eine Liste der Widgets und ihrer Daten. Dies ist eine Vorschaufunktion und wird in Zukunft verbessert.',
        CmsDebugWidgetsColumnName: 'Name',
        CmsDebugWidgetsColumnCreatedAt: 'Erstellt am',
        CmsDebugWidgetsColumnModifiedAt: 'Geändert am',
        CmsDebugWidgetsColumnData: 'Daten',
        DynamicPageNotFound: 'Seite nicht gefunden',
        DynamicPageLoading: 'Wird geladen...',
        FormMediaChooser: 'Medien auswählen',
        JaenFrameMediaModal: 'Medien',
        MediaModal: 'Medien',
        EmailwerkTemplatesPageTitle: 'Templates',
        EmailwerkBreadcrumbsRoot: 'Emailwerk',
        EmailwerkBreadcrumbsTemplates: 'Templates',
        EmailwerkMenuGroupLabel: 'Emailwerk',
        EmailwerkTemplatesLoadFailedTitle:
          'Templates konnten nicht geladen werden ({name})',
        EmailwerkTemplatesAddPromptTitle: 'Template hinzufügen',
        EmailwerkTemplatesAddPromptMessage:
          'Bitte gib eine Beschreibung für das neue Template ein',
        EmailwerkTemplatesCreateFailedTitle:
          'Template konnte nicht erstellt werden',
        EmailwerkTemplatesHeading: 'E-Mail-Templates',
        EmailwerkTemplatesDefaultSender:
          'Standardabsender: <strong>{address}</strong>',
        EmailwerkTemplatesNoSenderConfigured: 'Kein Absender konfiguriert',
        EmailwerkTemplatesSenderVerifiedTitle: 'Absender verifiziert',
        EmailwerkTemplatesSenderVerificationFailedTitle:
          'Verifizierung fehlgeschlagen',
        EmailwerkTemplatesAddButton: 'Template hinzufügen',
        EmailwerkTemplatesTableDescription: 'Beschreibung',
        EmailwerkTemplatesTableSubject: 'Betreff',
        EmailwerkTemplatesTableTo: 'An',
        EmailwerkTemplatesTableReplyTo: 'Antwort an',
        EmailwerkTemplatesTableUpdatedAt: 'Aktualisiert am',
        EmailwerkTemplatesTableCreatedAt: 'Erstellt am',
        EmailwerkTemplatesNoTemplatesFound: 'Keine Templates gefunden',
        EmailwerkTemplateLoadFailedTitle:
          'Template konnte nicht geladen werden ({name})',
        EmailwerkTemplateUpdatedTitle: 'Template aktualisiert',
        EmailwerkTemplateUpdatedDescription:
          'Template {templateId} wurde aktualisiert',
        EmailwerkTemplateErrorTitle: 'Fehler',
        EmailwerkTemplateUpdateErrorDescription:
          'Template {templateId} konnte nicht aktualisiert werden',
        EmailwerkTemplateDeleteConfirmTitle: 'Template löschen',
        EmailwerkTemplateDeleteConfirmMessage:
          'Bist du sicher, dass du dieses Template löschen möchtest?',
        EmailwerkTemplateDeleteConfirmButton: 'Löschen',
        EmailwerkTemplateDeleteCancelButton: 'Abbrechen',
        EmailwerkTemplateDeletedTitle: 'Template gelöscht',
        EmailwerkTemplateDeletedDescription:
          'Template {templateId} wurde gelöscht',
        EmailwerkTemplateDeleteErrorDescription:
          'Template {templateId} konnte nicht gelöscht werden',
        EmailwerkTemplateServerPreviewErrorDescription:
          'Die Server-Vorschau konnte nicht gerendert werden',
        EmailwerkTemplateCopiedTitle: 'Kopiert',
        EmailwerkTemplateCopiedDescription:
          'Template-ID {templateId} in die Zwischenablage kopiert',
        EmailwerkTemplateHeading: 'E-Mail-Template',
        EmailwerkTemplateIdAddon: 'Template-ID',
        EmailwerkTemplateCopyIdAriaLabel: 'Template-ID kopieren',
        EmailwerkTemplateDescriptionLabel: 'Beschreibung',
        EmailwerkTemplateParentLabel: 'Übergeordnetes Template',
        EmailwerkTemplateParentPlaceholder: 'Kein Template',
        EmailwerkTemplateEngineLabel: 'Engine',
        EmailwerkTemplateVerifyReplyToLabel: 'Antwortadresse verifizieren',
        EmailwerkTemplateLinkedLabel: 'Verknüpft',
        EmailwerkTemplateNoLinkedTemplates: 'Keine verknüpften Templates',
        EmailwerkTemplateEnvelopeHeading: 'Umschlag',
        EmailwerkTemplateSubjectLabel: 'Betreff',
        EmailwerkTemplateToHeading: 'An',
        EmailwerkTemplateDeleteToFieldAriaLabel: 'Empfängerfeld löschen',
        EmailwerkTemplateEmailAddressPlaceholder: 'E-Mail-Adresse eingeben',
        EmailwerkTemplateAddToButton: 'Empfänger hinzufügen',
        EmailwerkTemplateReplyToLabel: 'Antwort an',
        EmailwerkTemplateContentHeading: 'Inhalt',
        EmailwerkTemplatePreviewHeading: 'Vorschau',
        EmailwerkTemplateRenderedPreviewHeading: 'Gerenderte Vorschau',
        EmailwerkTemplateRenderPreviewButton: 'Vorschau rendern',
        EmailwerkTemplateVariablesHeading: 'Variablen',
        EmailwerkTemplateVariablesTableName: 'Name',
        EmailwerkTemplateVariablesTableType: 'Typ',
        EmailwerkTemplateVariablesTableDescription: 'Beschreibung',
        EmailwerkTemplateVariablesTableDefaultValue: 'Standardwert',
        EmailwerkTemplateVariablesTableRequired: 'Erforderlich',
        EmailwerkTemplateVariablesTableConstant: 'Konstant',
        EmailwerkTemplateVariablesRemoveButton: 'Entfernen',
        EmailwerkTemplateAddVariableButton: 'Variable hinzufügen',
        EmailwerkTemplateDeleteButton: 'Löschen',
        EmailwerkTemplateCancelButton: 'Abbrechen',
        EmailwerkTemplateSaveButton: 'Speichern',
        EmailwerkEmailPageTitle: 'E-Mail',
        EmailwerkEmailBreadcrumbsEmail: 'E-Mail',
        EmailwerkEmailValidationTemplateRequired: 'Template ist erforderlich',
        EmailwerkEmailValidationSubjectRequired: 'Betreff ist erforderlich',
        EmailwerkEmailValidationMessageRequired: 'Nachricht ist erforderlich',
        EmailwerkEmailValidationToRequired: 'Empfänger ist erforderlich',
        EmailwerkEmailValidationInvalidEmail: 'Ungültige E-Mail-Adresse(n)',
        EmailwerkEmailValidationInvalidBccEmail:
          'Ungültige BCC-E-Mail-Adresse(n)',
        EmailwerkEmailValidationConsentRequired: 'Zustimmung ist erforderlich.',
        EmailwerkEmailTemplatesNotFound: 'Keine Templates gefunden',
        EmailwerkEmailTemplatesFetchGraphqlError:
          'Templates konnten aufgrund eines GraphQL-Fehlers nicht geladen werden.',
        EmailwerkEmailTemplatesFetchUnknownError:
          'Beim Laden der Templates ist ein unbekannter Fehler aufgetreten.',
        EmailwerkEmailTemplatesFetchErrorTitle:
          'Fehler beim Laden der Templates',
        EmailwerkEmailTemplatesFetchErrorDescription:
          'Beim Laden der Templates ist ein Fehler aufgetreten.',
        EmailwerkEmailMessagePlaceholder: 'Gib hier deine Nachricht ein',
        EmailwerkEmailPreviewNoContent: 'Kein Inhalt vorhanden',
        EmailwerkEmailNoTemplateSelectedError: 'Kein Template ausgewählt.',
        EmailwerkEmailSendFailedTitle: 'E-Mail-Versand fehlgeschlagen',
        EmailwerkEmailSentTitle: 'E-Mail gesendet',
        EmailwerkEmailSentDescription: 'Die E-Mail wurde erfolgreich gesendet.',
        EmailwerkEmailSubmissionErrorTitle: 'Fehler beim Absenden',
        EmailwerkEmailUnexpectedError:
          'Ein unerwarteter Fehler ist aufgetreten.',
        EmailwerkEmailFormHeading: 'E-Mail senden',
        EmailwerkEmailPreviewButton: 'Vorschau',
        EmailwerkEmailTemplateLabel: 'E-Mail-Template',
        EmailwerkEmailTemplatesLoading: 'Templates werden geladen...',
        EmailwerkEmailErrorAlertTitle: 'Fehler',
        EmailwerkEmailNoTemplatesAlertTitle: 'Keine Templates gefunden',
        EmailwerkEmailNoTemplatesAlertDescription:
          'Es sind keine E-Mail-Templates vorhanden. Bitte erstelle zuerst eines.',
        EmailwerkEmailTemplateSelectPlaceholder: 'E-Mail-Template auswählen',
        EmailwerkEmailUnnamedTemplate: 'Unbenanntes Template',
        EmailwerkEmailTemplateHelperText: 'Das Template für die E-Mail.',
        EmailwerkEmailToLabel: 'An',
        EmailwerkEmailToPlaceholder: 'jane.doe@snek.at',
        EmailwerkEmailToHelperText:
          'Die Empfänger der E-Mail. Mehrere Empfänger durch Komma trennen.',
        EmailwerkEmailSubjectLabel: 'Betreff',
        EmailwerkEmailSubjectPlaceholder: 'Hallo',
        EmailwerkEmailSubjectHelperText: 'Der Betreff der E-Mail.',
        EmailwerkEmailMessageLabel: 'Nachricht',
        EmailwerkEmailEditorBold: 'Fett',
        EmailwerkEmailEditorItalic: 'Kursiv',
        EmailwerkEmailEditorUnderline: 'Unterstrichen',
        EmailwerkEmailEditorHeading1: 'Überschrift 1',
        EmailwerkEmailEditorHeading2: 'Überschrift 2',
        EmailwerkEmailEditorHeading3: 'Überschrift 3',
        EmailwerkEmailEditorBulletList: 'Aufzählung',
        EmailwerkEmailEditorOrderedList: 'Nummerierte Liste',
        EmailwerkEmailEditorQuote: 'Zitat',
        EmailwerkEmailEditorSetLink: 'Link setzen',
        EmailwerkEmailEditorUnsetLink: 'Link entfernen',
        EmailwerkEmailEditorLinkPrompt: 'URL eingeben',
        EmailwerkEmailMessageHelperText: 'Die Nachricht der E-Mail.',
        EmailwerkEmailBccLabel: 'BCC',
        EmailwerkEmailBccPlaceholder: 'john.doe@snek.at',
        EmailwerkEmailBccHelperText:
          'Zusätzliche verdeckte Empfänger der E-Mail. Mehrere Empfänger durch Komma trennen.',
        EmailwerkEmailConsentLabel:
          'Mit dem Aktivieren dieses Kästchens bestätigst du, dass mit Klick auf „Senden“ eine E-Mail verschickt wird.',
        EmailwerkEmailSendButton: 'Senden',
        EmailwerkEmailPreviewTitle: 'E-Mail-Vorschau',
        EmailwerkEmailPreviewNoTemplate: 'Kein Template ausgewählt',
        EmailwerkEmailPreviewNoSubject: 'Kein Betreff',
        EmailwerkEmailPreviewCloseButton: 'Schließen',
        EmailwerkSenderModalSubmitError:
          'Beim Absenden des Formulars ist ein Fehler aufgetreten.',
        EmailwerkSenderModalUnknownError:
          'Ein unbekannter Fehler ist aufgetreten.',
        EmailwerkSenderModalActionFailed: 'Absender-Aktion fehlgeschlagen.',
        EmailwerkSenderModalOpenButton: 'Absender verwalten',
        EmailwerkSenderModalTitle: 'Absender',
        EmailwerkSenderModalErrorAlertTitle: 'Fehler',
        EmailwerkSenderModalColumnAddress: 'Adresse',
        EmailwerkSenderModalColumnTransport: 'Transport',
        EmailwerkSenderModalBadgeDefault: 'Standard',
        EmailwerkSenderModalBadgeDisabled: 'Deaktiviert',
        EmailwerkSenderModalMakeDefaultButton: 'Als Standard festlegen',
        EmailwerkSenderModalVerifyButton: 'Verifizieren',
        EmailwerkSenderModalDeleteButton: 'Löschen',
        EmailwerkSenderModalEmpty: 'Noch keine Absender konfiguriert.',
        EmailwerkSenderModalAddHeading: 'SMTP-Absender hinzufügen',
        EmailwerkSenderModalValidationAddressRequired:
          'Adresse ist erforderlich',
        EmailwerkSenderModalAddressLabel: 'E-Mail-Adresse',
        EmailwerkSenderModalAddressPlaceholder: 'noreply@example.com',
        EmailwerkSenderModalDisplayNameLabel: 'Anzeigename',
        EmailwerkSenderModalValidationHostRequired:
          'SMTP-Host ist erforderlich',
        EmailwerkSenderModalHostLabel: 'SMTP-Host',
        EmailwerkSenderModalValidationPortRequired:
          'SMTP-Port ist erforderlich',
        EmailwerkSenderModalPortLabel: 'SMTP-Port',
        EmailwerkSenderModalSecureLabel: 'Sichere Verbindung',
        EmailwerkSenderModalValidationUsernameRequired:
          'SMTP-Benutzername ist erforderlich',
        EmailwerkSenderModalUsernameLabel: 'SMTP-Benutzername',
        EmailwerkSenderModalValidationPasswordRequired:
          'SMTP-Passwort ist erforderlich',
        EmailwerkSenderModalPasswordLabel: 'SMTP-Passwort',
        EmailwerkSenderModalIsDefaultLabel: 'Als Standardabsender festlegen',
        EmailwerkSenderModalCreateButton: 'Absender erstellen',
        EmailwerkSenderModalCloseButton: 'Schließen'
      }
    }
  }

  if (code === 'tr-TR') {
    return {
      code,
      strings: {
        Language: 'Türkçe',

        AuthLogin: 'Giriş Yap',
        AuthSignup: 'Kaydol',
        AuthLogout: 'Çıkış Yap',
        AuthSettings: 'Ayarlar',

        CmsLabelsRoot: 'CMS',

        CmsDashboardTitle: 'Jaen CMS',
        CmsDashboardMenuLabel: 'Kontrol Paneli',
        CmsDashboardMenuGroupLabel: 'Jaen CMS',

        CmsFrameStartEditing: 'Düzenlemeyi başlat',
        CmsFrameStopEditing: 'Düzenlemeyi durdur',
        CmsFrameSaveDraft: 'Taslağı kaydet',
        CmsFrameImportDraft: 'Taslağı içe aktar',
        CmsFrameDiscardChanges: 'Değişiklikleri at',
        CmsFrameDiscardAll: 'Vazgeç',
        CmsFrameDiscardAllTitle: 'Yayınlanmamış tüm değişiklikleri at',
        CmsFrameDiscardAllConfirm:
          '{pages, plural, one {# sayfadaki} other {# sayfadaki}} {fields, plural, one {# yayınlanmamış değişiklik} other {# yayınlanmamış değişiklik}} herkes için geri alınacak{who}{when}. Site son yayınlanan haline döner.',
        CmsFrameDiscardAllConfirmWho: ', yazan: {editors}',
        CmsFrameDiscardAllConfirmWhen: ', {since} tarihinden beri',
        CmsFrameDiscardAllConfirmText: 'Hepsini at',
        CmsFrameDiscardAllCancelText: 'Düzenlemeye devam et',
        CmsFrameDiscardNothing: 'Taslakta yayınlanandan farklı bir şey yok.',
        CmsFrameDiscardedTitle: 'Yayınlanmamış değişiklikler atıldı',
        CmsFrameDiscardedDescription:
          '{who}, {at} saatinde bu sitenin yayınlanmamış tüm değişikliklerini attı. Gördüğünüz, yayınlanmış içeriktir.',
        CmsFrameDiscardedByAnAdmin: 'Bir yönetici',
        CmsFrameSaveStateSaving: 'Kaydediliyor',
        CmsFrameSaveStateSaved: '{at} kaydedildi',
        CmsFrameSaveStateSavedUnpublished: '{at} kaydedildi, yayınlanmadı',
        CmsFramePublished: 'Her şey yayınlandı',
        CmsFrameSaveStateOffline: 'Çevrimdışı, {count} değişiklik bekliyor',
        CmsFrameSaveStateError: 'Kaydetme başarısız, yeniden deneniyor',
        CmsFrameSaveStatePending: 'Henüz kaydedilmedi',
        CmsFramePublish:
          '{isPublishing, select, true {Yayımlanıyor} other {Değişiklikleri yayımla}}',
        CmsFrameNewMedia: 'Yeni medya',
        CmsFrameGuest: 'Misafir',
        CmsFrameNotificationsEditModeTitle: 'Düzenleme modu',
        CmsFrameNotificationsEditModeOn: 'Sayfayı artık düzenleyebilirsiniz',
        CmsFrameNotificationsEditModeOff: 'Sayfayı artık düzenleyemezsiniz',
        CmsFrameNotificationsSaved: 'Kaydedildi',
        CmsFrameNotificationsSavedDescription: 'Değişiklikleriniz kaydedildi',
        CmsFrameNotificationsImported: 'İçe aktarıldı',
        CmsFrameNotificationsImportedDescription:
          'Değişiklikleriniz içe aktarıldı',
        CmsFrameNotificationsImportFailed: 'İçe aktarma başarısız',
        CmsFrameNotificationsImportFailedDescription:
          'Değişiklikleriniz içe aktarılamadı',
        CmsFrameNotificationsDiscarded: 'Atıldı',
        CmsFrameNotificationsDiscardedDescription: 'Değişiklikleriniz atıldı',

        CmsPagesTitle: 'Jaen CMS | Sayfalar',
        CmsPagesMenuLabel: 'Sayfalar',

        CmsPagesBreadcrumbsPages: 'Sayfalar',
        CmsPagesBreadcrumbsNew: 'Yeni',

        CmsPagesNotificationsCreated: 'Sayfa oluşturuldu',
        CmsPagesNotificationsCreatedDescription:
          '“{title}” sayfası oluşturuldu',
        CmsPagesNotificationsUpdated: 'Sayfa güncellendi',
        CmsPagesNotificationsUpdatedDescription:
          '“{title}” sayfası güncellendi',
        CmsPagesNotificationsDeleted: 'Sayfa silindi',
        CmsPagesNotificationsDeletedDescription: '{slug} sayfası silindi',
        CmsPagesNotificationsDuplicated: 'Sayfa kopyalandı',
        CmsPagesNotificationsDuplicatedDescription: '{slug} sayfası kopyalandı',
        CmsPagesNotificationsMoved: 'Sayfa taşındı',
        CmsPagesNotificationsMovedDescription: '{slug} sayfası taşındı',
        CmsPagesNotificationsSlugUpdated: 'Slug güncellendi',
        CmsPagesNotificationsSlugUpdatedDescription:
          'Slug {slug} olarak güncellendi',
        CmsPagesNotificationsDuplicateFailed: 'Sayfa kopyalanamadı',
        CmsPagesNotificationsMoveFailed: 'Sayfa taşınamadı',
        CmsPagesNotificationsSlugUpdateFailed: 'Slug güncellenemedi',

        CmsPagesActionsDuplicate: 'Sayfayı kopyala',
        CmsPagesActionsMove: 'Sayfayı taşı',
        CmsPagesActionsUpdateSlug: 'Slugu güncelle',
        CmsPagesActionsRenameSlug: 'Slugu yeniden adlandır',
        CmsPagesActionsDelete: 'Sayfayı sil',
        CmsPagesActionsDeleteThis: 'Bu sayfayı sil',

        CmsPagesDescriptionsDuplicate:
          'Bu işlem sayfayı ve alt sayfalarını kopyalar.',
        CmsPagesDescriptionsMove:
          'Bu işlem sayfayı ve tüm alt sayfalarını taşır.',
        CmsPagesDescriptionsUpdateSlug:
          'Bu işlem slugu değiştirir ve sayfanın ve tüm alt sayfalarının yolunu etkiler.',
        CmsPagesDescriptionsDelete:
          'Bu işlem sayfayı ve tüm alt sayfalarını siler.',

        CmsPagesPromptsDuplicateTitle: 'Sayfayı kopyala',
        CmsPagesPromptsDuplicateMessage:
          'Kopyalanan sayfa için yeni bir slug girin. Bu işlem yolu etkileyecektir.',
        CmsPagesPromptsDuplicateConfirm: 'Kopyala',
        CmsPagesPromptsDuplicateCancel: 'İptal',
        CmsPagesPromptsDuplicatePlaceholder: '{slug}-kopya',

        CmsPagesPromptsMoveTitle: 'Sayfayı taşı',
        CmsPagesPromptsMoveMessage: 'Lütfen yeni bir üst sayfa seçin.',
        CmsPagesPromptsMoveConfirm: 'Taşı',
        CmsPagesPromptsMoveCancel: 'İptal',

        CmsPagesPromptsRenameSlugTitle: 'Slugu yeniden adlandır',
        CmsPagesPromptsRenameSlugMessage:
          'Lütfen yeni bir slug girin. Bu işlem yolu etkileyecektir.',
        CmsPagesPromptsRenameSlugConfirm: 'Yeniden adlandır',
        CmsPagesPromptsRenameSlugCancel: 'İptal',

        CmsPagesPromptsDeleteTitle: 'Sayfayı sil',
        CmsPagesPromptsDeleteMessage:
          'Bu sayfayı ve tüm alt sayfalarını silmek istediğinizden emin misiniz?',
        CmsPagesPromptsDeleteConfirm: 'Sil',

        CmsPagesTableSubpagesHeading: 'Alt sayfalar',
        CmsPagesTableReorderEnable: 'Yeniden sırala',
        CmsPagesTableReorderDisable: 'Bitti',
        CmsPagesTableNewPage: 'Yeni sayfa',
        CmsPagesTableColumnsTitle: 'Başlık',
        CmsPagesTableColumnsDescription: 'Açıklama',
        CmsPagesTableColumnsDate: 'Tarih',
        CmsPagesTableEmptyStateDescription:
          'Bu sayfanın henüz alt sayfası yok.',
        CmsPagesTableEmptyStateAction: 'Yeni bir sayfa oluştur',
        CmsPagesTableDateCreated:
          '{date} tarihinde {time} saatinde oluşturuldu',
        CmsPagesTableDateUpdated:
          'Son güncelleme {date} tarihinde {time} saatinde',
        CmsPagesTableDateEmpty: '-',
        CmsPagesTableReorderError:
          'Sayfalar yeniden sıralanırken bir sorun oluştu.',
        CmsPagesTableDangerZoneHeading: 'Tehlike bölgesi',

        CmsPagesLabelsNoTitle: 'Başlıksız',
        CmsPagesLabelsNoDescription: 'Açıklama yok',
        CmsPagesLabelsFallbackTitle: 'Sayfa',
        CmsPagesLabelsYes: 'Evet',

        CmsPagesFormHeadingCreate: 'Yeni sayfa oluştur',
        CmsPagesFormHeadingEdit: 'Sayfayı düzenle',
        CmsPagesFormLeadCreate:
          'Bir sayfa, belirli bir URL altında gösterilen alan veya blok düzenidir.',
        CmsPagesFormLeadEdit:
          'Sayfayı düzenleyin. SEO ve sosyal medya görünürlüğünü artırın.',
        CmsPagesFormTemplateCreate: 'Yeni sayfa için bir şablon seçin',
        CmsPagesFormTemplateEdit: 'Sayfanın şablonu',
        CmsPagesFormTemplateHelperTextCreate:
          'Bu şablon, üst sayfaya göre yeni sayfaya uygulanacaktır.',
        CmsPagesFormTemplateHelperTextEdit:
          'Şablonu değiştirmek istiyorsanız yeni bir sayfa oluşturup içeriği aktarın.',
        CmsPagesFormTitleCreate: 'Yeni sayfa için başlık girin',
        CmsPagesFormTitleEdit: 'Sayfanın başlığı',
        CmsPagesFormTitleHelperTextCreate:
          'Yeni sayfanın başlığı. URL slug başlıktan otomatik olarak oluşturulur.',
        CmsPagesFormTitleHelperTextEdit: 'Sayfanın başlığı.',
        CmsPagesFormDescriptionCreate: 'Yeni sayfa için açıklama ekleyin',
        CmsPagesFormDescriptionEdit: 'Sayfanın açıklaması',
        CmsPagesFormDescriptionHelperTextCreate:
          'Açıklama arama motorları ve sosyal medya tarafından kullanılır. 160-165 karakter hedefleyin.',
        CmsPagesFormDescriptionHelperTextEdit:
          'Açıklama arama motorları ve sosyal medya tarafından kullanılır. 160-165 karakter hedefleyin.',
        CmsPagesFormParentPageCreate: 'Bir üst sayfa seçin',
        CmsPagesFormParentPageEdit: 'Sayfanın üst sayfası',
        CmsPagesFormParentHelperTextCreate: 'Bu, yeni sayfanın üst sayfasıdır.',
        CmsPagesFormParentHelperTextEdit:
          'Sayfayı daha uygun bir üst sayfaya taşıyabilirsiniz.',
        CmsPagesFormImageCreate: 'Görsel',
        CmsPagesFormImageEdit: 'Görsel',
        CmsPagesFormImageHelperTextCreate:
          'Sayfaya bir görsel ekleyin. Boş bırakılırsa üst sayfanın veya sitenin görseli kullanılır.',
        CmsPagesFormImageHelperTextEdit:
          'Sayfanın görseli. Boş bırakılırsa üst sayfanın veya sitenin görseli kullanılır.',
        CmsPagesFormPostCreate: 'Yazı olarak işaretle',
        CmsPagesFormPostEdit: 'Yazı',
        CmsPagesFormPostHelperTextCreate:
          'Bu sayfayı yazı olarak işaretleyerek tarih ve yazar alanlarını ekleyin.',
        CmsPagesFormPostHelperTextEdit:
          'Bu sayfayı yazı olarak işaretleyerek tarih ve yazar alanlarını ekleyin.',
        CmsPagesFormPostDateCreate: 'Yeni sayfa için tarih girin',
        CmsPagesFormPostDateEdit: 'Sayfanın yayın tarihi',
        CmsPagesFormPostDateHelperTextCreate:
          'Tarih, yazı sıralamasında kullanılacaktır.',
        CmsPagesFormPostDateHelperTextEdit:
          'Tarih, yazı sıralamasında kullanılacaktır.',
        CmsPagesFormPostAuthorCreate: 'Yeni sayfa için yazar girin',
        CmsPagesFormPostAuthorEdit: 'Sayfanın yazarı',
        CmsPagesFormPostAuthorHelperTextCreate:
          'Yazı için yazar olarak gösterilecektir.',
        CmsPagesFormPostAuthorHelperTextEdit:
          'Yazı için yazar olarak gösterilecektir.',
        CmsPagesFormPostCategoryCreate: 'Yeni sayfa için kategori girin',
        CmsPagesFormPostCategoryEdit: 'Sayfanın kategorisi',
        CmsPagesFormPostCategoryHelperTextCreate:
          'Kategori, yazıları sınıflandırmak için kullanılır.',
        CmsPagesFormPostCategoryHelperTextEdit:
          'Kategori, yazıları sınıflandırmak için kullanılır.',
        CmsPagesFormExcludeFromIndexCreate: 'Dizinden çıkar',
        CmsPagesFormExcludeFromIndexEdit: 'Dizinden çıkar',
        CmsPagesFormExcludeFromIndexHelperTextCreate:
          'Bu sayfayı tüm dizin alanlarından hariç tut (ör. sayfaların listelendiği yerler).',
        CmsPagesFormExcludeFromIndexHelperTextEdit:
          'Bu sayfayı tüm dizin alanlarından hariç tut (ör. sayfaların listelendiği yerler).',
        CmsPagesFormPlaceholdersTitle: 'Başlık',
        CmsPagesFormPlaceholdersSlug: 'slug',
        CmsPagesFormPlaceholdersDescription: 'Açıklama',
        CmsPagesFormPlaceholdersAuthor: 'Yazar',
        CmsPagesFormPlaceholdersCategory: 'Kategori',
        CmsPagesFormHelperMediaDescription:
          'Kuruluşu temsil edecek bir görsel yükleyin.',
        CmsPagesFormErrorsSlugInUse: 'Slug zaten kullanılıyor',
        CmsPagesFormErrorsParentRequired: 'Üst sayfa gerekli',
        CmsPagesFormErrorsTemplateRequired: 'Şablon gerekli',
        CmsPagesFormErrorsDateRequired: 'Yazılar için tarih gereklidir',
        CmsPagesFormErrorsAuthorRequired: 'Yazılar için yazar gereklidir',
        CmsPagesFormButtonsPreview: 'Önizleme',
        CmsPagesFormButtonsEdit: 'Sayfayı düzenle',
        CmsPagesFormButtonsCancel: 'İptal',
        CmsPagesFormButtonsCreate: 'Sayfa oluştur',
        CmsPagesFormButtonsSave: 'Sayfayı kaydet',

        CmsMediaTitle: 'Jaen CMS | Medya',
        CmsMediaMenuLabel: 'Medya',
        CmsMediaBreadcrumbsMedia: 'Medya',

        CmsSettingsTitle: 'Jaen CMS | Ayarlar',
        CmsSettingsMenuLabel: 'Ayarlar',
        CmsSettingsBreadcrumbsSettings: 'Ayarlar',
        CmsSettingsNotificationsUpdated: 'Ayarlar güncellendi',
        CmsSettingsFormHeading: 'Ayarlar',
        CmsSettingsFormSiteInfoGroupTitle: 'Site Bilgileri',
        CmsSettingsFormSiteInfoTitleLabel: 'Başlık',
        CmsSettingsFormSiteInfoTitlePlaceholder: 'Başlık',
        CmsSettingsFormSiteInfoTitleTooLong: 'Başlık çok uzun',
        CmsSettingsFormSiteInfoUrlLabel: 'URL',
        CmsSettingsFormSiteInfoUrlPlaceholder: 'https://snek.at',
        CmsSettingsFormSiteInfoUrlInvalid:
          'URL http:// veya https:// ile başlamalıdır',
        CmsSettingsFormSiteInfoDescriptionLabel: 'Açıklama',
        CmsSettingsFormSiteInfoDescriptionPlaceholder:
          'Arama motorlarında ve sosyal medyada görünen açıklama.',
        CmsSettingsFormSiteInfoDescriptionHelper:
          'Siteniz için kısa bir açıklama.',
        CmsSettingsFormSiteInfoImageLabel: 'Görsel',
        CmsSettingsFormSiteInfoImageDescription:
          'Siteyi temsil edecek bir görsel yükleyin.',
        CmsSettingsFormOrganisationGroupTitle: 'Organizasyon',
        CmsSettingsFormOrganisationNameLabel: 'Ad',
        CmsSettingsFormOrganisationNamePlaceholder: 'Snek',
        CmsSettingsFormOrganisationNameTooLong: 'Ad çok uzun',
        CmsSettingsFormOrganisationUrlLabel: 'URL',
        CmsSettingsFormOrganisationUrlPlaceholder: 'https://snek.at',
        CmsSettingsFormOrganisationUrlInvalid:
          'URL http:// veya https:// ile başlamalıdır',
        CmsSettingsFormOrganisationLogoLabel: 'Görsel',
        CmsSettingsFormOrganisationLogoDescription:
          'Organizasyonu temsil edecek bir görsel yükleyin.',
        CmsSettingsFormCancel: 'İptal',
        CmsSettingsFormSave: 'Kaydet',

        CmsDebugTitle: 'Jaen CMS | Hata Ayıklama',
        CmsDebugBreadcrumbsDebug: 'Hata Ayıklama',

        CmsNotificationTitle: 'Jaen CMS | Bildirim',
        CmsNotificationMenuLabel: 'Bildirim',
        CmsNotificationBreadcrumbsPopup: 'Bildirim',
        CmsNotificationCardTitle: 'Bildirim Açılır Penceresi',
        CmsNotificationCardDescription:
          'Bildirim açılır penceresini yapılandırın. Bildirim, kullanıcı sayfayı ziyaret ettiğinde gösterilir.',
        CmsNotificationPreview: 'Önizleme',
        CmsNotificationNotificationsUpdated: 'Bildirim güncellendi',
        CmsNotificationNotificationsUpdatedDescription:
          'Bildirim başarıyla güncellendi',
        CmsNotificationFormTitleLabel: 'Başlık',
        CmsNotificationFormTitlePlaceholder: 'Haberler',
        CmsNotificationFormTitleDescription: 'Bildirimin başlığı',
        CmsNotificationFormMessageLabel: 'Mesaj',
        CmsNotificationFormMessageExample: 'Bu bir örnek mesajdır',
        CmsNotificationFormMessageDescription: 'Bildirimin mesajı',
        CmsNotificationFormEnterUrl: "URL'yi girin",
        CmsNotificationFormFromLabel: 'Başlangıç',
        CmsNotificationFormFromDescription:
          'Bildirim bu tarihten <b>sonra</b> gösterilir',
        CmsNotificationFormToLabel: 'Bitiş',
        CmsNotificationFormToDescription:
          'Bildirim bu tarihe <b>kadar</b> gösterilir',
        CmsNotificationFormPickDate: 'Bir tarih seçin',
        CmsNotificationFormEnabledLabel:
          'Kullanıcı sayfayı ziyaret ettiğinde bildirim açılır penceresini göster',
        CmsNotificationFormSubmit: 'Gönder',

        // Accounts
        CmsAccountsErrorsLoadService:
          'Kullanıcılar kimlik servisinden yüklenemedi.',
        CmsAccountsErrorsLoadGeneric: 'Kullanıcılar yüklenemedi.',
        CmsAccountsNotificationsCreated: 'Hesap oluşturuldu',
        CmsAccountsNotificationsCreatedDescription:
          '{username} hesabı oluşturuldu',
        CmsAccountsNotificationsCreateFailed: 'Hesap oluşturulamadı',
        CmsAccountsTitle: 'Hesaplar',
        CmsAccountsPageTitle: 'Jaen CMS | Hesaplar',
        CmsAccountsMenuLabel: 'Hesaplar',
        CmsAccountsBreadcrumbsAccounts: 'Hesaplar',
        CmsAccountsSubtitle:
          'Kimlik kiracınızdaki kullanıcı hesaplarına göz atın ve bunları yönetin.',
        CmsAccountsActionsCreate: 'Yeni hesap',
        CmsAccountsSearchPlaceholder:
          'Ada, e-postaya veya giriş adına göre ara',
        CmsAccountsErrorsLoadTitle: 'Hesaplar yüklenemedi',
        CmsAccountsCardUnnamed: 'Adsız kullanıcı',
        CmsAccountsCardNoEmail: 'E-posta belirtilmemiş',
        CmsAccountsCardUsername: 'Kullanıcı adı',
        CmsAccountsCardLoginNames: 'Giriş adları',
        CmsAccountsCardNoLoginNames: 'Alternatif giriş adı yok',
        CmsAccountsCardManage: 'Hesabı yönet',
        CmsAccountsEmptyTitle: 'Aramanızla eşleşen hesap yok',
        CmsAccountsEmptyHint:
          'Arama terimini değiştirin veya yeni bir hesap oluşturun.',
        CmsAccountsCreateTitle: 'Yeni hesap oluştur',
        CmsAccountsCreateUsername: 'Kullanıcı adı',
        CmsAccountsCreateEmail: 'E-posta',
        CmsAccountsCreateFirstName: 'Ad',
        CmsAccountsCreateLastName: 'Soyad',
        CmsAccountsCreateInitialPassword: 'Başlangıç parolası (isteğe bağlı)',
        CmsAccountsCreateSendReset:
          'Parola belirlenmediğinde parola sıfırlama e-postası gönder',
        CmsAccountsActionsCancel: 'İptal',
        CmsAccountsActionsCreateSubmit: 'Hesap oluştur',
        CmsAccountsErrorsDetailService:
          'Kullanıcı profili kimlik servisinden yüklenemedi.',
        CmsAccountsErrorsDetailGeneric: 'Kullanıcı profili yüklenemedi.',
        CmsAccountsNotificationsActionFailed: 'İşlem başarısız',
        CmsAccountsNotificationsSaved: 'Değişiklikler kaydedildi',
        CmsAccountsNotificationsSavedDescription: 'Profil güncellendi.',
        CmsAccountsNotificationsSaveFailed: 'Kaydetme başarısız',
        CmsAccountsNotificationsDeleted: 'Hesap silindi',
        CmsAccountsNotificationsPasswordSet: 'Parola belirlendi',
        CmsAccountsNotificationsRolesUpdated: 'Roller güncellendi',
        CmsAccountsDetailBack: 'Hesaplara geri dön',
        CmsAccountsErrorsDetailTitle: 'Bu hesap yüklenemedi',
        CmsAccountsDetailNoEmail: 'Birincil e-posta belirtilmemiş',
        CmsAccountsDetailUsername: 'Kullanıcı adı',
        CmsAccountsDetailPreferredLogin: 'Tercih edilen giriş adı',
        CmsAccountsDetailState: 'Hesap durumu',
        CmsAccountsDetailCreated: 'Oluşturulma',
        CmsAccountsDetailLastChange: 'Son değişiklik',
        CmsAccountsDetailResourceOwner: 'Kuruluş',
        CmsAccountsProfileTitle: 'Profil',
        CmsAccountsProfileDisplayName: 'Görünen ad',
        CmsAccountsProfileLanguage: 'Tercih edilen dil',
        CmsAccountsProfileFirstName: 'Ad',
        CmsAccountsProfileLastName: 'Soyad',
        CmsAccountsProfileEmail: 'E-posta',
        CmsAccountsProfilePhone: 'Telefon',
        CmsAccountsProfileReset: 'Sıfırla',
        CmsAccountsProfileSave: 'Değişiklikleri kaydet',
        CmsAccountsRolesTitle: 'Proje rolleri',
        CmsAccountsRolesGrant: 'Rol ata',
        CmsAccountsRolesEdit: 'Düzenle',
        CmsAccountsNotificationsRolesRevoked: 'Roller kaldırıldı',
        CmsAccountsRolesRevoke: 'Kaldır',
        CmsAccountsRolesEmpty: 'Atanmış proje rolü yok.',
        CmsAccountsActionsTitle: 'Hesap işlemleri',
        CmsAccountsActionsSetPassword: 'Parola belirle',
        CmsAccountsNotificationsResetRequested: 'Parola sıfırlama talep edildi',
        CmsAccountsActionsRequestReset: 'Parola sıfırlama talep et',
        CmsAccountsNotificationsVerificationSent:
          'Doğrulama e-postası gönderildi',
        CmsAccountsActionsResendVerification:
          'E-posta doğrulamasını yeniden gönder',
        CmsAccountsNotificationsDeactivated: 'Hesap devre dışı bırakıldı',
        CmsAccountsActionsDeactivate: 'Devre dışı bırak',
        CmsAccountsNotificationsReactivated: 'Hesap yeniden etkinleştirildi',
        CmsAccountsActionsReactivate: 'Yeniden etkinleştir',
        CmsAccountsNotificationsUnlocked: 'Hesabın kilidi açıldı',
        CmsAccountsActionsUnlock: 'Kilidi aç',
        CmsAccountsNotificationsLocked: 'Hesap kilitlendi',
        CmsAccountsActionsLock: 'Kilitle',
        CmsAccountsActionsDelete: 'Hesabı sil',
        CmsAccountsDeleteTitle: 'Hesabı sil',
        CmsAccountsDeletePrompt:
          '{username} hesabını silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
        CmsAccountsPasswordTitle: 'Yeni parola belirle',
        CmsAccountsPasswordNew: 'Yeni parola',
        CmsAccountsPasswordChangeRequired:
          'Bir sonraki girişte değiştirilmesini zorunlu kıl',
        CmsAccountsRolesEditTitle: 'Atanmış rolleri düzenle',
        CmsAccountsRolesGrantTitle: 'Proje rolleri ata',
        CmsAccountsRolesProject: 'Proje',
        CmsAccountsRolesNoneAvailable: 'Bu proje için kullanılabilir rol yok.',
        CmsAccountsRolesSave: 'Rolleri kaydet',
        SettingsTabGeneral: 'Genel',
        SettingsTabPasswordSecurity: 'Parola ve Güvenlik',
        SettingsProfileGenderUnspecified: 'Belirtilmemiş',
        SettingsProfileGenderMale: 'Erkek',
        SettingsProfileGenderFemale: 'Kadın',
        SettingsProfileGenderOther: 'Diğer',
        SettingsUsernamePromptTitle: 'Kullanıcı adını değiştir',
        SettingsUsernamePromptMessage: 'Lütfen yeni kullanıcı adınızı girin',
        SettingsEmailPromptTitle: 'E-postayı değiştir',
        SettingsEmailPromptMessage: 'Lütfen yeni e-posta adresinizi girin',
        SettingsPhonePromptTitle: 'Telefon numarasını değiştir',
        SettingsPhonePromptMessage: 'Lütfen yeni telefon numaranızı girin',
        SettingsPhoneDeleteConfirmTitle: 'Telefon numarasını sil',
        SettingsPhoneDeleteConfirmMessage:
          'Telefon numaranızı silmek istediğinizden emin misiniz?',
        SettingsPhoneVerifyPromptTitle: 'Telefon numarasını doğrula',
        SettingsPhoneVerifyPromptMessage: 'Lütfen doğrulama kodunu girin',
        SettingsProfileTitle: 'Profil',
        SettingsProfileAvatarNoFileSelected: 'Dosya seçilmedi',
        SettingsProfileUsernameLabel: 'Kullanıcı adı',
        SettingsProfileUsernameEditAriaLabel: 'Kullanıcı adını düzenle',
        SettingsProfileFirstNameLabel: 'Ad',
        SettingsProfileLastNameLabel: 'Soyad',
        SettingsProfileNicknameLabel: 'Takma ad',
        SettingsProfileFullNameLabel: 'Ad Soyad',
        SettingsProfileGenderLabel: 'Cinsiyet',
        SettingsProfileLanguageLabel: 'Dil',
        SettingsProfileLanguageNotSet: 'Ayarlanmadı',
        SettingsSaveButton: 'Kaydet',
        SettingsContactTitle: 'İletişim Bilgileri',
        SettingsContactRefreshAriaLabel: 'Yenile',
        SettingsContactDescription:
          'Verilen bilgiler, parola sıfırlama e-postaları gibi önemli bilgileri size göndermek için kullanılır.',
        SettingsContactEmailLabel: 'E-posta',
        SettingsContactEmailEditAriaLabel: 'E-postayı düzenle',
        SettingsContactVerified: 'Doğrulandı',
        SettingsContactNotVerified: 'Doğrulanmadı',
        SettingsContactResendCodeButton: 'Kodu yeniden gönder',
        SettingsContactPhoneLabel: 'Telefon numarası',
        SettingsContactPhoneDeleteAriaLabel: 'Telefon numarasını sil',
        SettingsContactPhoneEditAriaLabel: 'Telefon numarasını düzenle',
        SettingsContactVerifyButton: 'Doğrula',
        SettingsContactPhoneAddAriaLabel: 'Telefon numarası ekle',
        SettingsContactPhoneNone: 'Telefon numarası belirtilmemiş',
        SettingsPasswordTitle: 'Parola',
        SettingsPasswordPolicyIntro:
          'Yeni parolayı aşağıdaki kurallara göre girin.',
        SettingsPasswordCurrentLabel: 'Mevcut parola',
        SettingsPasswordCurrentPlaceholder: 'Yeni parola',
        SettingsPasswordPolicyMinLength:
          'En az {minLength} karakter uzunluğunda olmalıdır. ({length} / {minLength})',
        SettingsPasswordPolicySymbol:
          'Bir sembol veya noktalama işareti içermelidir.',
        SettingsPasswordPolicyNumber: 'Bir rakam içermelidir.',
        SettingsPasswordPolicyUppercase: 'Bir büyük harf içermelidir.',
        SettingsPasswordPolicyLowercase: 'Bir küçük harf içermelidir.',
        SettingsPasswordPolicyMatch: 'Parolalar eşleşiyor.',
        SettingsPasswordNewLabel: 'Yeni parola',
        SettingsPasswordNewPlaceholder: 'Yeni parola',
        SettingsPasswordConfirmLabel: 'Parolayı onayla',
        SettingsPasswordConfirmPlaceholder: 'Parolayı onayla',
        SettingsPasswordResetButton: 'Mevcut parolayı sıfırla',
        SettingsPasswordCancelButton: 'İptal',
        SettingsPasswordHint:
          'Güçlü bir parola hesabın korunmasına yardımcı olur',
        SettingsPasswordEditAriaLabel: 'E-postayı düzenle',
        ProfileFormTitle: 'Hesap',
        ProfileFormFirstNameLabel: 'Ad',
        ProfileFormLastNameLabel: 'Soyad',
        ProfileFormUsernameLabel: 'Kullanıcı adı',
        ProfileFormRequiredError: 'Bu alan zorunludur',
        ProfileFormImageLabel: 'Görsel',
        ProfileFormImageDescription:
          'Hesabınızın daha kolay tanınması için bir profil fotoğrafı yükleyin.',
        ProfileFormUpdateButton: 'Hesabı güncelle',
        EmailFormTitle: 'E-postalar',
        EmailFormPrimaryLabel: 'Birincil',
        EmailFormDeleteAriaLabel: 'E-posta adresini sil',
        EmailFormPrimaryHelpText:
          'Birincil e-posta adresleri hesapla ilgili iletişim için (ör. parola sıfırlama) kullanılır.',
        EmailFormUnverifiedLabel: 'Doğrulanmamış',
        EmailFormResendVerificationLink: 'Doğrulama e-postasını yeniden gönder',
        EmailFormAddDescription: 'Hesabınıza bir e-posta adresi ekleyin.',
        EmailFormRequiredError: 'Bu alan zorunludur',
        EmailFormInvalidEmailError: 'Geçersiz e-posta adresi',
        EmailFormEmailPlaceholder: 'E-posta',
        EmailFormAddingLoadingText: 'Ekleniyor...',
        EmailFormAddButton: 'Ekle',
        PasswordFormTitle: 'Parola',
        PasswordFormPasswordLabel: 'Parola',
        PasswordFormRequiredError: 'Bu alan zorunludur',
        PasswordFormConfirmPasswordLabel: 'Parolayı onayla',
        PasswordFormMismatchError: 'Parolalar eşleşmiyor',
        PasswordFormHelpText:
          'Parolanızın en az 15 karakter VEYA bir rakam ve bir küçük harf içeren en az 8 karakter uzunluğunda olduğundan emin olun.',
        PasswordFormUpdateButton: 'Parolayı güncelle',
        PasswordResetTryAnotherEmailButton: 'Başka bir e-posta dene',
        PasswordResetBackToWebsiteButton: 'Web sitesine dön',
        PasswordResetEmailHeading: 'Parolanızı sıfırlayın',
        PasswordResetPasswordHeading: 'Yeni parolanızı girin',
        PasswordResetOtpHeading: 'Kodunuzu girin',
        PasswordResetNoAccountPrompt: 'Hesabınız yok mu?',
        PasswordResetSignUpLink: 'Kaydol',
        PasswordResetPasswordDescription:
          '<b>{email}</b> için yeni bir parola girin.',
        PasswordResetOtpDescription:
          '<strong>{email}</strong> adresine tek kullanımlık bir parola (OTP) gönderildi.',
        PasswordResetStepPasswordPasswordLabel: 'Parola',
        PasswordResetStepPasswordConfirmPasswordLabel: 'Parolayı onayla',
        PasswordResetStepPasswordRequiredError: 'Bu alan zorunludur',
        PasswordResetStepPasswordMismatchError: 'Parolalar eşleşmiyor',
        PasswordResetStepPasswordSubmitButton:
          'Parola sıfırlama e-postası gönder',
        SignupSuccessTitle: 'Kayıt başarılı.',
        SignupSuccessDescription:
          'Doğrulama bağlantısı için lütfen e-postanızı kontrol edin.',
        SignupErrorTitle: 'Kayıt yapılamadı.',
        SignupBackToWebsiteButton: 'Web sitesine dön',
        SignupHeading: 'Hesabınızı oluşturun',
        SignupAlreadyUserPrompt: 'Zaten hesabınız var mı?',
        SignupLoginLink: 'Giriş yap',
        SignupFirstNameLabel: 'Ad',
        SignupFirstNameRequiredError: 'Ad zorunludur',
        SignupLastNameLabel: 'Soyad',
        SignupLastNameRequiredError: 'Soyad zorunludur',
        SignupEmailLabel: 'E-posta',
        SignupEmailRequiredError: 'E-posta zorunludur',
        SignupUsernameLabel: 'Kullanıcı adı',
        SignupSubmitButton: 'Kaydol',
        PasswordFieldLabel: 'Parola',
        PasswordFieldMaskAriaLabel: 'Parolayı gizle',
        PasswordFieldRevealAriaLabel: 'Parolayı göster',
        PasswordFieldRequiredError: 'Parola zorunludur',
        MediaCloseSidebarAriaLabel: 'kenar çubuğunu kapat',
        MediaPagesHeading: 'Sayfalar',
        DialogCloseLabel: 'Kapat',
        CmsDebugVersionInformationHeading: 'Sürüm Bilgileri',
        CmsDebugVersionInformationDescription:
          'Aşağıda projenizde kurulu Gatsby, Jaen ve eklenti sürümleri hakkında bilgi bulabilirsiniz.',
        CmsDebugGatsbyTitle: 'Gatsby',
        CmsDebugGatsbyDescription:
          'Gatsby, modern web uygulamaları oluşturmak için kullanılan popüler bir statik site oluşturucudur. Aşağıda projenizde kurulu Gatsby ve Gatsby CLI sürümleri hakkında bilgi bulabilirsiniz.',
        CmsDebugGatsbyVersionLabel: 'Gatsby sürümü:',
        CmsDebugGatsbyCliVersionLabel: 'Gatsby CLI sürümü:',
        CmsDebugJaenTitle: 'Jaen',
        CmsDebugJaenDescription:
          'Jaen, web sitenizin içeriğini yönetmek için kullanılan başsız (headless) bir içerik yönetim sistemidir (CMS). Aşağıda projenizde kurulu Jaen sürümü hakkında bilgi bulabilirsiniz.',
        CmsDebugJaenVersionLabel: 'Jaen sürümü:',
        CmsDebugPluginsTitle: 'Eklentiler',
        CmsDebugPluginsDescription:
          'Eklentiler web sitenizin işlevselliğini genişletir. Aşağıda kurulu eklentilerin ve sürümlerinin listesini bulabilirsiniz.',
        CmsDebugWidgetsHeading: "Widget'lar",
        CmsDebugWidgetsDescription:
          "Aşağıda widget'ların ve verilerinin listesini bulabilirsiniz. Bu bir önizleme özelliğidir ve gelecekte geliştirilecektir.",
        CmsDebugWidgetsColumnName: 'Ad',
        CmsDebugWidgetsColumnCreatedAt: 'Oluşturulma',
        CmsDebugWidgetsColumnModifiedAt: 'Değiştirilme',
        CmsDebugWidgetsColumnData: 'Veri',
        DynamicPageNotFound: 'Sayfa bulunamadı',
        DynamicPageLoading: 'Yükleniyor...',
        FormMediaChooser: 'FormMediaChooser',
        JaenFrameMediaModal: 'JaenFrameMediaModal',
        MediaModal: 'MediaModal',
        EmailwerkTemplatesPageTitle: 'Şablonlar',
        EmailwerkBreadcrumbsRoot: 'Emailwerk',
        EmailwerkBreadcrumbsTemplates: 'Şablonlar',
        EmailwerkMenuGroupLabel: 'Emailwerk',
        EmailwerkTemplatesLoadFailedTitle: 'Şablonlar yüklenemedi ({name})',
        EmailwerkTemplatesAddPromptTitle: 'Şablon ekle',
        EmailwerkTemplatesAddPromptMessage:
          'Lütfen yeni şablon için bir açıklama girin',
        EmailwerkTemplatesCreateFailedTitle: 'Şablon oluşturulamadı',
        EmailwerkTemplatesHeading: 'E-posta Şablonları',
        EmailwerkTemplatesDefaultSender:
          'Varsayılan gönderen: <strong>{address}</strong>',
        EmailwerkTemplatesNoSenderConfigured: 'Gönderen yapılandırılmadı',
        EmailwerkTemplatesSenderVerifiedTitle: 'Gönderen doğrulandı',
        EmailwerkTemplatesSenderVerificationFailedTitle: 'Doğrulama başarısız',
        EmailwerkTemplatesAddButton: 'Şablon ekle',
        EmailwerkTemplatesTableDescription: 'Açıklama',
        EmailwerkTemplatesTableSubject: 'Konu',
        EmailwerkTemplatesTableTo: 'Alıcı',
        EmailwerkTemplatesTableReplyTo: 'Yanıt adresi',
        EmailwerkTemplatesTableUpdatedAt: 'Güncellenme',
        EmailwerkTemplatesTableCreatedAt: 'Oluşturulma',
        EmailwerkTemplatesNoTemplatesFound: 'Şablon bulunamadı',
        EmailwerkTemplateLoadFailedTitle: 'Şablon yüklenemedi ({name})',
        EmailwerkTemplateUpdatedTitle: 'Şablon güncellendi!',
        EmailwerkTemplateUpdatedDescription:
          '{templateId} kimlikli şablon güncellendi',
        EmailwerkTemplateErrorTitle: 'Hata!',
        EmailwerkTemplateUpdateErrorDescription:
          '{templateId} şablonu güncellenirken hata oluştu',
        EmailwerkTemplateDeleteConfirmTitle: 'Şablonu sil',
        EmailwerkTemplateDeleteConfirmMessage:
          'Bu şablonu silmek istediğinizden emin misiniz?',
        EmailwerkTemplateDeleteConfirmButton: 'Sil',
        EmailwerkTemplateDeleteCancelButton: 'İptal',
        EmailwerkTemplateDeletedTitle: 'Şablon silindi!',
        EmailwerkTemplateDeletedDescription:
          '{templateId} kimlikli şablon silindi',
        EmailwerkTemplateDeleteErrorDescription:
          '{templateId} şablonu silinirken hata oluştu',
        EmailwerkTemplateServerPreviewErrorDescription:
          'Sunucu önizlemesi oluşturulurken hata oluştu',
        EmailwerkTemplateCopiedTitle: 'Kopyalandı!',
        EmailwerkTemplateCopiedDescription:
          'Şablon kimliği {templateId} panoya kopyalandı',
        EmailwerkTemplateHeading: 'E-posta Şablonu',
        EmailwerkTemplateIdAddon: 'Şablon kimliği',
        EmailwerkTemplateCopyIdAriaLabel: 'şablon kimliğini kopyala',
        EmailwerkTemplateDescriptionLabel: 'Açıklama',
        EmailwerkTemplateParentLabel: 'Üst şablon',
        EmailwerkTemplateParentPlaceholder: 'Şablon yok',
        EmailwerkTemplateEngineLabel: 'Motor',
        EmailwerkTemplateVerifyReplyToLabel: 'Yanıt adresini doğrula',
        EmailwerkTemplateLinkedLabel: 'Bağlı',
        EmailwerkTemplateNoLinkedTemplates: 'Bağlı şablon yok',
        EmailwerkTemplateEnvelopeHeading: 'Zarf',
        EmailwerkTemplateSubjectLabel: 'Konu',
        EmailwerkTemplateToHeading: 'Alıcı',
        EmailwerkTemplateDeleteToFieldAriaLabel: 'alıcı alanını sil',
        EmailwerkTemplateEmailAddressPlaceholder: 'E-posta adresi girin',
        EmailwerkTemplateAddToButton: 'Alıcı ekle',
        EmailwerkTemplateReplyToLabel: 'Yanıt adresi',
        EmailwerkTemplateContentHeading: 'İçerik',
        EmailwerkTemplatePreviewHeading: 'Önizleme',
        EmailwerkTemplateRenderedPreviewHeading: 'Oluşturulan Önizleme',
        EmailwerkTemplateRenderPreviewButton: 'Önizleme oluştur',
        EmailwerkTemplateVariablesHeading: 'Değişkenler',
        EmailwerkTemplateVariablesTableName: 'Ad',
        EmailwerkTemplateVariablesTableType: 'Tür',
        EmailwerkTemplateVariablesTableDescription: 'Açıklama',
        EmailwerkTemplateVariablesTableDefaultValue: 'Varsayılan değer',
        EmailwerkTemplateVariablesTableRequired: 'Zorunlu',
        EmailwerkTemplateVariablesTableConstant: 'Sabit',
        EmailwerkTemplateVariablesRemoveButton: 'Kaldır',
        EmailwerkTemplateAddVariableButton: 'Değişken ekle',
        EmailwerkTemplateDeleteButton: 'Sil',
        EmailwerkTemplateCancelButton: 'İptal',
        EmailwerkTemplateSaveButton: 'Kaydet',
        EmailwerkEmailPageTitle: 'E-posta',
        EmailwerkEmailBreadcrumbsEmail: 'E-posta',
        EmailwerkEmailValidationTemplateRequired: 'Şablon zorunludur',
        EmailwerkEmailValidationSubjectRequired: 'Konu zorunludur',
        EmailwerkEmailValidationMessageRequired: 'Mesaj zorunludur',
        EmailwerkEmailValidationToRequired: 'Alıcı zorunludur',
        EmailwerkEmailValidationInvalidEmail:
          'Geçersiz e-posta adresi/adresleri',
        EmailwerkEmailValidationInvalidBccEmail:
          'Geçersiz BCC e-posta adresi/adresleri',
        EmailwerkEmailValidationConsentRequired: 'Onay zorunludur.',
        EmailwerkEmailTemplatesNotFound: 'Şablon bulunamadı',
        EmailwerkEmailTemplatesFetchGraphqlError:
          'GraphQL hatası nedeniyle şablonlar alınamadı.',
        EmailwerkEmailTemplatesFetchUnknownError:
          'Şablonlar alınırken bilinmeyen bir hata oluştu.',
        EmailwerkEmailTemplatesFetchErrorTitle:
          'Şablonlar alınırken hata oluştu',
        EmailwerkEmailTemplatesFetchErrorDescription:
          'Şablonlar alınırken bir hata oluştu.',
        EmailwerkEmailMessagePlaceholder: 'Mesajınızı buraya girin',
        EmailwerkEmailPreviewNoContent: 'İçerik yok',
        EmailwerkEmailNoTemplateSelectedError: 'Şablon seçilmedi.',
        EmailwerkEmailSendFailedTitle: 'E-posta gönderilemedi',
        EmailwerkEmailSentTitle: 'E-posta gönderildi',
        EmailwerkEmailSentDescription: 'E-posta başarıyla gönderildi.',
        EmailwerkEmailSubmissionErrorTitle: 'Gönderim hatası',
        EmailwerkEmailUnexpectedError: 'Beklenmeyen bir hata oluştu.',
        EmailwerkEmailFormHeading: 'E-posta Gönder',
        EmailwerkEmailPreviewButton: 'Önizleme',
        EmailwerkEmailTemplateLabel: 'E-posta şablonu',
        EmailwerkEmailTemplatesLoading: 'Şablonlar yükleniyor...',
        EmailwerkEmailErrorAlertTitle: 'Hata!',
        EmailwerkEmailNoTemplatesAlertTitle: 'Şablon bulunamadı!',
        EmailwerkEmailNoTemplatesAlertDescription:
          'Kullanılabilir e-posta şablonu yok. Lütfen önce bir tane oluşturun.',
        EmailwerkEmailTemplateSelectPlaceholder: 'Bir e-posta şablonu seçin',
        EmailwerkEmailUnnamedTemplate: 'Adsız şablon',
        EmailwerkEmailTemplateHelperText: 'E-postanın şablonu.',
        EmailwerkEmailToLabel: 'Alıcı',
        EmailwerkEmailToPlaceholder: 'jane.doe@snek.at',
        EmailwerkEmailToHelperText:
          'E-postanın alıcısı/alıcıları. Birden fazla alıcıyı virgülle ayırarak ekleyin.',
        EmailwerkEmailSubjectLabel: 'Konu',
        EmailwerkEmailSubjectPlaceholder: 'Merhaba',
        EmailwerkEmailSubjectHelperText: 'E-postanın konusu.',
        EmailwerkEmailMessageLabel: 'Mesaj',
        EmailwerkEmailEditorBold: 'Kalın',
        EmailwerkEmailEditorItalic: 'İtalik',
        EmailwerkEmailEditorUnderline: 'Altı çizili',
        EmailwerkEmailEditorHeading1: 'Başlık 1',
        EmailwerkEmailEditorHeading2: 'Başlık 2',
        EmailwerkEmailEditorHeading3: 'Başlık 3',
        EmailwerkEmailEditorBulletList: 'Madde işaretli liste',
        EmailwerkEmailEditorOrderedList: 'Numaralı liste',
        EmailwerkEmailEditorQuote: 'Alıntı',
        EmailwerkEmailEditorSetLink: 'Bağlantı ekle',
        EmailwerkEmailEditorUnsetLink: 'Bağlantıyı kaldır',
        EmailwerkEmailEditorLinkPrompt: "URL'yi girin",
        EmailwerkEmailMessageHelperText: 'E-postanın mesajı.',
        EmailwerkEmailBccLabel: 'BCC',
        EmailwerkEmailBccPlaceholder: 'john.doe@snek.at',
        EmailwerkEmailBccHelperText:
          'E-postanın ek gizli alıcısı/alıcıları. Birden fazla alıcıyı virgülle ayırarak ekleyin.',
        EmailwerkEmailConsentLabel:
          'Bu kutuyu işaretleyerek "Gönder" düğmesine tıklandığında bir e-posta gönderileceğini kabul edersiniz.',
        EmailwerkEmailSendButton: 'Gönder',
        EmailwerkEmailPreviewTitle: 'E-posta Önizlemesi',
        EmailwerkEmailPreviewNoTemplate: 'Şablon seçilmedi',
        EmailwerkEmailPreviewNoSubject: 'Konu yok',
        EmailwerkEmailPreviewCloseButton: 'Kapat',
        EmailwerkSenderModalSubmitError: 'Form gönderilirken bir hata oluştu.',
        EmailwerkSenderModalUnknownError: 'Bilinmeyen bir hata oluştu.',
        EmailwerkSenderModalActionFailed: 'Gönderen işlemi başarısız oldu.',
        EmailwerkSenderModalOpenButton: 'Gönderenleri yönet',
        EmailwerkSenderModalTitle: 'Gönderenler',
        EmailwerkSenderModalErrorAlertTitle: 'Hata!',
        EmailwerkSenderModalColumnAddress: 'Adres',
        EmailwerkSenderModalColumnTransport: 'Aktarım',
        EmailwerkSenderModalBadgeDefault: 'varsayılan',
        EmailwerkSenderModalBadgeDisabled: 'devre dışı',
        EmailwerkSenderModalMakeDefaultButton: 'Varsayılan yap',
        EmailwerkSenderModalVerifyButton: 'Doğrula',
        EmailwerkSenderModalDeleteButton: 'Sil',
        EmailwerkSenderModalEmpty: 'Henüz gönderen yapılandırılmadı.',
        EmailwerkSenderModalAddHeading: 'SMTP göndereni ekle',
        EmailwerkSenderModalValidationAddressRequired: 'Adres zorunludur',
        EmailwerkSenderModalAddressLabel: 'E-posta adresi',
        EmailwerkSenderModalAddressPlaceholder: 'noreply@example.com',
        EmailwerkSenderModalDisplayNameLabel: 'Görünen ad',
        EmailwerkSenderModalValidationHostRequired: 'SMTP sunucusu zorunludur',
        EmailwerkSenderModalHostLabel: 'SMTP sunucusu',
        EmailwerkSenderModalValidationPortRequired: 'SMTP portu zorunludur',
        EmailwerkSenderModalPortLabel: 'SMTP portu',
        EmailwerkSenderModalSecureLabel: 'Güvenli',
        EmailwerkSenderModalValidationUsernameRequired:
          'SMTP kullanıcı adı zorunludur',
        EmailwerkSenderModalUsernameLabel: 'SMTP kullanıcı adı',
        EmailwerkSenderModalValidationPasswordRequired:
          'SMTP parolası zorunludur',
        EmailwerkSenderModalPasswordLabel: 'SMTP parolası',
        EmailwerkSenderModalIsDefaultLabel: 'Varsayılan gönderen olarak ayarla',
        EmailwerkSenderModalCreateButton: 'Gönderen oluştur',
        EmailwerkSenderModalCloseButton: 'Kapat'
      }
    }
  }

  if (code === 'ar-EG') {
    return {
      code,
      strings: {
        Language: 'العربية',

        AuthLogin: 'تسجيل الدخول',
        AuthSignup: 'إنشاء حساب',
        AuthLogout: 'تسجيل الخروج',
        AuthSettings: 'الإعدادات',

        CmsLabelsRoot: 'نظام إدارة المحتوى',

        CmsDashboardTitle: 'Jaen CMS',
        CmsDashboardMenuLabel: 'لوحة التحكم',
        CmsDashboardMenuGroupLabel: 'Jaen CMS',

        CmsFrameStartEditing: 'بدء التحرير',
        CmsFrameStopEditing: 'إيقاف التحرير',
        CmsFrameSaveDraft: 'حفظ المسودة',
        CmsFrameImportDraft: 'استيراد المسودة',
        CmsFrameDiscardChanges: 'تجاهل التغييرات',
        CmsFrameDiscardAll: 'تجاهل',
        CmsFrameDiscardAllTitle: 'تجاهل كل التغييرات غير المنشورة',
        CmsFrameDiscardAllConfirm:
          'سيتم التراجع للجميع عن {fields, plural, other {# تغييرًا غير منشور}} في {pages, plural, other {# صفحة}}{who}{when}. سيعود الموقع إلى آخر نشر.',
        CmsFrameDiscardAllConfirmWho: '، بقلم {editors}',
        CmsFrameDiscardAllConfirmWhen: '، منذ {since}',
        CmsFrameDiscardAllConfirmText: 'تجاهل الكل',
        CmsFrameDiscardAllCancelText: 'متابعة التحرير',
        CmsFrameDiscardNothing: 'لا يوجد في المسودة ما يختلف عن المنشور.',
        CmsFrameDiscardedTitle: 'تم تجاهل التغييرات غير المنشورة',
        CmsFrameDiscardedDescription:
          'قام {who} بتجاهل كل التغييرات غير المنشورة لهذا الموقع في {at}. ما تراه هو المحتوى المنشور.',
        CmsFrameDiscardedByAnAdmin: 'أحد المسؤولين',
        CmsFrameSaveStateSaving: 'جارٍ الحفظ',
        CmsFrameSaveStateSaved: 'تم الحفظ {at}',
        CmsFrameSaveStateSavedUnpublished: 'تم الحفظ {at}، لم يُنشر',
        CmsFramePublished: 'كل شيء منشور',
        CmsFrameSaveStateOffline: 'غير متصل، بانتظار الإرسال: {count}',
        CmsFrameSaveStateError: 'فشل الحفظ، تتم إعادة المحاولة',
        CmsFrameSaveStatePending: 'لم يتم الحفظ بعد',
        CmsFramePublish:
          '{isPublishing, select, true {جارٍ النشر} other {نشر التغييرات}}',
        CmsFrameNewMedia: 'وسائط جديدة',
        CmsFrameGuest: 'ضيف',
        CmsFrameNotificationsEditModeTitle: 'وضع التحرير',
        CmsFrameNotificationsEditModeOn: 'يمكنك الآن تحرير الصفحة',
        CmsFrameNotificationsEditModeOff: 'لم يعد بإمكانك تحرير الصفحة',
        CmsFrameNotificationsSaved: 'تم الحفظ',
        CmsFrameNotificationsSavedDescription: 'تم حفظ تغييراتك',
        CmsFrameNotificationsImported: 'تم الاستيراد',
        CmsFrameNotificationsImportedDescription: 'تم استيراد تغييراتك',
        CmsFrameNotificationsImportFailed: 'تعذّر الاستيراد',
        CmsFrameNotificationsImportFailedDescription: 'تعذّر استيراد تغييراتك',
        CmsFrameNotificationsDiscarded: 'تم التجاهل',
        CmsFrameNotificationsDiscardedDescription: 'تم تجاهل تغييراتك',

        CmsPagesTitle: 'Jaen CMS | الصفحات',
        CmsPagesMenuLabel: 'الصفحات',

        CmsPagesBreadcrumbsPages: 'الصفحات',
        CmsPagesBreadcrumbsNew: 'جديد',

        CmsPagesNotificationsCreated: 'تم إنشاء الصفحة',
        CmsPagesNotificationsCreatedDescription: 'تم إنشاء الصفحة {title}',
        CmsPagesNotificationsUpdated: 'تم تحديث الصفحة',
        CmsPagesNotificationsUpdatedDescription: 'تم تحديث الصفحة {title}',
        CmsPagesNotificationsDeleted: 'تم حذف الصفحة',
        CmsPagesNotificationsDeletedDescription: 'تم حذف الصفحة {slug}',
        CmsPagesNotificationsDuplicated: 'تم استنساخ الصفحة',
        CmsPagesNotificationsDuplicatedDescription: 'تم استنساخ الصفحة {slug}',
        CmsPagesNotificationsMoved: 'تم نقل الصفحة',
        CmsPagesNotificationsMovedDescription: 'تم نقل الصفحة {slug}',
        CmsPagesNotificationsSlugUpdated: 'تم تحديث الرابط',
        CmsPagesNotificationsSlugUpdatedDescription:
          'تم تحديث الرابط إلى {slug}',
        CmsPagesNotificationsDuplicateFailed: 'تعذّر استنساخ الصفحة',
        CmsPagesNotificationsMoveFailed: 'تعذّر نقل الصفحة',
        CmsPagesNotificationsSlugUpdateFailed: 'تعذّر تحديث الرابط',

        CmsPagesActionsDuplicate: 'استنساخ الصفحة',
        CmsPagesActionsMove: 'نقل الصفحة',
        CmsPagesActionsUpdateSlug: 'تحديث الرابط',
        CmsPagesActionsRenameSlug: 'إعادة تسمية الرابط',
        CmsPagesActionsDelete: 'حذف الصفحة',
        CmsPagesActionsDeleteThis: 'حذف هذه الصفحة',

        CmsPagesDescriptionsDuplicate:
          'سيؤدي ذلك إلى استنساخ الصفحة وجميع صفحاتها الفرعية.',
        CmsPagesDescriptionsMove:
          'سيؤدي ذلك إلى نقل الصفحة وجميع صفحاتها الفرعية.',
        CmsPagesDescriptionsUpdateSlug:
          'سيؤدي ذلك إلى إعادة تسمية الرابط وبالتالي يؤثر على مسار الصفحة وجميع صفحاتها الفرعية.',
        CmsPagesDescriptionsDelete:
          'سيؤدي ذلك إلى حذف الصفحة وجميع صفحاتها الفرعية.',

        CmsPagesPromptsDuplicateTitle: 'استنساخ الصفحة',
        CmsPagesPromptsDuplicateMessage:
          'يرجى إدخال رابط جديد للصفحة المستنسخة. سيؤثر ذلك على المسار.',
        CmsPagesPromptsDuplicateConfirm: 'استنساخ',
        CmsPagesPromptsDuplicateCancel: 'إلغاء',
        CmsPagesPromptsDuplicatePlaceholder: '{slug}-نسخة',

        CmsPagesPromptsMoveTitle: 'نقل الصفحة',
        CmsPagesPromptsMoveMessage: 'يرجى اختيار صفحة رئيسية جديدة.',
        CmsPagesPromptsMoveConfirm: 'نقل',
        CmsPagesPromptsMoveCancel: 'إلغاء',

        CmsPagesPromptsRenameSlugTitle: 'إعادة تسمية الرابط',
        CmsPagesPromptsRenameSlugMessage:
          'يرجى إدخال رابط جديد. سيؤثر ذلك على المسار.',
        CmsPagesPromptsRenameSlugConfirm: 'إعادة تسمية',
        CmsPagesPromptsRenameSlugCancel: 'إلغاء',

        CmsPagesPromptsDeleteTitle: 'حذف الصفحة',
        CmsPagesPromptsDeleteMessage:
          'هل أنت متأكد أنك تريد حذف هذه الصفحة وجميع صفحاتها الفرعية؟',
        CmsPagesPromptsDeleteConfirm: 'حذف',

        CmsPagesTableSubpagesHeading: 'الصفحات الفرعية',
        CmsPagesTableReorderEnable: 'إعادة الترتيب',
        CmsPagesTableReorderDisable: 'تم',
        CmsPagesTableNewPage: 'صفحة جديدة',
        CmsPagesTableColumnsTitle: 'العنوان',
        CmsPagesTableColumnsDescription: 'الوصف',
        CmsPagesTableColumnsDate: 'التاريخ',
        CmsPagesTableEmptyStateDescription:
          'لا تحتوي هذه الصفحة على أي صفحات فرعية بعد.',
        CmsPagesTableEmptyStateAction: 'أنشئ صفحة جديدة',
        CmsPagesTableDateCreated: 'تم الإنشاء في {date} الساعة {time}',
        CmsPagesTableDateUpdated: 'آخر تعديل في {date} الساعة {time}',
        CmsPagesTableDateEmpty: '-',
        CmsPagesTableReorderError: 'حدث خطأ أثناء إعادة ترتيب الصفحات.',
        CmsPagesTableDangerZoneHeading: 'منطقة الخطر',

        CmsPagesLabelsNoTitle: 'بدون عنوان',
        CmsPagesLabelsNoDescription: 'بدون وصف',
        CmsPagesLabelsFallbackTitle: 'صفحة',
        CmsPagesLabelsYes: 'نعم',

        CmsPagesFormHeadingCreate: 'إنشاء صفحة جديدة',
        CmsPagesFormHeadingEdit: 'تحرير الصفحة',
        CmsPagesFormLeadCreate:
          'تمثل الصفحة ترتيباً من الحقول أو الكتل يتم عرضه على عنوان URL محدد.',
        CmsPagesFormLeadEdit:
          'حرر الصفحة. عزّز تحسين محركات البحث والحضور على وسائل التواصل الاجتماعي.',
        CmsPagesFormTemplateCreate: 'اختر قالباً للصفحة الجديدة',
        CmsPagesFormTemplateEdit: 'القالب المستخدم للصفحة',
        CmsPagesFormTemplateHelperTextCreate:
          'سيتم تطبيق هذا القالب على الصفحة الجديدة بناءً على الصفحة الرئيسية.',
        CmsPagesFormTemplateHelperTextEdit:
          'إذا أردت تعديل القالب، أنشئ صفحة جديدة وانقل المحتوى.',
        CmsPagesFormTitleCreate: 'أدخل عنواناً للصفحة الجديدة',
        CmsPagesFormTitleEdit: 'عنوان الصفحة',
        CmsPagesFormTitleHelperTextCreate:
          'عنوان الصفحة الجديدة. سيتم إنشاء الرابط تلقائياً من العنوان.',
        CmsPagesFormTitleHelperTextEdit: 'عنوان الصفحة.',
        CmsPagesFormDescriptionCreate: 'قدّم وصفاً للصفحة الجديدة',
        CmsPagesFormDescriptionEdit: 'وصف الصفحة',
        CmsPagesFormDescriptionHelperTextCreate:
          'يُستخدم الوصف لمحركات البحث ووسائل التواصل الاجتماعي. استهدف 160-165 حرفاً.',
        CmsPagesFormDescriptionHelperTextEdit:
          'يُستخدم الوصف لمحركات البحث ووسائل التواصل الاجتماعي. استهدف 160-165 حرفاً.',
        CmsPagesFormParentPageCreate: 'اختر صفحة رئيسية',
        CmsPagesFormParentPageEdit: 'الصفحة الرئيسية لهذه الصفحة',
        CmsPagesFormParentHelperTextCreate:
          'تُعد هذه الصفحة الرئيسية للصفحة الجديدة.',
        CmsPagesFormParentHelperTextEdit:
          'يمكنك نقل الصفحة إلى صفحة رئيسية أكثر ملاءمة.',
        CmsPagesFormImageCreate: 'صورة',
        CmsPagesFormImageEdit: 'صورة',
        CmsPagesFormImageHelperTextCreate:
          'أضف صورة إلى الصفحة. إذا تُركت فارغة فسيتم استخدام صورة الصفحة الرئيسية أو الموقع.',
        CmsPagesFormImageHelperTextEdit:
          'صورة الصفحة. إذا تُركت فارغة فسيتم استخدام صورة الصفحة الرئيسية أو الموقع.',
        CmsPagesFormPostCreate: 'اعتبارها مقالة',
        CmsPagesFormPostEdit: 'مقالة',
        CmsPagesFormPostHelperTextCreate:
          'عيّن هذه الصفحة كمقالة لإضافة حقلي التاريخ والمؤلف.',
        CmsPagesFormPostHelperTextEdit:
          'عيّن هذه الصفحة كمقالة لإضافة حقلي التاريخ والمؤلف.',
        CmsPagesFormPostDateCreate: 'أدخل تاريخاً للصفحة الجديدة',
        CmsPagesFormPostDateEdit: 'تاريخ نشر الصفحة',
        CmsPagesFormPostDateHelperTextCreate: 'سيُستخدم التاريخ لفرز المقالات.',
        CmsPagesFormPostDateHelperTextEdit: 'سيُستخدم التاريخ لفرز المقالات.',
        CmsPagesFormPostAuthorCreate: 'أدخل مؤلف الصفحة الجديدة',
        CmsPagesFormPostAuthorEdit: 'مؤلف الصفحة',
        CmsPagesFormPostAuthorHelperTextCreate: 'سيظهر كمؤلف للمقالة.',
        CmsPagesFormPostAuthorHelperTextEdit: 'سيظهر كمؤلف للمقالة.',
        CmsPagesFormPostCategoryCreate: 'أدخل تصنيفاً للصفحة الجديدة',
        CmsPagesFormPostCategoryEdit: 'تصنيف الصفحة',
        CmsPagesFormPostCategoryHelperTextCreate:
          'يُستخدم التصنيف لتنظيم المقالات.',
        CmsPagesFormPostCategoryHelperTextEdit:
          'يُستخدم التصنيف لتنظيم المقالات.',
        CmsPagesFormExcludeFromIndexCreate: 'استبعاد من الفهرس',
        CmsPagesFormExcludeFromIndexEdit: 'استبعاد من الفهرس',
        CmsPagesFormExcludeFromIndexHelperTextCreate:
          'استبعد هذه الصفحة من جميع قوائم الفهرس (مثل الأماكن التي تُعرض فيها الصفحات).',
        CmsPagesFormExcludeFromIndexHelperTextEdit:
          'استبعد هذه الصفحة من جميع قوائم الفهرس (مثل الأماكن التي تُعرض فيها الصفحات).',
        CmsPagesFormPlaceholdersTitle: 'العنوان',
        CmsPagesFormPlaceholdersSlug: 'slug',
        CmsPagesFormPlaceholdersDescription: 'الوصف',
        CmsPagesFormPlaceholdersAuthor: 'المؤلف',
        CmsPagesFormPlaceholdersCategory: 'التصنيف',
        CmsPagesFormHelperMediaDescription: 'حمّل صورة تُمثّل المؤسسة.',
        CmsPagesFormErrorsSlugInUse: 'الرابط مستخدم بالفعل',
        CmsPagesFormErrorsParentRequired: 'الصفحة الرئيسية مطلوبة',
        CmsPagesFormErrorsTemplateRequired: 'القالب مطلوب',
        CmsPagesFormErrorsDateRequired: 'التاريخ مطلوب للمقالات',
        CmsPagesFormErrorsAuthorRequired: 'المؤلف مطلوب للمقالات',
        CmsPagesFormButtonsPreview: 'معاينة',
        CmsPagesFormButtonsEdit: 'تحرير الصفحة',
        CmsPagesFormButtonsCancel: 'إلغاء',
        CmsPagesFormButtonsCreate: 'إنشاء الصفحة',
        CmsPagesFormButtonsSave: 'حفظ الصفحة',

        CmsMediaTitle: 'Jaen CMS | الوسائط',
        CmsMediaMenuLabel: 'الوسائط',
        CmsMediaBreadcrumbsMedia: 'الوسائط',

        CmsSettingsTitle: 'Jaen CMS | الإعدادات',
        CmsSettingsMenuLabel: 'الإعدادات',
        CmsSettingsBreadcrumbsSettings: 'الإعدادات',
        CmsSettingsNotificationsUpdated: 'تم تحديث الإعدادات',
        CmsSettingsFormHeading: 'الإعدادات',
        CmsSettingsFormSiteInfoGroupTitle: 'معلومات الموقع',
        CmsSettingsFormSiteInfoTitleLabel: 'العنوان',
        CmsSettingsFormSiteInfoTitlePlaceholder: 'العنوان',
        CmsSettingsFormSiteInfoTitleTooLong: 'العنوان طويل جدًا',
        CmsSettingsFormSiteInfoUrlLabel: 'الرابط',
        CmsSettingsFormSiteInfoUrlPlaceholder: 'https://snek.at',
        CmsSettingsFormSiteInfoUrlInvalid:
          'يجب أن يبدأ الرابط بـ http:// أو https://',
        CmsSettingsFormSiteInfoDescriptionLabel: 'الوصف',
        CmsSettingsFormSiteInfoDescriptionPlaceholder:
          'الوصف الذي يظهر في محركات البحث ووسائل التواصل الاجتماعي.',
        CmsSettingsFormSiteInfoDescriptionHelper: 'وصف موجز لموقعك.',
        CmsSettingsFormSiteInfoImageLabel: 'صورة',
        CmsSettingsFormSiteInfoImageDescription: 'حمّل صورة لتمثل الموقع.',
        CmsSettingsFormOrganisationGroupTitle: 'المنظمة',
        CmsSettingsFormOrganisationNameLabel: 'الاسم',
        CmsSettingsFormOrganisationNamePlaceholder: 'Snek',
        CmsSettingsFormOrganisationNameTooLong: 'الاسم طويل جدًا',
        CmsSettingsFormOrganisationUrlLabel: 'الرابط',
        CmsSettingsFormOrganisationUrlPlaceholder: 'https://snek.at',
        CmsSettingsFormOrganisationUrlInvalid:
          'يجب أن يبدأ الرابط بـ http:// أو https://',
        CmsSettingsFormOrganisationLogoLabel: 'صورة',
        CmsSettingsFormOrganisationLogoDescription: 'حمّل صورة لتمثل المنظمة.',
        CmsSettingsFormCancel: 'إلغاء',
        CmsSettingsFormSave: 'حفظ',

        CmsDebugTitle: 'Jaen CMS | تتبع الأخطاء',
        CmsDebugBreadcrumbsDebug: 'تتبع الأخطاء',

        CmsNotificationTitle: 'Jaen CMS | الإشعارات',
        CmsNotificationMenuLabel: 'النوافذ المنبثقة',
        CmsNotificationBreadcrumbsPopup: 'الإشعار',
        CmsNotificationCardTitle: 'نافذة الإشعار المنبثقة',
        CmsNotificationCardDescription:
          'قم بإعداد نافذة الإشعار المنبثقة. سيظهر الإشعار عند زيارة المستخدم للصفحة.',
        CmsNotificationPreview: 'معاينة',
        CmsNotificationNotificationsUpdated: 'تم تحديث الإشعار',
        CmsNotificationNotificationsUpdatedDescription: 'لقد تم تحديث الإشعار',
        CmsNotificationFormTitleLabel: 'العنوان',
        CmsNotificationFormTitlePlaceholder: 'أخبار',
        CmsNotificationFormTitleDescription: 'عنوان الإشعار',
        CmsNotificationFormMessageLabel: 'الرسالة',
        CmsNotificationFormMessageExample: 'هذه رسالة توضيحية',
        CmsNotificationFormMessageDescription: 'رسالة الإشعار',
        CmsNotificationFormEnterUrl: 'أدخل الرابط',
        CmsNotificationFormFromLabel: 'من',
        CmsNotificationFormFromDescription:
          'سيظهر الإشعار <b>بعد</b> هذا التاريخ',
        CmsNotificationFormToLabel: 'إلى',
        CmsNotificationFormToDescription:
          'سيظهر الإشعار <b>حتى</b> هذا التاريخ',
        CmsNotificationFormPickDate: 'اختر تاريخاً',
        CmsNotificationFormEnabledLabel:
          'إظهار نافذة الإشعار المنبثقة عند زيارة المستخدم للصفحة',
        CmsNotificationFormSubmit: 'إرسال',

        // Accounts
        CmsAccountsErrorsLoadService: 'تعذّر تحميل المستخدمين من خدمة الهوية.',
        CmsAccountsErrorsLoadGeneric: 'تعذّر تحميل المستخدمين.',
        CmsAccountsNotificationsCreated: 'تم إنشاء الحساب',
        CmsAccountsNotificationsCreatedDescription:
          'تم إنشاء الحساب {username}',
        CmsAccountsNotificationsCreateFailed: 'تعذّر إنشاء الحساب',
        CmsAccountsTitle: 'الحسابات',
        CmsAccountsPageTitle: 'Jaen CMS | الحسابات',
        CmsAccountsMenuLabel: 'الحسابات',
        CmsAccountsBreadcrumbsAccounts: 'الحسابات',
        CmsAccountsSubtitle:
          'تصفح وأدر حسابات المستخدمين في مستأجر الهوية الخاص بك.',
        CmsAccountsActionsCreate: 'حساب جديد',
        CmsAccountsSearchPlaceholder:
          'ابحث بالاسم أو البريد الإلكتروني أو اسم الدخول',
        CmsAccountsErrorsLoadTitle: 'تعذّر تحميل الحسابات',
        CmsAccountsCardUnnamed: 'مستخدم بدون اسم',
        CmsAccountsCardNoEmail: 'لا يوجد بريد إلكتروني',
        CmsAccountsCardUsername: 'اسم المستخدم',
        CmsAccountsCardLoginNames: 'أسماء تسجيل الدخول',
        CmsAccountsCardNoLoginNames: 'لا توجد أسماء دخول بديلة',
        CmsAccountsCardManage: 'إدارة الحساب',
        CmsAccountsEmptyTitle: 'لا توجد حسابات مطابقة لبحثك',
        CmsAccountsEmptyHint: 'عدّل مصطلح البحث أو أنشئ حساباً جديداً.',
        CmsAccountsCreateTitle: 'إنشاء حساب جديد',
        CmsAccountsCreateUsername: 'اسم المستخدم',
        CmsAccountsCreateEmail: 'البريد الإلكتروني',
        CmsAccountsCreateFirstName: 'الاسم الأول',
        CmsAccountsCreateLastName: 'اسم العائلة',
        CmsAccountsCreateInitialPassword: 'كلمة المرور الأولية (اختياري)',
        CmsAccountsCreateSendReset:
          'إرسال بريد إعادة تعيين كلمة المرور عند عدم تعيين كلمة مرور',
        CmsAccountsActionsCancel: 'إلغاء',
        CmsAccountsActionsCreateSubmit: 'إنشاء الحساب',
        CmsAccountsErrorsDetailService:
          'تعذّر تحميل الملف الشخصي للمستخدم من خدمة الهوية.',
        CmsAccountsErrorsDetailGeneric: 'تعذّر تحميل الملف الشخصي للمستخدم.',
        CmsAccountsNotificationsActionFailed: 'فشل الإجراء',
        CmsAccountsNotificationsSaved: 'تم حفظ التغييرات',
        CmsAccountsNotificationsSavedDescription: 'تم تحديث الملف الشخصي.',
        CmsAccountsNotificationsSaveFailed: 'تعذّر الحفظ',
        CmsAccountsNotificationsDeleted: 'تم حذف الحساب',
        CmsAccountsNotificationsPasswordSet: 'تم تعيين كلمة المرور',
        CmsAccountsNotificationsRolesUpdated: 'تم تحديث الأدوار',
        CmsAccountsDetailBack: 'العودة إلى الحسابات',
        CmsAccountsErrorsDetailTitle: 'تعذّر تحميل هذا الحساب',
        CmsAccountsDetailNoEmail: 'لا يوجد بريد إلكتروني أساسي',
        CmsAccountsDetailUsername: 'اسم المستخدم',
        CmsAccountsDetailPreferredLogin: 'اسم الدخول المفضل',
        CmsAccountsDetailState: 'حالة الحساب',
        CmsAccountsDetailCreated: 'تاريخ الإنشاء',
        CmsAccountsDetailLastChange: 'آخر تعديل',
        CmsAccountsDetailResourceOwner: 'المنظمة',
        CmsAccountsProfileTitle: 'الملف الشخصي',
        CmsAccountsProfileDisplayName: 'الاسم المعروض',
        CmsAccountsProfileLanguage: 'اللغة المفضلة',
        CmsAccountsProfileFirstName: 'الاسم الأول',
        CmsAccountsProfileLastName: 'اسم العائلة',
        CmsAccountsProfileEmail: 'البريد الإلكتروني',
        CmsAccountsProfilePhone: 'الهاتف',
        CmsAccountsProfileReset: 'إعادة تعيين',
        CmsAccountsProfileSave: 'حفظ التغييرات',
        CmsAccountsRolesTitle: 'أدوار المشروع',
        CmsAccountsRolesGrant: 'منح أدوار',
        CmsAccountsRolesEdit: 'تحرير',
        CmsAccountsNotificationsRolesRevoked: 'تم سحب الأدوار',
        CmsAccountsRolesRevoke: 'سحب',
        CmsAccountsRolesEmpty: 'لم تُمنح أي أدوار للمشروع.',
        CmsAccountsActionsTitle: 'إجراءات الحساب',
        CmsAccountsActionsSetPassword: 'تعيين كلمة المرور',
        CmsAccountsNotificationsResetRequested:
          'تم طلب إعادة تعيين كلمة المرور',
        CmsAccountsActionsRequestReset: 'طلب إعادة تعيين كلمة المرور',
        CmsAccountsNotificationsVerificationSent: 'تم إرسال بريد التحقق',
        CmsAccountsActionsResendVerification: 'إعادة إرسال بريد التحقق',
        CmsAccountsNotificationsDeactivated: 'تم تعطيل الحساب',
        CmsAccountsActionsDeactivate: 'تعطيل',
        CmsAccountsNotificationsReactivated: 'تمت إعادة تفعيل الحساب',
        CmsAccountsActionsReactivate: 'إعادة تفعيل',
        CmsAccountsNotificationsUnlocked: 'تم فتح قفل الحساب',
        CmsAccountsActionsUnlock: 'فتح القفل',
        CmsAccountsNotificationsLocked: 'تم قفل الحساب',
        CmsAccountsActionsLock: 'قفل',
        CmsAccountsActionsDelete: 'حذف الحساب',
        CmsAccountsDeleteTitle: 'حذف الحساب',
        CmsAccountsDeletePrompt:
          'هل أنت متأكد أنك تريد حذف {username}؟ لا يمكن التراجع عن هذا الإجراء.',
        CmsAccountsPasswordTitle: 'تعيين كلمة مرور جديدة',
        CmsAccountsPasswordNew: 'كلمة المرور الجديدة',
        CmsAccountsPasswordChangeRequired:
          'طلب تغيير كلمة المرور عند تسجيل الدخول التالي',
        CmsAccountsRolesEditTitle: 'تحرير الأدوار الممنوحة',
        CmsAccountsRolesGrantTitle: 'منح أدوار المشروع',
        CmsAccountsRolesProject: 'المشروع',
        CmsAccountsRolesNoneAvailable: 'لا توجد أدوار متاحة لهذا المشروع.',
        CmsAccountsRolesSave: 'حفظ الأدوار',
        SettingsTabGeneral: 'عام',
        SettingsTabPasswordSecurity: 'كلمة المرور والأمان',
        SettingsProfileGenderUnspecified: 'غير محدد',
        SettingsProfileGenderMale: 'ذكر',
        SettingsProfileGenderFemale: 'أنثى',
        SettingsProfileGenderOther: 'آخر',
        SettingsUsernamePromptTitle: 'تغيير اسم المستخدم',
        SettingsUsernamePromptMessage: 'يرجى إدخال اسم المستخدم الجديد',
        SettingsEmailPromptTitle: 'تغيير البريد الإلكتروني',
        SettingsEmailPromptMessage: 'يرجى إدخال بريدك الإلكتروني الجديد',
        SettingsPhonePromptTitle: 'تغيير رقم الهاتف',
        SettingsPhonePromptMessage: 'يرجى إدخال رقم هاتفك الجديد',
        SettingsPhoneDeleteConfirmTitle: 'حذف رقم الهاتف',
        SettingsPhoneDeleteConfirmMessage:
          'هل أنت متأكد أنك تريد حذف رقم هاتفك؟',
        SettingsPhoneVerifyPromptTitle: 'التحقق من رقم الهاتف',
        SettingsPhoneVerifyPromptMessage: 'يرجى إدخال رمز التحقق',
        SettingsProfileTitle: 'الملف الشخصي',
        SettingsProfileAvatarNoFileSelected: 'لم يتم اختيار ملف',
        SettingsProfileUsernameLabel: 'اسم المستخدم',
        SettingsProfileUsernameEditAriaLabel: 'تحرير اسم المستخدم',
        SettingsProfileFirstNameLabel: 'الاسم الأول',
        SettingsProfileLastNameLabel: 'اسم العائلة',
        SettingsProfileNicknameLabel: 'الاسم المستعار',
        SettingsProfileFullNameLabel: 'الاسم الكامل',
        SettingsProfileGenderLabel: 'النوع',
        SettingsProfileLanguageLabel: 'اللغة',
        SettingsProfileLanguageNotSet: 'غير محددة',
        SettingsSaveButton: 'حفظ',
        SettingsContactTitle: 'معلومات الاتصال',
        SettingsContactRefreshAriaLabel: 'تحديث',
        SettingsContactDescription:
          'تُستخدم المعلومات المقدمة لإرسال معلومات مهمة إليك، مثل رسائل إعادة تعيين كلمة المرور.',
        SettingsContactEmailLabel: 'البريد الإلكتروني',
        SettingsContactEmailEditAriaLabel: 'تحرير البريد الإلكتروني',
        SettingsContactVerified: 'تم التحقق',
        SettingsContactNotVerified: 'لم يتم التحقق',
        SettingsContactResendCodeButton: 'إعادة إرسال الرمز',
        SettingsContactPhoneLabel: 'رقم الهاتف',
        SettingsContactPhoneDeleteAriaLabel: 'حذف رقم الهاتف',
        SettingsContactPhoneEditAriaLabel: 'تحرير رقم الهاتف',
        SettingsContactVerifyButton: 'تحقق',
        SettingsContactPhoneAddAriaLabel: 'إضافة رقم هاتف',
        SettingsContactPhoneNone: 'لم يتم إدخال رقم هاتف',
        SettingsPasswordTitle: 'كلمة المرور',
        SettingsPasswordPolicyIntro:
          'أدخل كلمة المرور الجديدة وفقاً للسياسة أدناه.',
        SettingsPasswordCurrentLabel: 'كلمة المرور الحالية',
        SettingsPasswordCurrentPlaceholder: 'كلمة المرور الجديدة',
        SettingsPasswordPolicyMinLength:
          'يجب ألا يقل طولها عن {minLength} من الأحرف. ({length} / {minLength})',
        SettingsPasswordPolicySymbol: 'يجب أن تتضمن رمزاً أو علامة ترقيم.',
        SettingsPasswordPolicyNumber: 'يجب أن تتضمن رقماً.',
        SettingsPasswordPolicyUppercase: 'يجب أن تتضمن حرفاً كبيراً.',
        SettingsPasswordPolicyLowercase: 'يجب أن تتضمن حرفاً صغيراً.',
        SettingsPasswordPolicyMatch: 'كلمتا المرور متطابقتان.',
        SettingsPasswordNewLabel: 'كلمة المرور الجديدة',
        SettingsPasswordNewPlaceholder: 'كلمة المرور الجديدة',
        SettingsPasswordConfirmLabel: 'تأكيد كلمة المرور',
        SettingsPasswordConfirmPlaceholder: 'تأكيد كلمة المرور',
        SettingsPasswordResetButton: 'إعادة تعيين كلمة المرور الحالية',
        SettingsPasswordCancelButton: 'إلغاء',
        SettingsPasswordHint: 'كلمة المرور الآمنة تساعد على حماية الحساب',
        SettingsPasswordEditAriaLabel: 'تحرير البريد الإلكتروني',
        ProfileFormTitle: 'الحساب',
        ProfileFormFirstNameLabel: 'الاسم الأول',
        ProfileFormLastNameLabel: 'اسم العائلة',
        ProfileFormUsernameLabel: 'اسم المستخدم',
        ProfileFormRequiredError: 'هذا الحقل مطلوب',
        ProfileFormImageLabel: 'صورة',
        ProfileFormImageDescription: 'حمّل صورة شخصية لتسهيل التعرف على حسابك.',
        ProfileFormUpdateButton: 'تحديث الحساب',
        EmailFormTitle: 'عناوين البريد الإلكتروني',
        EmailFormPrimaryLabel: 'أساسي',
        EmailFormDeleteAriaLabel: 'حذف عنوان البريد الإلكتروني',
        EmailFormPrimaryHelpText:
          'تُستخدم عناوين البريد الإلكتروني الأساسية للمراسلات المتعلقة بالحساب (مثل إعادة تعيين كلمة المرور).',
        EmailFormUnverifiedLabel: 'لم يتم التحقق',
        EmailFormResendVerificationLink: 'إعادة إرسال بريد التحقق',
        EmailFormAddDescription: 'أضف عنوان بريد إلكتروني إلى حسابك.',
        EmailFormRequiredError: 'هذا الحقل مطلوب',
        EmailFormInvalidEmailError: 'عنوان البريد الإلكتروني غير صالح',
        EmailFormEmailPlaceholder: 'البريد الإلكتروني',
        EmailFormAddingLoadingText: 'جارٍ الإضافة...',
        EmailFormAddButton: 'إضافة',
        PasswordFormTitle: 'كلمة المرور',
        PasswordFormPasswordLabel: 'كلمة المرور',
        PasswordFormRequiredError: 'هذا الحقل مطلوب',
        PasswordFormConfirmPasswordLabel: 'تأكيد كلمة المرور',
        PasswordFormMismatchError: 'كلمتا المرور غير متطابقتين',
        PasswordFormHelpText:
          'تأكد من أن كلمة المرور لا تقل عن 15 حرفاً، أو عن 8 أحرف على الأقل تتضمن رقماً وحرفاً صغيراً.',
        PasswordFormUpdateButton: 'تحديث كلمة المرور',
        PasswordResetTryAnotherEmailButton: 'جرّب بريداً إلكترونياً آخر',
        PasswordResetBackToWebsiteButton: 'العودة إلى الموقع',
        PasswordResetEmailHeading: 'إعادة تعيين كلمة المرور',
        PasswordResetPasswordHeading: 'أدخل كلمة المرور الجديدة',
        PasswordResetOtpHeading: 'أدخل الرمز',
        PasswordResetNoAccountPrompt: 'ليس لديك حساب؟',
        PasswordResetSignUpLink: 'إنشاء حساب',
        PasswordResetPasswordDescription:
          'أدخل كلمة مرور جديدة لـ <b>{email}</b>.',
        PasswordResetOtpDescription:
          'تم إرسال كلمة مرور لمرة واحدة (OTP) إلى <strong>{email}</strong>.',
        PasswordResetStepPasswordPasswordLabel: 'كلمة المرور',
        PasswordResetStepPasswordConfirmPasswordLabel: 'تأكيد كلمة المرور',
        PasswordResetStepPasswordRequiredError: 'هذا الحقل مطلوب',
        PasswordResetStepPasswordMismatchError: 'كلمتا المرور غير متطابقتين',
        PasswordResetStepPasswordSubmitButton:
          'إرسال بريد إعادة تعيين كلمة المرور',
        SignupSuccessTitle: 'تم إنشاء الحساب بنجاح.',
        SignupSuccessDescription:
          'يرجى مراجعة بريدك الإلكتروني للحصول على رابط التحقق.',
        SignupErrorTitle: 'تعذّر إنشاء الحساب.',
        SignupBackToWebsiteButton: 'العودة إلى الموقع',
        SignupHeading: 'أنشئ حسابك',
        SignupAlreadyUserPrompt: 'لديك حساب بالفعل؟',
        SignupLoginLink: 'تسجيل الدخول',
        SignupFirstNameLabel: 'الاسم الأول',
        SignupFirstNameRequiredError: 'الاسم الأول مطلوب',
        SignupLastNameLabel: 'اسم العائلة',
        SignupLastNameRequiredError: 'اسم العائلة مطلوب',
        SignupEmailLabel: 'البريد الإلكتروني',
        SignupEmailRequiredError: 'البريد الإلكتروني مطلوب',
        SignupUsernameLabel: 'اسم المستخدم',
        SignupSubmitButton: 'إنشاء حساب',
        PasswordFieldLabel: 'كلمة المرور',
        PasswordFieldMaskAriaLabel: 'إخفاء كلمة المرور',
        PasswordFieldRevealAriaLabel: 'إظهار كلمة المرور',
        PasswordFieldRequiredError: 'كلمة المرور مطلوبة',
        MediaCloseSidebarAriaLabel: 'إغلاق الشريط الجانبي',
        MediaPagesHeading: 'الصفحات',
        DialogCloseLabel: 'إغلاق',
        CmsDebugVersionInformationHeading: 'معلومات الإصدار',
        CmsDebugVersionInformationDescription:
          'تجد أدناه معلومات عن إصدارات Gatsby وJaen والإضافات المثبتة في مشروعك.',
        CmsDebugGatsbyTitle: 'Gatsby',
        CmsDebugGatsbyDescription:
          'Gatsby مولّد مواقع ثابتة شائع يُستخدم لبناء تطبيقات الويب الحديثة. تجد أدناه معلومات عن إصداري Gatsby وGatsby CLI المثبتين في مشروعك.',
        CmsDebugGatsbyVersionLabel: 'إصدار Gatsby:',
        CmsDebugGatsbyCliVersionLabel: 'إصدار Gatsby CLI:',
        CmsDebugJaenTitle: 'Jaen',
        CmsDebugJaenDescription:
          'Jaen نظام إدارة محتوى بدون واجهة (headless CMS) لإدارة محتوى موقعك. تجد أدناه معلومات عن إصدار Jaen المثبت في مشروعك.',
        CmsDebugJaenVersionLabel: 'إصدار Jaen:',
        CmsDebugPluginsTitle: 'الإضافات',
        CmsDebugPluginsDescription:
          'توسّع الإضافات وظائف موقعك. تجد أدناه قائمة بالإضافات المثبتة وإصداراتها.',
        CmsDebugWidgetsHeading: 'الودجات',
        CmsDebugWidgetsDescription:
          'تجد أدناه قائمة بالودجات وبياناتها. هذه ميزة تجريبية وسيتم تحسينها مستقبلاً.',
        CmsDebugWidgetsColumnName: 'الاسم',
        CmsDebugWidgetsColumnCreatedAt: 'تاريخ الإنشاء',
        CmsDebugWidgetsColumnModifiedAt: 'آخر تعديل',
        CmsDebugWidgetsColumnData: 'البيانات',
        DynamicPageNotFound: 'الصفحة غير موجودة',
        DynamicPageLoading: 'جارٍ التحميل...',
        FormMediaChooser: 'FormMediaChooser',
        JaenFrameMediaModal: 'JaenFrameMediaModal',
        MediaModal: 'MediaModal',
        EmailwerkTemplatesPageTitle: 'القوالب',
        EmailwerkBreadcrumbsRoot: 'Emailwerk',
        EmailwerkBreadcrumbsTemplates: 'القوالب',
        EmailwerkMenuGroupLabel: 'Emailwerk',
        EmailwerkTemplatesLoadFailedTitle: 'تعذّر تحميل القوالب ({name})',
        EmailwerkTemplatesAddPromptTitle: 'إضافة قالب',
        EmailwerkTemplatesAddPromptMessage: 'يرجى إدخال وصف للقالب الجديد',
        EmailwerkTemplatesCreateFailedTitle: 'تعذّر إنشاء القالب',
        EmailwerkTemplatesHeading: 'قوالب البريد الإلكتروني',
        EmailwerkTemplatesDefaultSender:
          'المرسل الافتراضي: <strong>{address}</strong>',
        EmailwerkTemplatesNoSenderConfigured: 'لم يتم إعداد مرسل',
        EmailwerkTemplatesSenderVerifiedTitle: 'تم التحقق من المرسل',
        EmailwerkTemplatesSenderVerificationFailedTitle: 'تعذّر التحقق',
        EmailwerkTemplatesAddButton: 'إضافة قالب',
        EmailwerkTemplatesTableDescription: 'الوصف',
        EmailwerkTemplatesTableSubject: 'الموضوع',
        EmailwerkTemplatesTableTo: 'إلى',
        EmailwerkTemplatesTableReplyTo: 'الرد إلى',
        EmailwerkTemplatesTableUpdatedAt: 'تاريخ التحديث',
        EmailwerkTemplatesTableCreatedAt: 'تاريخ الإنشاء',
        EmailwerkTemplatesNoTemplatesFound: 'لم يتم العثور على قوالب',
        EmailwerkTemplateLoadFailedTitle: 'تعذّر تحميل القالب ({name})',
        EmailwerkTemplateUpdatedTitle: 'تم تحديث القالب',
        EmailwerkTemplateUpdatedDescription: 'تم تحديث القالب {templateId}',
        EmailwerkTemplateErrorTitle: 'خطأ',
        EmailwerkTemplateUpdateErrorDescription:
          'حدث خطأ أثناء تحديث القالب {templateId}',
        EmailwerkTemplateDeleteConfirmTitle: 'حذف القالب',
        EmailwerkTemplateDeleteConfirmMessage:
          'هل أنت متأكد أنك تريد حذف هذا القالب؟',
        EmailwerkTemplateDeleteConfirmButton: 'حذف',
        EmailwerkTemplateDeleteCancelButton: 'إلغاء',
        EmailwerkTemplateDeletedTitle: 'تم حذف القالب',
        EmailwerkTemplateDeletedDescription: 'تم حذف القالب {templateId}',
        EmailwerkTemplateDeleteErrorDescription:
          'حدث خطأ أثناء حذف القالب {templateId}',
        EmailwerkTemplateServerPreviewErrorDescription:
          'حدث خطأ أثناء عرض معاينة الخادم',
        EmailwerkTemplateCopiedTitle: 'تم النسخ',
        EmailwerkTemplateCopiedDescription:
          'تم نسخ معرّف القالب {templateId} إلى الحافظة',
        EmailwerkTemplateHeading: 'قالب البريد الإلكتروني',
        EmailwerkTemplateIdAddon: 'معرّف القالب',
        EmailwerkTemplateCopyIdAriaLabel: 'نسخ معرّف القالب',
        EmailwerkTemplateDescriptionLabel: 'الوصف',
        EmailwerkTemplateParentLabel: 'القالب الأصل',
        EmailwerkTemplateParentPlaceholder: 'بدون قالب',
        EmailwerkTemplateEngineLabel: 'المحرك',
        EmailwerkTemplateVerifyReplyToLabel: 'التحقق من عنوان الرد',
        EmailwerkTemplateLinkedLabel: 'القوالب المرتبطة',
        EmailwerkTemplateNoLinkedTemplates: 'لا توجد قوالب مرتبطة',
        EmailwerkTemplateEnvelopeHeading: 'المغلّف',
        EmailwerkTemplateSubjectLabel: 'الموضوع',
        EmailwerkTemplateToHeading: 'إلى',
        EmailwerkTemplateDeleteToFieldAriaLabel: 'حذف حقل المستلم',
        EmailwerkTemplateEmailAddressPlaceholder:
          'أدخل عنوان البريد الإلكتروني',
        EmailwerkTemplateAddToButton: 'إضافة مستلم',
        EmailwerkTemplateReplyToLabel: 'الرد إلى',
        EmailwerkTemplateContentHeading: 'المحتوى',
        EmailwerkTemplatePreviewHeading: 'معاينة',
        EmailwerkTemplateRenderedPreviewHeading: 'المعاينة المعروضة',
        EmailwerkTemplateRenderPreviewButton: 'عرض المعاينة',
        EmailwerkTemplateVariablesHeading: 'المتغيرات',
        EmailwerkTemplateVariablesTableName: 'الاسم',
        EmailwerkTemplateVariablesTableType: 'النوع',
        EmailwerkTemplateVariablesTableDescription: 'الوصف',
        EmailwerkTemplateVariablesTableDefaultValue: 'القيمة الافتراضية',
        EmailwerkTemplateVariablesTableRequired: 'مطلوب',
        EmailwerkTemplateVariablesTableConstant: 'ثابت',
        EmailwerkTemplateVariablesRemoveButton: 'إزالة',
        EmailwerkTemplateAddVariableButton: 'إضافة متغير',
        EmailwerkTemplateDeleteButton: 'حذف',
        EmailwerkTemplateCancelButton: 'إلغاء',
        EmailwerkTemplateSaveButton: 'حفظ',
        EmailwerkEmailPageTitle: 'البريد الإلكتروني',
        EmailwerkEmailBreadcrumbsEmail: 'البريد الإلكتروني',
        EmailwerkEmailValidationTemplateRequired: 'القالب مطلوب',
        EmailwerkEmailValidationSubjectRequired: 'الموضوع مطلوب',
        EmailwerkEmailValidationMessageRequired: 'الرسالة مطلوبة',
        EmailwerkEmailValidationToRequired: 'المستلم مطلوب',
        EmailwerkEmailValidationInvalidEmail:
          'عنوان البريد الإلكتروني غير صالح',
        EmailwerkEmailValidationInvalidBccEmail: 'عنوان بريد BCC غير صالح',
        EmailwerkEmailValidationConsentRequired: 'الموافقة مطلوبة.',
        EmailwerkEmailTemplatesNotFound: 'لم يتم العثور على قوالب',
        EmailwerkEmailTemplatesFetchGraphqlError:
          'تعذّر جلب القوالب بسبب خطأ في GraphQL.',
        EmailwerkEmailTemplatesFetchUnknownError:
          'حدث خطأ غير معروف أثناء جلب القوالب.',
        EmailwerkEmailTemplatesFetchErrorTitle: 'خطأ في جلب القوالب',
        EmailwerkEmailTemplatesFetchErrorDescription:
          'حدث خطأ أثناء جلب القوالب.',
        EmailwerkEmailMessagePlaceholder: 'أدخل رسالتك هنا',
        EmailwerkEmailPreviewNoContent: 'لا يوجد محتوى متاح',
        EmailwerkEmailNoTemplateSelectedError: 'لم يتم اختيار قالب.',
        EmailwerkEmailSendFailedTitle: 'تعذّر إرسال البريد الإلكتروني',
        EmailwerkEmailSentTitle: 'تم إرسال البريد الإلكتروني',
        EmailwerkEmailSentDescription: 'تم إرسال البريد الإلكتروني بنجاح.',
        EmailwerkEmailSubmissionErrorTitle: 'خطأ في الإرسال',
        EmailwerkEmailUnexpectedError: 'حدث خطأ غير متوقع.',
        EmailwerkEmailFormHeading: 'إرسال بريد إلكتروني',
        EmailwerkEmailPreviewButton: 'معاينة',
        EmailwerkEmailTemplateLabel: 'قالب البريد الإلكتروني',
        EmailwerkEmailTemplatesLoading: 'جارٍ تحميل القوالب...',
        EmailwerkEmailErrorAlertTitle: 'خطأ',
        EmailwerkEmailNoTemplatesAlertTitle: 'لم يتم العثور على قوالب',
        EmailwerkEmailNoTemplatesAlertDescription:
          'لا توجد قوالب بريد إلكتروني متاحة. يرجى إنشاء قالب أولاً.',
        EmailwerkEmailTemplateSelectPlaceholder: 'اختر قالب بريد إلكتروني',
        EmailwerkEmailUnnamedTemplate: 'قالب بدون اسم',
        EmailwerkEmailTemplateHelperText: 'قالب البريد الإلكتروني.',
        EmailwerkEmailToLabel: 'إلى',
        EmailwerkEmailToPlaceholder: 'jane.doe@snek.at',
        EmailwerkEmailToHelperText:
          'مستلمو البريد الإلكتروني. يمكنك إضافة عدة مستلمين مفصولين بفاصلة.',
        EmailwerkEmailSubjectLabel: 'الموضوع',
        EmailwerkEmailSubjectPlaceholder: 'مرحباً',
        EmailwerkEmailSubjectHelperText: 'موضوع البريد الإلكتروني.',
        EmailwerkEmailMessageLabel: 'الرسالة',
        EmailwerkEmailEditorBold: 'غامق',
        EmailwerkEmailEditorItalic: 'مائل',
        EmailwerkEmailEditorUnderline: 'تسطير',
        EmailwerkEmailEditorHeading1: 'عنوان 1',
        EmailwerkEmailEditorHeading2: 'عنوان 2',
        EmailwerkEmailEditorHeading3: 'عنوان 3',
        EmailwerkEmailEditorBulletList: 'قائمة نقطية',
        EmailwerkEmailEditorOrderedList: 'قائمة مرقمة',
        EmailwerkEmailEditorQuote: 'اقتباس',
        EmailwerkEmailEditorSetLink: 'إدراج رابط',
        EmailwerkEmailEditorUnsetLink: 'إزالة الرابط',
        EmailwerkEmailEditorLinkPrompt: 'أدخل الرابط',
        EmailwerkEmailMessageHelperText: 'رسالة البريد الإلكتروني.',
        EmailwerkEmailBccLabel: 'نسخة مخفية (BCC)',
        EmailwerkEmailBccPlaceholder: 'john.doe@snek.at',
        EmailwerkEmailBccHelperText:
          'مستلمون إضافيون مخفيون للبريد الإلكتروني. يمكنك إضافة عدة مستلمين مفصولين بفاصلة.',
        EmailwerkEmailConsentLabel:
          'بتحديد هذا المربع، توافق على أن النقر على زر "إرسال" سيؤدي إلى إرسال بريد إلكتروني.',
        EmailwerkEmailSendButton: 'إرسال',
        EmailwerkEmailPreviewTitle: 'معاينة البريد الإلكتروني',
        EmailwerkEmailPreviewNoTemplate: 'لم يتم اختيار قالب',
        EmailwerkEmailPreviewNoSubject: 'بدون موضوع',
        EmailwerkEmailPreviewCloseButton: 'إغلاق',
        EmailwerkSenderModalSubmitError: 'حدث خطأ أثناء إرسال النموذج.',
        EmailwerkSenderModalUnknownError: 'حدث خطأ غير معروف.',
        EmailwerkSenderModalActionFailed: 'تعذّر تنفيذ إجراء المرسل.',
        EmailwerkSenderModalOpenButton: 'إدارة المرسلين',
        EmailwerkSenderModalTitle: 'المرسلون',
        EmailwerkSenderModalErrorAlertTitle: 'خطأ',
        EmailwerkSenderModalColumnAddress: 'العنوان',
        EmailwerkSenderModalColumnTransport: 'وسيلة النقل',
        EmailwerkSenderModalBadgeDefault: 'افتراضي',
        EmailwerkSenderModalBadgeDisabled: 'معطّل',
        EmailwerkSenderModalMakeDefaultButton: 'تعيين كافتراضي',
        EmailwerkSenderModalVerifyButton: 'تحقق',
        EmailwerkSenderModalDeleteButton: 'حذف',
        EmailwerkSenderModalEmpty: 'لم يتم إعداد أي مرسلين بعد.',
        EmailwerkSenderModalAddHeading: 'إضافة مرسل SMTP',
        EmailwerkSenderModalValidationAddressRequired: 'العنوان مطلوب',
        EmailwerkSenderModalAddressLabel: 'عنوان البريد الإلكتروني',
        EmailwerkSenderModalAddressPlaceholder: 'noreply@example.com',
        EmailwerkSenderModalDisplayNameLabel: 'اسم العرض',
        EmailwerkSenderModalValidationHostRequired: 'مضيف SMTP مطلوب',
        EmailwerkSenderModalHostLabel: 'مضيف SMTP',
        EmailwerkSenderModalValidationPortRequired: 'منفذ SMTP مطلوب',
        EmailwerkSenderModalPortLabel: 'منفذ SMTP',
        EmailwerkSenderModalSecureLabel: 'آمن',
        EmailwerkSenderModalValidationUsernameRequired: 'اسم مستخدم SMTP مطلوب',
        EmailwerkSenderModalUsernameLabel: 'اسم مستخدم SMTP',
        EmailwerkSenderModalValidationPasswordRequired: 'كلمة مرور SMTP مطلوبة',
        EmailwerkSenderModalPasswordLabel: 'كلمة مرور SMTP',
        EmailwerkSenderModalIsDefaultLabel: 'تعيين كمرسل افتراضي',
        EmailwerkSenderModalCreateButton: 'إنشاء مرسل',
        EmailwerkSenderModalCloseButton: 'إغلاق'
      }
    }
  }

  // EN fallback (defaults)
  if (code === 'sl-SI') {
    return {
      code,
      strings: {
        Language: 'Slovenščina',

        AuthLogin: 'Prijava',
        AuthSignup: 'Registracija',
        AuthLogout: 'Odjava',
        AuthSettings: 'Nastavitve',

        CmsLabelsRoot: 'CMS',

        CmsDashboardTitle: 'Jaen CMS',
        CmsDashboardMenuLabel: 'Nadzorna plošča',
        CmsDashboardMenuGroupLabel: 'Jaen CMS',

        CmsFrameStartEditing: 'Začni urejanje',
        CmsFrameStopEditing: 'Končaj urejanje',
        CmsFrameSaveDraft: 'Shrani osnutek',
        CmsFrameImportDraft: 'Uvozi osnutek',
        CmsFrameDiscardChanges: 'Zavrzi spremembe',
        CmsFrameDiscardAll: 'Zavrzi',
        CmsFrameDiscardAllTitle: 'Zavrzi vse neobjavljene spremembe',
        CmsFrameDiscardAllConfirm:
          '{fields, plural, one {# neobjavljena sprememba} other {# neobjavljenih sprememb}} na {pages, plural, one {# strani} other {# straneh}} bo za vse razveljavljenih{who}{when}. Spletno mesto se vrne na zadnjo objavo.',
        CmsFrameDiscardAllConfirmWho: ', avtorji: {editors}',
        CmsFrameDiscardAllConfirmWhen: ', od {since}',
        CmsFrameDiscardAllConfirmText: 'Zavrzi vse',
        CmsFrameDiscardAllCancelText: 'Nadaljuj urejanje',
        CmsFrameDiscardNothing:
          'V osnutku ni ničesar, kar bi se razlikovalo od objavljenega.',
        CmsFrameDiscardedTitle: 'Neobjavljene spremembe zavržene',
        CmsFrameDiscardedDescription:
          '{who} je ob {at} zavrgel vse neobjavljene spremembe tega mesta. Kar vidite, je objavljeno stanje.',
        CmsFrameDiscardedByAnAdmin: 'Skrbnik',
        CmsFrameSaveStateSaving: 'Shranjevanje',
        CmsFrameSaveStateSaved: 'Shranjeno {at}',
        CmsFrameSaveStateSavedUnpublished: 'Shranjeno {at}, ni objavljeno',
        CmsFramePublished: 'Vse je objavljeno',
        CmsFrameSaveStateOffline: 'Brez povezave, čaka sprememb: {count}',
        CmsFrameSaveStateError: 'Shranjevanje ni uspelo, poskušam znova',
        CmsFrameSaveStatePending: 'Še ni shranjeno',
        CmsFramePublish:
          '{isPublishing, select, true {Objavljanje poteka} other {Objavi spremembe}}',
        CmsFrameNewMedia: 'Nova predstavnost',
        CmsFrameGuest: 'Gost',
        CmsFrameNotificationsEditModeTitle: 'Način urejanja',
        CmsFrameNotificationsEditModeOn: 'Zdaj lahko urejate stran',
        CmsFrameNotificationsEditModeOff: 'Strani ne morete več urejati',
        CmsFrameNotificationsSaved: 'Shranjeno',
        CmsFrameNotificationsSavedDescription:
          'Vaše spremembe so bile shranjene',
        CmsFrameNotificationsImported: 'Uvoženo',
        CmsFrameNotificationsImportedDescription:
          'Vaše spremembe so bile uvožene',
        CmsFrameNotificationsImportFailed: 'Uvoz ni uspel',
        CmsFrameNotificationsImportFailedDescription:
          'Vaših sprememb ni bilo mogoče uvoziti',
        CmsFrameNotificationsDiscarded: 'Zavrženo',
        CmsFrameNotificationsDiscardedDescription:
          'Vaše spremembe so bile zavržene',

        CmsPagesTitle: 'Jaen CMS | Strani',
        CmsPagesMenuLabel: 'Strani',

        CmsPagesBreadcrumbsPages: 'Strani',
        CmsPagesBreadcrumbsNew: 'Novo',

        CmsPagesNotificationsCreated: 'Stran ustvarjena',
        CmsPagesNotificationsCreatedDescription:
          'Stran {title} je bila ustvarjena',
        CmsPagesNotificationsUpdated: 'Stran posodobljena',
        CmsPagesNotificationsUpdatedDescription:
          'Stran {title} je bila posodobljena',
        CmsPagesNotificationsDeleted: 'Stran izbrisana',
        CmsPagesNotificationsDeletedDescription:
          'Stran {slug} je bila izbrisana',
        CmsPagesNotificationsDuplicated: 'Stran podvojena',
        CmsPagesNotificationsDuplicatedDescription:
          'Stran {slug} je bila podvojena',
        CmsPagesNotificationsMoved: 'Stran premaknjena',
        CmsPagesNotificationsMovedDescription:
          'Stran {slug} je bila premaknjena',
        CmsPagesNotificationsSlugUpdated: 'Slug posodobljen',
        CmsPagesNotificationsSlugUpdatedDescription:
          'Slug je bil posodobljen v {slug}',
        CmsPagesNotificationsDuplicateFailed: 'Strani ni bilo mogoče podvojiti',
        CmsPagesNotificationsMoveFailed: 'Strani ni bilo mogoče premakniti',
        CmsPagesNotificationsSlugUpdateFailed:
          'Sluga ni bilo mogoče posodobiti',

        CmsPagesActionsDuplicate: 'Podvoji stran',
        CmsPagesActionsMove: 'Premakni stran',
        CmsPagesActionsUpdateSlug: 'Posodobi slug',
        CmsPagesActionsRenameSlug: 'Preimenuj slug',
        CmsPagesActionsDelete: 'Izbriši stran',
        CmsPagesActionsDeleteThis: 'Izbriši to stran',

        CmsPagesDescriptionsDuplicate:
          'S tem boste podvojili stran skupaj z njenimi podstranmi.',
        CmsPagesDescriptionsMove:
          'S tem boste premaknili stran in vse njene podstrani.',
        CmsPagesDescriptionsUpdateSlug:
          'S tem boste preimenovali slug, kar vpliva na pot strani in vseh njenih podstrani.',
        CmsPagesDescriptionsDelete:
          'S tem boste izbrisali stran in vse njene podstrani.',

        CmsPagesPromptsDuplicateTitle: 'Podvoji stran',
        CmsPagesPromptsDuplicateMessage:
          'Vnesite nov slug za podvojeno stran. To bo vplivalo na pot.',
        CmsPagesPromptsDuplicateConfirm: 'Podvoji',
        CmsPagesPromptsDuplicateCancel: 'Prekliči',
        CmsPagesPromptsDuplicatePlaceholder: '{slug}-kopija',

        CmsPagesPromptsMoveTitle: 'Premakni stran',
        CmsPagesPromptsMoveMessage: 'Izberite novo nadrejeno stran.',
        CmsPagesPromptsMoveConfirm: 'Premakni',
        CmsPagesPromptsMoveCancel: 'Prekliči',

        CmsPagesPromptsRenameSlugTitle: 'Preimenuj slug',
        CmsPagesPromptsRenameSlugMessage:
          'Vnesite nov slug. To bo vplivalo na pot.',
        CmsPagesPromptsRenameSlugConfirm: 'Preimenuj',
        CmsPagesPromptsRenameSlugCancel: 'Prekliči',

        CmsPagesPromptsDeleteTitle: 'Izbriši stran',
        CmsPagesPromptsDeleteMessage:
          'Ali ste prepričani, da želite izbrisati to stran in vse njene podstrani?',
        CmsPagesPromptsDeleteConfirm: 'Izbriši',

        CmsPagesTableSubpagesHeading: 'Podstrani',
        CmsPagesTableReorderEnable: 'Prerazporedi',
        CmsPagesTableReorderDisable: 'Končano',
        CmsPagesTableNewPage: 'Nova stran',
        CmsPagesTableColumnsTitle: 'Naslov',
        CmsPagesTableColumnsDescription: 'Opis',
        CmsPagesTableColumnsDate: 'Datum',
        CmsPagesTableEmptyStateDescription: 'Ta stran še nima podstrani.',
        CmsPagesTableEmptyStateAction: 'Ustvari novo stran',
        CmsPagesTableDateCreated: 'Ustvarjeno {date} ob {time}',
        CmsPagesTableDateUpdated: 'Nazadnje spremenjeno {date} ob {time}',
        CmsPagesTableDateEmpty: '-',
        CmsPagesTableReorderError:
          'Pri prerazporejanju strani je prišlo do napake.',
        CmsPagesTableDangerZoneHeading: 'Nevarno območje',

        CmsPagesLabelsNoTitle: 'Brez naslova',
        CmsPagesLabelsNoDescription: 'Brez opisa',
        CmsPagesLabelsFallbackTitle: 'Stran',
        CmsPagesLabelsYes: 'Da',

        CmsPagesFormHeadingCreate: 'Ustvari novo stran',
        CmsPagesFormHeadingEdit: 'Uredi stran',
        CmsPagesFormLeadCreate:
          'Stran predstavlja razporeditev polj ali blokov, ki so prikazani na določenem naslovu URL.',
        CmsPagesFormLeadEdit:
          'Uredite stran. Izboljšajte SEO in prisotnost v družbenih omrežjih.',
        CmsPagesFormTemplateCreate: 'Izberite predlogo za novo stran',
        CmsPagesFormTemplateEdit: 'Predloga, uporabljena za stran',
        CmsPagesFormTemplateHelperTextCreate:
          'Ta predloga bo glede na nadrejeno stran uporabljena za novo stran.',
        CmsPagesFormTemplateHelperTextEdit:
          'Če želite spremeniti predlogo, ustvarite novo stran in prenesite vsebino.',
        CmsPagesFormTitleCreate: 'Vnesite naslov nove strani',
        CmsPagesFormTitleEdit: 'Naslov strani',
        CmsPagesFormTitleHelperTextCreate:
          'Naslov nove strani. Slug za URL bo samodejno ustvarjen iz naslova.',
        CmsPagesFormTitleHelperTextEdit: 'Naslov strani.',
        CmsPagesFormDescriptionCreate: 'Vnesite opis nove strani',
        CmsPagesFormDescriptionEdit: 'Opis strani',
        CmsPagesFormDescriptionHelperTextCreate:
          'Opis uporabljajo iskalniki in družbena omrežja. Priporočena dolžina je 160-165 znakov.',
        CmsPagesFormDescriptionHelperTextEdit:
          'Opis uporabljajo iskalniki in družbena omrežja. Priporočena dolžina je 160-165 znakov.',
        CmsPagesFormParentPageCreate: 'Izberite nadrejeno stran',
        CmsPagesFormParentPageEdit: 'Nadrejena stran te strani',
        CmsPagesFormParentHelperTextCreate:
          'To bo nadrejena stran nove strani.',
        CmsPagesFormParentHelperTextEdit:
          'Stran lahko premaknete pod primernejšo nadrejeno stran.',
        CmsPagesFormImageCreate: 'Slika',
        CmsPagesFormImageEdit: 'Slika',
        CmsPagesFormImageHelperTextCreate:
          'Strani dodajte sliko. Če je ne nastavite, bo uporabljena slika nadrejene strani ali spletnega mesta.',
        CmsPagesFormImageHelperTextEdit:
          'Slika strani. Če je ne nastavite, bo uporabljena slika nadrejene strani ali spletnega mesta.',
        CmsPagesFormPostCreate: 'Označi kot prispevek',
        CmsPagesFormPostEdit: 'Prispevek',
        CmsPagesFormPostHelperTextCreate:
          'Označite to stran kot prispevek, da dodate polji za datum in avtorja.',
        CmsPagesFormPostHelperTextEdit:
          'Označite to stran kot prispevek, da dodate polji za datum in avtorja.',
        CmsPagesFormPostDateCreate: 'Vnesite datum nove strani',
        CmsPagesFormPostDateEdit: 'Datum objave strani',
        CmsPagesFormPostDateHelperTextCreate:
          'Datum bo uporabljen za razvrščanje prispevkov.',
        CmsPagesFormPostDateHelperTextEdit:
          'Datum bo uporabljen za razvrščanje prispevkov.',
        CmsPagesFormPostAuthorCreate: 'Vnesite avtorja nove strani',
        CmsPagesFormPostAuthorEdit: 'Avtor strani',
        CmsPagesFormPostAuthorHelperTextCreate:
          'To bo prikazano kot avtor prispevka.',
        CmsPagesFormPostAuthorHelperTextEdit:
          'To bo prikazano kot avtor prispevka.',
        CmsPagesFormPostCategoryCreate: 'Vnesite kategorijo nove strani',
        CmsPagesFormPostCategoryEdit: 'Kategorija strani',
        CmsPagesFormPostCategoryHelperTextCreate:
          'Kategorija bo uporabljena za klasifikacijo prispevkov.',
        CmsPagesFormPostCategoryHelperTextEdit:
          'Kategorija bo uporabljena za klasifikacijo prispevkov.',
        CmsPagesFormExcludeFromIndexCreate: 'Izključi iz kazala',
        CmsPagesFormExcludeFromIndexEdit: 'Izključi iz kazala',
        CmsPagesFormExcludeFromIndexHelperTextCreate:
          'Izključite to stran iz vseh polj kazala (npr. mest, kjer so strani navedene).',
        CmsPagesFormExcludeFromIndexHelperTextEdit:
          'Izključite to stran iz vseh polj kazala (npr. mest, kjer so strani navedene).',
        CmsPagesFormPlaceholdersTitle: 'Naslov',
        CmsPagesFormPlaceholdersSlug: 'slug',
        CmsPagesFormPlaceholdersDescription: 'Opis',
        CmsPagesFormPlaceholdersAuthor: 'Avtor',
        CmsPagesFormPlaceholdersCategory: 'Kategorija',
        CmsPagesFormHelperMediaDescription:
          'Naložite fotografijo, ki predstavlja organizacijo.',
        CmsPagesFormErrorsSlugInUse: 'Slug je že v uporabi',
        CmsPagesFormErrorsParentRequired: 'Nadrejena stran je obvezna',
        CmsPagesFormErrorsTemplateRequired: 'Predloga je obvezna',
        CmsPagesFormErrorsDateRequired: 'Datum je obvezen za prispevke v blogu',
        CmsPagesFormErrorsAuthorRequired:
          'Avtor je obvezen za prispevke v blogu',
        CmsPagesFormButtonsPreview: 'Predogled',
        CmsPagesFormButtonsEdit: 'Uredi stran',
        CmsPagesFormButtonsCancel: 'Prekliči',
        CmsPagesFormButtonsCreate: 'Ustvari stran',
        CmsPagesFormButtonsSave: 'Shrani stran',

        CmsMediaTitle: 'Jaen CMS | Predstavnost',
        CmsMediaMenuLabel: 'Predstavnost',
        CmsMediaBreadcrumbsMedia: 'Predstavnost',

        CmsSettingsTitle: 'Jaen CMS | Nastavitve',
        CmsSettingsMenuLabel: 'Nastavitve',
        CmsSettingsBreadcrumbsSettings: 'Nastavitve',
        CmsSettingsNotificationsUpdated: 'Nastavitve posodobljene',
        CmsSettingsFormHeading: 'Nastavitve',
        CmsSettingsFormSiteInfoGroupTitle: 'Podatki o spletnem mestu',
        CmsSettingsFormSiteInfoTitleLabel: 'Naslov',
        CmsSettingsFormSiteInfoTitlePlaceholder: 'Naslov',
        CmsSettingsFormSiteInfoTitleTooLong: 'Naslov je predolg',
        CmsSettingsFormSiteInfoUrlLabel: 'URL',
        CmsSettingsFormSiteInfoUrlPlaceholder: 'https://snek.at',
        CmsSettingsFormSiteInfoUrlInvalid:
          'URL se mora začeti s http:// ali https://',
        CmsSettingsFormSiteInfoDescriptionLabel: 'Opis',
        CmsSettingsFormSiteInfoDescriptionPlaceholder:
          'Opis, ki se prikaže v iskalnikih in družbenih omrežjih.',
        CmsSettingsFormSiteInfoDescriptionHelper:
          'Kratek opis vašega spletnega mesta.',
        CmsSettingsFormSiteInfoImageLabel: 'Slika',
        CmsSettingsFormSiteInfoImageDescription:
          'Naložite fotografijo, ki predstavlja spletno mesto.',
        CmsSettingsFormOrganisationGroupTitle: 'Organizacija',
        CmsSettingsFormOrganisationNameLabel: 'Ime',
        CmsSettingsFormOrganisationNamePlaceholder: 'Snek',
        CmsSettingsFormOrganisationNameTooLong: 'Ime je predolgo',
        CmsSettingsFormOrganisationUrlLabel: 'URL',
        CmsSettingsFormOrganisationUrlPlaceholder: 'https://snek.at',
        CmsSettingsFormOrganisationUrlInvalid:
          'URL se mora začeti s http:// ali https://',
        CmsSettingsFormOrganisationLogoLabel: 'Slika',
        CmsSettingsFormOrganisationLogoDescription:
          'Naložite fotografijo, ki predstavlja organizacijo.',
        CmsSettingsFormCancel: 'Prekliči',
        CmsSettingsFormSave: 'Shrani',

        CmsDebugTitle: 'Jaen CMS | Razhroščevanje',
        CmsDebugBreadcrumbsDebug: 'Razhroščevanje',

        CmsNotificationTitle: 'Jaen CMS | Obvestilo',
        CmsNotificationMenuLabel: 'Pojavno okno',
        CmsNotificationBreadcrumbsPopup: 'Pojavno okno',
        CmsNotificationCardTitle: 'Pojavno okno z obvestilom',
        CmsNotificationCardDescription:
          'Nastavite pojavno okno z obvestilom. Obvestilo bo prikazano, ko uporabnik obišče stran.',
        CmsNotificationPreview: 'Predogled',
        CmsNotificationNotificationsUpdated: 'Obvestilo posodobljeno',
        CmsNotificationNotificationsUpdatedDescription:
          'Obvestilo je bilo posodobljeno',
        CmsNotificationFormTitleLabel: 'Naslov',
        CmsNotificationFormTitlePlaceholder: 'Novice',
        CmsNotificationFormTitleDescription: 'Naslov obvestila',
        CmsNotificationFormMessageLabel: 'Sporočilo',
        CmsNotificationFormMessageExample: 'To je primer sporočila',
        CmsNotificationFormMessageDescription: 'Sporočilo obvestila',
        CmsNotificationFormEnterUrl: 'Vnesite URL',
        CmsNotificationFormFromLabel: 'Od',
        CmsNotificationFormFromDescription:
          'Obvestilo bo prikazano <b>po</b> tem datumu',
        CmsNotificationFormToLabel: 'Do',
        CmsNotificationFormToDescription:
          'Obvestilo bo prikazano <b>do</b> tega datuma',
        CmsNotificationFormPickDate: 'Izberite datum',
        CmsNotificationFormEnabledLabel:
          'Prikaži pojavno okno z obvestilom, ko uporabnik obišče stran',
        CmsNotificationFormSubmit: 'Pošlji',

        // Accounts
        CmsAccountsErrorsLoadService:
          'Uporabnikov ni bilo mogoče naložiti iz identitetne storitve.',
        CmsAccountsErrorsLoadGeneric: 'Uporabnikov ni bilo mogoče naložiti.',
        CmsAccountsNotificationsCreated: 'Račun ustvarjen',
        CmsAccountsNotificationsCreatedDescription:
          'Račun {username} je bil ustvarjen',
        CmsAccountsNotificationsCreateFailed: 'Računa ni bilo mogoče ustvariti',
        CmsAccountsTitle: 'Računi',
        CmsAccountsPageTitle: 'Jaen CMS | Računi',
        CmsAccountsMenuLabel: 'Računi',
        CmsAccountsBreadcrumbsAccounts: 'Računi',
        CmsAccountsSubtitle:
          'Preglejte in upravljajte uporabniške račune svojega identitetnega najemnika.',
        CmsAccountsActionsCreate: 'Nov račun',
        CmsAccountsSearchPlaceholder:
          'Iskanje po imenu, e-pošti ali prijavnem imenu',
        CmsAccountsErrorsLoadTitle: 'Računov ni mogoče naložiti',
        CmsAccountsCardUnnamed: 'Neimenovan uporabnik',
        CmsAccountsCardNoEmail: 'E-poštni naslov ni naveden',
        CmsAccountsCardUsername: 'Uporabniško ime',
        CmsAccountsCardLoginNames: 'Prijavna imena',
        CmsAccountsCardNoLoginNames: 'Ni dodatnih prijavnih imen',
        CmsAccountsCardManage: 'Upravljaj račun',
        CmsAccountsEmptyTitle: 'Noben račun ne ustreza vašemu iskanju',
        CmsAccountsEmptyHint:
          'Prilagodite iskalni niz ali ustvarite nov račun.',
        CmsAccountsCreateTitle: 'Ustvari nov račun',
        CmsAccountsCreateUsername: 'Uporabniško ime',
        CmsAccountsCreateEmail: 'E-pošta',
        CmsAccountsCreateFirstName: 'Ime',
        CmsAccountsCreateLastName: 'Priimek',
        CmsAccountsCreateInitialPassword: 'Začetno geslo (neobvezno)',
        CmsAccountsCreateSendReset:
          'Če geslo ni nastavljeno, pošlji e-poštno sporočilo za ponastavitev gesla',
        CmsAccountsActionsCancel: 'Prekliči',
        CmsAccountsActionsCreateSubmit: 'Ustvari račun',
        CmsAccountsErrorsDetailService:
          'Uporabniškega profila ni bilo mogoče naložiti iz identitetne storitve.',
        CmsAccountsErrorsDetailGeneric:
          'Uporabniškega profila ni bilo mogoče naložiti.',
        CmsAccountsNotificationsActionFailed: 'Dejanje ni uspelo',
        CmsAccountsNotificationsSaved: 'Spremembe shranjene',
        CmsAccountsNotificationsSavedDescription: 'Profil je bil posodobljen.',
        CmsAccountsNotificationsSaveFailed: 'Shranjevanje ni uspelo',
        CmsAccountsNotificationsDeleted: 'Račun izbrisan',
        CmsAccountsNotificationsPasswordSet: 'Geslo nastavljeno',
        CmsAccountsNotificationsRolesUpdated: 'Vloge posodobljene',
        CmsAccountsDetailBack: 'Nazaj na račune',
        CmsAccountsErrorsDetailTitle: 'Tega računa ni mogoče naložiti',
        CmsAccountsDetailNoEmail: 'Primarni e-poštni naslov ni naveden',
        CmsAccountsDetailUsername: 'Uporabniško ime',
        CmsAccountsDetailPreferredLogin: 'Prednostna prijava',
        CmsAccountsDetailState: 'Stanje računa',
        CmsAccountsDetailCreated: 'Ustvarjeno',
        CmsAccountsDetailLastChange: 'Zadnja sprememba',
        CmsAccountsDetailResourceOwner: 'Organizacija',
        CmsAccountsProfileTitle: 'Profil',
        CmsAccountsProfileDisplayName: 'Prikazno ime',
        CmsAccountsProfileLanguage: 'Prednostni jezik',
        CmsAccountsProfileFirstName: 'Ime',
        CmsAccountsProfileLastName: 'Priimek',
        CmsAccountsProfileEmail: 'E-pošta',
        CmsAccountsProfilePhone: 'Telefon',
        CmsAccountsProfileReset: 'Ponastavi',
        CmsAccountsProfileSave: 'Shrani spremembe',
        CmsAccountsRolesTitle: 'Projektne vloge',
        CmsAccountsRolesGrant: 'Dodeli vloge',
        CmsAccountsRolesEdit: 'Uredi',
        CmsAccountsNotificationsRolesRevoked: 'Vloge odvzete',
        CmsAccountsRolesRevoke: 'Odvzemi',
        CmsAccountsRolesEmpty: 'Ni dodeljenih projektnih vlog.',
        CmsAccountsActionsTitle: 'Dejanja računa',
        CmsAccountsActionsSetPassword: 'Nastavi geslo',
        CmsAccountsNotificationsResetRequested: 'Ponastavitev gesla zahtevana',
        CmsAccountsActionsRequestReset: 'Zahtevaj ponastavitev gesla',
        CmsAccountsNotificationsVerificationSent:
          'Potrditveno e-poštno sporočilo poslano',
        CmsAccountsActionsResendVerification:
          'Znova pošlji potrditveno e-poštno sporočilo',
        CmsAccountsNotificationsDeactivated: 'Račun deaktiviran',
        CmsAccountsActionsDeactivate: 'Deaktiviraj',
        CmsAccountsNotificationsReactivated: 'Račun znova aktiviran',
        CmsAccountsActionsReactivate: 'Znova aktiviraj',
        CmsAccountsNotificationsUnlocked: 'Račun odklenjen',
        CmsAccountsActionsUnlock: 'Odkleni',
        CmsAccountsNotificationsLocked: 'Račun zaklenjen',
        CmsAccountsActionsLock: 'Zakleni',
        CmsAccountsActionsDelete: 'Izbriši račun',
        CmsAccountsDeleteTitle: 'Izbriši račun',
        CmsAccountsDeletePrompt:
          'Ali ste prepričani, da želite izbrisati {username}? Tega dejanja ni mogoče razveljaviti.',
        CmsAccountsPasswordTitle: 'Nastavi novo geslo',
        CmsAccountsPasswordNew: 'Novo geslo',
        CmsAccountsPasswordChangeRequired:
          'Zahtevaj spremembo ob naslednji prijavi',
        CmsAccountsRolesEditTitle: 'Uredi dodeljene vloge',
        CmsAccountsRolesGrantTitle: 'Dodeli projektne vloge',
        CmsAccountsRolesProject: 'Projekt',
        CmsAccountsRolesNoneAvailable: 'Za ta projekt ni vlog na voljo.',
        CmsAccountsRolesSave: 'Shrani vloge',
        SettingsTabGeneral: 'Splošno',
        SettingsTabPasswordSecurity: 'Geslo in varnost',
        SettingsProfileGenderUnspecified: 'Ni navedeno',
        SettingsProfileGenderMale: 'Moški',
        SettingsProfileGenderFemale: 'Ženski',
        SettingsProfileGenderOther: 'Drugo',
        SettingsUsernamePromptTitle: 'Spremeni uporabniško ime',
        SettingsUsernamePromptMessage: 'Vnesite novo uporabniško ime',
        SettingsEmailPromptTitle: 'Spremeni e-poštni naslov',
        SettingsEmailPromptMessage: 'Vnesite nov e-poštni naslov',
        SettingsPhonePromptTitle: 'Spremeni telefonsko številko',
        SettingsPhonePromptMessage: 'Vnesite novo telefonsko številko',
        SettingsPhoneDeleteConfirmTitle: 'Izbriši telefonsko številko',
        SettingsPhoneDeleteConfirmMessage:
          'Ali ste prepričani, da želite izbrisati svojo telefonsko številko?',
        SettingsPhoneVerifyPromptTitle: 'Potrdi telefonsko številko',
        SettingsPhoneVerifyPromptMessage: 'Vnesite potrditveno kodo',
        SettingsProfileTitle: 'Profil',
        SettingsProfileAvatarNoFileSelected: 'Datoteka ni izbrana',
        SettingsProfileUsernameLabel: 'Uporabniško ime',
        SettingsProfileUsernameEditAriaLabel: 'Uredi uporabniško ime',
        SettingsProfileFirstNameLabel: 'Ime',
        SettingsProfileLastNameLabel: 'Priimek',
        SettingsProfileNicknameLabel: 'Vzdevek',
        SettingsProfileFullNameLabel: 'Polno ime',
        SettingsProfileGenderLabel: 'Spol',
        SettingsProfileLanguageLabel: 'Jezik',
        SettingsProfileLanguageNotSet: 'Ni nastavljeno',
        SettingsSaveButton: 'Shrani',
        SettingsContactTitle: 'Kontaktni podatki',
        SettingsContactRefreshAriaLabel: 'Osveži',
        SettingsContactDescription:
          'Navedeni podatki se uporabljajo za pošiljanje pomembnih informacij, na primer e-poštnih sporočil za ponastavitev gesla.',
        SettingsContactEmailLabel: 'E-pošta',
        SettingsContactEmailEditAriaLabel: 'Uredi e-poštni naslov',
        SettingsContactVerified: 'Potrjeno',
        SettingsContactNotVerified: 'Ni potrjeno',
        SettingsContactResendCodeButton: 'Znova pošlji kodo',
        SettingsContactPhoneLabel: 'Telefonska številka',
        SettingsContactPhoneDeleteAriaLabel: 'Izbriši telefonsko številko',
        SettingsContactPhoneEditAriaLabel: 'Uredi telefonsko številko',
        SettingsContactVerifyButton: 'Potrdi',
        SettingsContactPhoneAddAriaLabel: 'Dodaj telefonsko številko',
        SettingsContactPhoneNone: 'Telefonska številka ni navedena',
        SettingsPasswordTitle: 'Geslo',
        SettingsPasswordPolicyIntro:
          'Vnesite novo geslo v skladu s spodnjimi pravili.',
        SettingsPasswordCurrentLabel: 'Trenutno geslo',
        SettingsPasswordCurrentPlaceholder: 'Trenutno geslo',
        SettingsPasswordPolicyMinLength:
          'Dolžina mora biti vsaj {minLength} znakov. ({length} / {minLength})',
        SettingsPasswordPolicySymbol: 'Vsebovati mora simbol ali ločilo.',
        SettingsPasswordPolicyNumber: 'Vsebovati mora številko.',
        SettingsPasswordPolicyUppercase: 'Vsebovati mora veliko črko.',
        SettingsPasswordPolicyLowercase: 'Vsebovati mora malo črko.',
        SettingsPasswordPolicyMatch: 'Gesli se ujemata.',
        SettingsPasswordNewLabel: 'Novo geslo',
        SettingsPasswordNewPlaceholder: 'Novo geslo',
        SettingsPasswordConfirmLabel: 'Potrdi geslo',
        SettingsPasswordConfirmPlaceholder: 'Potrdite geslo',
        SettingsPasswordResetButton: 'Ponastavi trenutno geslo',
        SettingsPasswordCancelButton: 'Prekliči',
        SettingsPasswordHint: 'Varno geslo pomaga zaščititi račun',
        SettingsPasswordEditAriaLabel: 'Uredi geslo',
        ProfileFormTitle: 'Račun',
        ProfileFormFirstNameLabel: 'Ime',
        ProfileFormLastNameLabel: 'Priimek',
        ProfileFormUsernameLabel: 'Uporabniško ime',
        ProfileFormRequiredError: 'To polje je obvezno',
        ProfileFormImageLabel: 'Slika',
        ProfileFormImageDescription:
          'Naložite profilno sliko, da bo vaš račun lažje prepoznaven.',
        ProfileFormUpdateButton: 'Posodobi račun',
        EmailFormTitle: 'E-poštni naslovi',
        EmailFormPrimaryLabel: 'Primarni',
        EmailFormDeleteAriaLabel: 'Izbriši e-poštni naslov',
        EmailFormPrimaryHelpText:
          'Primarni e-poštni naslovi se uporabljajo za komunikacijo v zvezi z računom (npr. ponastavitev gesla).',
        EmailFormUnverifiedLabel: 'Nepotrjen',
        EmailFormResendVerificationLink:
          'Znova pošlji potrditveno e-poštno sporočilo',
        EmailFormAddDescription: 'Računu dodajte e-poštni naslov.',
        EmailFormRequiredError: 'To polje je obvezno',
        EmailFormInvalidEmailError: 'Neveljaven e-poštni naslov',
        EmailFormEmailPlaceholder: 'E-pošta',
        EmailFormAddingLoadingText: 'Dodajanje ...',
        EmailFormAddButton: 'Dodaj',
        PasswordFormTitle: 'Geslo',
        PasswordFormPasswordLabel: 'Geslo',
        PasswordFormRequiredError: 'To polje je obvezno',
        PasswordFormConfirmPasswordLabel: 'Potrdi geslo',
        PasswordFormMismatchError: 'Gesli se ne ujemata',
        PasswordFormHelpText:
          'Geslo mora imeti vsaj 15 znakov ALI vsaj 8 znakov, vključno s številko in malo črko.',
        PasswordFormUpdateButton: 'Posodobi geslo',
        PasswordResetTryAnotherEmailButton:
          'Poskusi z drugim e-poštnim naslovom',
        PasswordResetBackToWebsiteButton: 'Nazaj na spletno mesto',
        PasswordResetEmailHeading: 'Ponastavite geslo',
        PasswordResetPasswordHeading: 'Vnesite novo geslo',
        PasswordResetOtpHeading: 'Vnesite kodo',
        PasswordResetNoAccountPrompt: 'Še nimate računa?',
        PasswordResetSignUpLink: 'Registracija',
        PasswordResetPasswordDescription:
          'Vnesite novo geslo za <b>{email}</b>.',
        PasswordResetOtpDescription:
          'Enkratno geslo (OTP) je bilo poslano na <strong>{email}</strong>.',
        PasswordResetStepPasswordPasswordLabel: 'Geslo',
        PasswordResetStepPasswordConfirmPasswordLabel: 'Potrdi geslo',
        PasswordResetStepPasswordRequiredError: 'To polje je obvezno',
        PasswordResetStepPasswordMismatchError: 'Gesli se ne ujemata',
        PasswordResetStepPasswordSubmitButton:
          'Pošlji e-pošto za ponastavitev gesla',
        SignupSuccessTitle: 'Registracija je uspela.',
        SignupSuccessDescription:
          'Preverite svojo e-pošto in poiščite potrditveno povezavo.',
        SignupErrorTitle: 'Registracija ni uspela.',
        SignupBackToWebsiteButton: 'Nazaj na spletno mesto',
        SignupHeading: 'Ustvarite svoj račun',
        SignupAlreadyUserPrompt: 'Že imate račun?',
        SignupLoginLink: 'Prijava',
        SignupFirstNameLabel: 'Ime',
        SignupFirstNameRequiredError: 'Ime je obvezno',
        SignupLastNameLabel: 'Priimek',
        SignupLastNameRequiredError: 'Priimek je obvezen',
        SignupEmailLabel: 'E-pošta',
        SignupEmailRequiredError: 'E-pošta je obvezna',
        SignupUsernameLabel: 'Uporabniško ime',
        SignupSubmitButton: 'Registriraj se',
        PasswordFieldLabel: 'Geslo',
        PasswordFieldMaskAriaLabel: 'Skrij geslo',
        PasswordFieldRevealAriaLabel: 'Prikaži geslo',
        PasswordFieldRequiredError: 'Geslo je obvezno',
        MediaCloseSidebarAriaLabel: 'Zapri stransko vrstico',
        MediaPagesHeading: 'Strani',
        DialogCloseLabel: 'Zapri',
        CmsDebugVersionInformationHeading: 'Informacije o različicah',
        CmsDebugVersionInformationDescription:
          'Spodaj najdete informacije o različicah orodij Gatsby in Jaen ter vtičnikov, nameščenih v vašem projektu.',
        CmsDebugGatsbyTitle: 'Gatsby',
        CmsDebugGatsbyDescription:
          'Gatsby je priljubljen generator statičnih spletnih mest za izdelavo sodobnih spletnih aplikacij. Spodaj najdete informacije o različicah Gatsby in Gatsby CLI, nameščenih v vašem projektu.',
        CmsDebugGatsbyVersionLabel: 'Različica Gatsby:',
        CmsDebugGatsbyCliVersionLabel: 'Različica Gatsby CLI:',
        CmsDebugJaenTitle: 'Jaen',
        CmsDebugJaenDescription:
          'Jaen je brezglavi sistem za upravljanje vsebin (CMS) za upravljanje vsebine vašega spletnega mesta. Spodaj najdete informacije o različici Jaen, nameščeni v vašem projektu.',
        CmsDebugJaenVersionLabel: 'Različica Jaen:',
        CmsDebugPluginsTitle: 'Vtičniki',
        CmsDebugPluginsDescription:
          'Vtičniki razširjajo funkcionalnost vašega spletnega mesta. Spodaj najdete seznam nameščenih vtičnikov in njihovih različic.',
        CmsDebugWidgetsHeading: 'Gradniki',
        CmsDebugWidgetsDescription:
          'Spodaj najdete seznam gradnikov in njihovih podatkov. To je predogledna funkcija, ki bo v prihodnosti izboljšana.',
        CmsDebugWidgetsColumnName: 'Ime',
        CmsDebugWidgetsColumnCreatedAt: 'Ustvarjeno',
        CmsDebugWidgetsColumnModifiedAt: 'Spremenjeno',
        CmsDebugWidgetsColumnData: 'Podatki',
        DynamicPageNotFound: 'Strani ni mogoče najti',
        DynamicPageLoading: 'Nalaganje ...',
        FormMediaChooser: 'FormMediaChooser',
        JaenFrameMediaModal: 'JaenFrameMediaModal',
        MediaModal: 'MediaModal',
        EmailwerkTemplatesPageTitle: 'Predloge',
        EmailwerkBreadcrumbsRoot: 'Emailwerk',
        EmailwerkBreadcrumbsTemplates: 'Predloge',
        EmailwerkMenuGroupLabel: 'Emailwerk',
        EmailwerkTemplatesLoadFailedTitle:
          'Predlog ni bilo mogoče naložiti ({name})',
        EmailwerkTemplatesAddPromptTitle: 'Dodaj predlogo',
        EmailwerkTemplatesAddPromptMessage: 'Vnesite opis nove predloge',
        EmailwerkTemplatesCreateFailedTitle:
          'Predloge ni bilo mogoče ustvariti',
        EmailwerkTemplatesHeading: 'E-poštne predloge',
        EmailwerkTemplatesDefaultSender:
          'Privzeti pošiljatelj: <strong>{address}</strong>',
        EmailwerkTemplatesNoSenderConfigured: 'Pošiljatelj ni nastavljen',
        EmailwerkTemplatesSenderVerifiedTitle: 'Pošiljatelj preverjen',
        EmailwerkTemplatesSenderVerificationFailedTitle:
          'Preverjanje ni uspelo',
        EmailwerkTemplatesAddButton: 'Dodaj predlogo',
        EmailwerkTemplatesTableDescription: 'Opis',
        EmailwerkTemplatesTableSubject: 'Zadeva',
        EmailwerkTemplatesTableTo: 'Za',
        EmailwerkTemplatesTableReplyTo: 'Odgovori na',
        EmailwerkTemplatesTableUpdatedAt: 'Posodobljeno',
        EmailwerkTemplatesTableCreatedAt: 'Ustvarjeno',
        EmailwerkTemplatesNoTemplatesFound: 'Ni najdenih predlog',
        EmailwerkTemplateLoadFailedTitle:
          'Predloge ni bilo mogoče naložiti ({name})',
        EmailwerkTemplateUpdatedTitle: 'Predloga posodobljena!',
        EmailwerkTemplateUpdatedDescription:
          'Predloga z ID-jem {templateId} je bila posodobljena',
        EmailwerkTemplateErrorTitle: 'Napaka!',
        EmailwerkTemplateUpdateErrorDescription:
          'Napaka pri posodabljanju predloge {templateId}',
        EmailwerkTemplateDeleteConfirmTitle: 'Izbriši predlogo',
        EmailwerkTemplateDeleteConfirmMessage:
          'Ali ste prepričani, da želite izbrisati to predlogo?',
        EmailwerkTemplateDeleteConfirmButton: 'Izbriši',
        EmailwerkTemplateDeleteCancelButton: 'Prekliči',
        EmailwerkTemplateDeletedTitle: 'Predloga izbrisana!',
        EmailwerkTemplateDeletedDescription:
          'Predloga z ID-jem {templateId} je bila izbrisana',
        EmailwerkTemplateDeleteErrorDescription:
          'Napaka pri brisanju predloge {templateId}',
        EmailwerkTemplateServerPreviewErrorDescription:
          'Napaka pri upodabljanju strežniškega predogleda',
        EmailwerkTemplateCopiedTitle: 'Kopirano!',
        EmailwerkTemplateCopiedDescription:
          'ID predloge {templateId} je bil kopiran v odložišče',
        EmailwerkTemplateHeading: 'E-poštna predloga',
        EmailwerkTemplateIdAddon: 'ID predloge',
        EmailwerkTemplateCopyIdAriaLabel: 'Kopiraj ID predloge',
        EmailwerkTemplateDescriptionLabel: 'Opis',
        EmailwerkTemplateParentLabel: 'Nadrejena predloga',
        EmailwerkTemplateParentPlaceholder: 'Brez predloge',
        EmailwerkTemplateEngineLabel: 'Pogon',
        EmailwerkTemplateVerifyReplyToLabel: 'Preveri naslov za odgovor',
        EmailwerkTemplateLinkedLabel: 'Povezano',
        EmailwerkTemplateNoLinkedTemplates: 'Ni povezanih predlog',
        EmailwerkTemplateEnvelopeHeading: 'Ovojnica',
        EmailwerkTemplateSubjectLabel: 'Zadeva',
        EmailwerkTemplateToHeading: 'Za',
        EmailwerkTemplateDeleteToFieldAriaLabel: 'Izbriši polje prejemnika',
        EmailwerkTemplateEmailAddressPlaceholder: 'Vnesite e-poštni naslov',
        EmailwerkTemplateAddToButton: 'Dodaj prejemnika',
        EmailwerkTemplateReplyToLabel: 'Odgovori na',
        EmailwerkTemplateContentHeading: 'Vsebina',
        EmailwerkTemplatePreviewHeading: 'Predogled',
        EmailwerkTemplateRenderedPreviewHeading: 'Upodobljeni predogled',
        EmailwerkTemplateRenderPreviewButton: 'Upodobi predogled',
        EmailwerkTemplateVariablesHeading: 'Spremenljivke',
        EmailwerkTemplateVariablesTableName: 'Ime',
        EmailwerkTemplateVariablesTableType: 'Vrsta',
        EmailwerkTemplateVariablesTableDescription: 'Opis',
        EmailwerkTemplateVariablesTableDefaultValue: 'Privzeta vrednost',
        EmailwerkTemplateVariablesTableRequired: 'Obvezno',
        EmailwerkTemplateVariablesTableConstant: 'Konstanta',
        EmailwerkTemplateVariablesRemoveButton: 'Odstrani',
        EmailwerkTemplateAddVariableButton: 'Dodaj spremenljivko',
        EmailwerkTemplateDeleteButton: 'Izbriši',
        EmailwerkTemplateCancelButton: 'Prekliči',
        EmailwerkTemplateSaveButton: 'Shrani',
        EmailwerkEmailPageTitle: 'E-pošta',
        EmailwerkEmailBreadcrumbsEmail: 'E-pošta',
        EmailwerkEmailValidationTemplateRequired: 'Predloga je obvezna',
        EmailwerkEmailValidationSubjectRequired: 'Zadeva je obvezna',
        EmailwerkEmailValidationMessageRequired: 'Sporočilo je obvezno',
        EmailwerkEmailValidationToRequired: 'Prejemnik je obvezen',
        EmailwerkEmailValidationInvalidEmail:
          'Neveljaven e-poštni naslov ali naslovi',
        EmailwerkEmailValidationInvalidBccEmail:
          'Neveljaven e-poštni naslov ali naslovi v polju Skp',
        EmailwerkEmailValidationConsentRequired: 'Soglasje je obvezno.',
        EmailwerkEmailTemplatesNotFound: 'Ni najdenih predlog',
        EmailwerkEmailTemplatesFetchGraphqlError:
          'Predlog ni bilo mogoče pridobiti zaradi napake GraphQL.',
        EmailwerkEmailTemplatesFetchUnknownError:
          'Pri pridobivanju predlog je prišlo do neznane napake.',
        EmailwerkEmailTemplatesFetchErrorTitle:
          'Napaka pri pridobivanju predlog',
        EmailwerkEmailTemplatesFetchErrorDescription:
          'Pri pridobivanju predlog je prišlo do napake.',
        EmailwerkEmailMessagePlaceholder: 'Tukaj vnesite sporočilo',
        EmailwerkEmailPreviewNoContent: 'Vsebina ni na voljo',
        EmailwerkEmailNoTemplateSelectedError: 'Predloga ni izbrana.',
        EmailwerkEmailSendFailedTitle: 'Pošiljanje e-pošte ni uspelo',
        EmailwerkEmailSentTitle: 'E-pošta poslana',
        EmailwerkEmailSentDescription:
          'E-poštno sporočilo je bilo uspešno poslano.',
        EmailwerkEmailSubmissionErrorTitle: 'Napaka pri pošiljanju',
        EmailwerkEmailUnexpectedError: 'Prišlo je do nepričakovane napake.',
        EmailwerkEmailFormHeading: 'Pošlji e-pošto',
        EmailwerkEmailPreviewButton: 'Predogled',
        EmailwerkEmailTemplateLabel: 'E-poštna predloga',
        EmailwerkEmailTemplatesLoading: 'Nalaganje predlog ...',
        EmailwerkEmailErrorAlertTitle: 'Napaka!',
        EmailwerkEmailNoTemplatesAlertTitle: 'Ni najdenih predlog!',
        EmailwerkEmailNoTemplatesAlertDescription:
          'Na voljo ni nobene e-poštne predloge. Najprej jo ustvarite.',
        EmailwerkEmailTemplateSelectPlaceholder: 'Izberite e-poštno predlogo',
        EmailwerkEmailUnnamedTemplate: 'Neimenovana predloga',
        EmailwerkEmailTemplateHelperText: 'Predloga za e-poštno sporočilo.',
        EmailwerkEmailToLabel: 'Za',
        EmailwerkEmailToPlaceholder: 'jane.doe@snek.at',
        EmailwerkEmailToHelperText:
          'Prejemniki e-poštnega sporočila. Več prejemnikov ločite z vejico.',
        EmailwerkEmailSubjectLabel: 'Zadeva',
        EmailwerkEmailSubjectPlaceholder: 'Pozdravljeni',
        EmailwerkEmailSubjectHelperText: 'Zadeva e-poštnega sporočila.',
        EmailwerkEmailMessageLabel: 'Sporočilo',
        EmailwerkEmailEditorBold: 'Krepko',
        EmailwerkEmailEditorItalic: 'Ležeče',
        EmailwerkEmailEditorUnderline: 'Podčrtano',
        EmailwerkEmailEditorHeading1: 'Naslov 1',
        EmailwerkEmailEditorHeading2: 'Naslov 2',
        EmailwerkEmailEditorHeading3: 'Naslov 3',
        EmailwerkEmailEditorBulletList: 'Označen seznam',
        EmailwerkEmailEditorOrderedList: 'Oštevilčen seznam',
        EmailwerkEmailEditorQuote: 'Citat',
        EmailwerkEmailEditorSetLink: 'Dodaj povezavo',
        EmailwerkEmailEditorUnsetLink: 'Odstrani povezavo',
        EmailwerkEmailEditorLinkPrompt: 'Vnesite URL',
        EmailwerkEmailMessageHelperText: 'Besedilo e-poštnega sporočila.',
        EmailwerkEmailBccLabel: 'Skp',
        EmailwerkEmailBccPlaceholder: 'john.doe@snek.at',
        EmailwerkEmailBccHelperText:
          'Dodatni skriti prejemniki e-poštnega sporočila. Več prejemnikov ločite z vejico.',
        EmailwerkEmailConsentLabel:
          'S potrditvijo tega polja se strinjate, da bo s klikom na gumb »Pošlji« poslano e-poštno sporočilo.',
        EmailwerkEmailSendButton: 'Pošlji',
        EmailwerkEmailPreviewTitle: 'Predogled e-pošte',
        EmailwerkEmailPreviewNoTemplate: 'Predloga ni izbrana',
        EmailwerkEmailPreviewNoSubject: 'Brez zadeve',
        EmailwerkEmailPreviewCloseButton: 'Zapri',
        EmailwerkSenderModalSubmitError:
          'Pri pošiljanju obrazca je prišlo do napake.',
        EmailwerkSenderModalUnknownError: 'Prišlo je do neznane napake.',
        EmailwerkSenderModalActionFailed: 'Dejanje s pošiljateljem ni uspelo.',
        EmailwerkSenderModalOpenButton: 'Upravljaj pošiljatelje',
        EmailwerkSenderModalTitle: 'Pošiljatelji',
        EmailwerkSenderModalErrorAlertTitle: 'Napaka!',
        EmailwerkSenderModalColumnAddress: 'Naslov',
        EmailwerkSenderModalColumnTransport: 'Prenos',
        EmailwerkSenderModalBadgeDefault: 'privzeto',
        EmailwerkSenderModalBadgeDisabled: 'onemogočeno',
        EmailwerkSenderModalMakeDefaultButton: 'Nastavi kot privzeto',
        EmailwerkSenderModalVerifyButton: 'Preveri',
        EmailwerkSenderModalDeleteButton: 'Izbriši',
        EmailwerkSenderModalEmpty: 'Noben pošiljatelj še ni nastavljen.',
        EmailwerkSenderModalAddHeading: 'Dodaj pošiljatelja SMTP',
        EmailwerkSenderModalValidationAddressRequired: 'Naslov je obvezen',
        EmailwerkSenderModalAddressLabel: 'E-poštni naslov',
        EmailwerkSenderModalAddressPlaceholder: 'noreply@example.com',
        EmailwerkSenderModalDisplayNameLabel: 'Prikazno ime',
        EmailwerkSenderModalValidationHostRequired: 'Gostitelj SMTP je obvezen',
        EmailwerkSenderModalHostLabel: 'Gostitelj SMTP',
        EmailwerkSenderModalValidationPortRequired: 'Vrata SMTP so obvezna',
        EmailwerkSenderModalPortLabel: 'Vrata SMTP',
        EmailwerkSenderModalSecureLabel: 'Varna povezava',
        EmailwerkSenderModalValidationUsernameRequired:
          'Uporabniško ime SMTP je obvezno',
        EmailwerkSenderModalUsernameLabel: 'Uporabniško ime SMTP',
        EmailwerkSenderModalValidationPasswordRequired: 'Geslo SMTP je obvezno',
        EmailwerkSenderModalPasswordLabel: 'Geslo SMTP',
        EmailwerkSenderModalIsDefaultLabel:
          'Nastavi kot privzetega pošiljatelja',
        EmailwerkSenderModalCreateButton: 'Ustvari pošiljatelja',
        EmailwerkSenderModalCloseButton: 'Zapri'
      }
    }
  }

  if (code === 'it-IT') {
    return {
      code,
      strings: {
        Language: 'Italiano',

        AuthLogin: 'Accedi',
        AuthSignup: 'Registrati',
        AuthLogout: 'Esci',
        AuthSettings: 'Impostazioni',

        CmsLabelsRoot: 'CMS',

        CmsDashboardTitle: 'Jaen CMS',
        CmsDashboardMenuLabel: 'Dashboard',
        CmsDashboardMenuGroupLabel: 'Jaen CMS',

        CmsFrameStartEditing: 'Inizia la modifica',
        CmsFrameStopEditing: 'Termina la modifica',
        CmsFrameSaveDraft: 'Salva bozza',
        CmsFrameImportDraft: 'Importa bozza',
        CmsFrameDiscardChanges: 'Scarta le modifiche',
        CmsFrameDiscardAll: 'Scarta',
        CmsFrameDiscardAllTitle: 'Scarta tutte le modifiche non pubblicate',
        CmsFrameDiscardAllConfirm:
          '{fields, plural, one {# modifica non pubblicata} other {# modifiche non pubblicate}} su {pages, plural, one {# pagina} other {# pagine}} verranno annullate per tutti{who}{when}. Il sito torna a quanto prodotto dall’ultima pubblicazione.',
        CmsFrameDiscardAllConfirmWho: ', scritte da {editors}',
        CmsFrameDiscardAllConfirmWhen: ', dal {since}',
        CmsFrameDiscardAllConfirmText: 'Scarta tutto',
        CmsFrameDiscardAllCancelText: 'Continua a modificare',
        CmsFrameDiscardNothing:
          'Nella bozza non c’è nulla di diverso da quanto pubblicato.',
        CmsFrameDiscardedTitle: 'Modifiche non pubblicate scartate',
        CmsFrameDiscardedDescription:
          '{who} ha scartato tutte le modifiche non pubblicate di questo sito alle {at}. Quello che vedi è ciò che è pubblicato.',
        CmsFrameDiscardedByAnAdmin: 'Un amministratore',
        CmsFrameSaveStateSaving: 'Salvataggio in corso',
        CmsFrameSaveStateSaved: 'Salvato {at}',
        CmsFrameSaveStateSavedUnpublished: 'Salvato {at}, non pubblicato',
        CmsFramePublished: 'Tutto pubblicato',
        CmsFrameSaveStateOffline:
          'Offline, {count, plural, one {# modifica in attesa} other {# modifiche in attesa}}',
        CmsFrameSaveStateError: 'Salvataggio non riuscito, nuovo tentativo',
        CmsFrameSaveStatePending: 'Non ancora salvato',
        CmsFramePublish:
          '{isPublishing, select, true {Pubblicazione in corso} other {Pubblica le modifiche}}',
        CmsFrameNewMedia: 'Nuovo media',
        CmsFrameGuest: 'Ospite',
        CmsFrameNotificationsEditModeTitle: 'Modalità di modifica',
        CmsFrameNotificationsEditModeOn: 'Ora puoi modificare la pagina',
        CmsFrameNotificationsEditModeOff: 'Non puoi più modificare la pagina',
        CmsFrameNotificationsSaved: 'Salvato',
        CmsFrameNotificationsSavedDescription:
          'Le tue modifiche sono state salvate',
        CmsFrameNotificationsImported: 'Importato',
        CmsFrameNotificationsImportedDescription:
          'Le tue modifiche sono state importate',
        CmsFrameNotificationsImportFailed: 'Importazione non riuscita',
        CmsFrameNotificationsImportFailedDescription:
          'Non è stato possibile importare le tue modifiche',
        CmsFrameNotificationsDiscarded: 'Scartato',
        CmsFrameNotificationsDiscardedDescription:
          'Le tue modifiche sono state scartate',

        CmsPagesTitle: 'Jaen CMS | Pagine',
        CmsPagesMenuLabel: 'Pagine',

        CmsPagesBreadcrumbsPages: 'Pagine',
        CmsPagesBreadcrumbsNew: 'Nuova',

        CmsPagesNotificationsCreated: 'Pagina creata',
        CmsPagesNotificationsCreatedDescription:
          'La pagina {title} è stata creata',
        CmsPagesNotificationsUpdated: 'Pagina aggiornata',
        CmsPagesNotificationsUpdatedDescription:
          'La pagina {title} è stata aggiornata',
        CmsPagesNotificationsDeleted: 'Pagina eliminata',
        CmsPagesNotificationsDeletedDescription:
          'La pagina {slug} è stata eliminata',
        CmsPagesNotificationsDuplicated: 'Pagina duplicata',
        CmsPagesNotificationsDuplicatedDescription:
          'La pagina {slug} è stata duplicata',
        CmsPagesNotificationsMoved: 'Pagina spostata',
        CmsPagesNotificationsMovedDescription:
          'La pagina {slug} è stata spostata',
        CmsPagesNotificationsSlugUpdated: 'Slug aggiornato',
        CmsPagesNotificationsSlugUpdatedDescription:
          'Lo slug è stato aggiornato in {slug}',
        CmsPagesNotificationsDuplicateFailed: 'Impossibile duplicare la pagina',
        CmsPagesNotificationsMoveFailed: 'Impossibile spostare la pagina',
        CmsPagesNotificationsSlugUpdateFailed: 'Impossibile aggiornare lo slug',

        CmsPagesActionsDuplicate: 'Duplica pagina',
        CmsPagesActionsMove: 'Sposta pagina',
        CmsPagesActionsUpdateSlug: 'Aggiorna slug',
        CmsPagesActionsRenameSlug: 'Rinomina slug',
        CmsPagesActionsDelete: 'Elimina pagina',
        CmsPagesActionsDeleteThis: 'Elimina questa pagina',

        CmsPagesDescriptionsDuplicate:
          'Questa operazione duplicherà la pagina con le sue sottopagine.',
        CmsPagesDescriptionsMove:
          'Questa operazione sposterà la pagina e tutte le sue sottopagine.',
        CmsPagesDescriptionsUpdateSlug:
          'Questa operazione rinominerà lo slug e influirà quindi sul percorso della pagina e di tutte le sue sottopagine.',
        CmsPagesDescriptionsDelete:
          'Questa operazione eliminerà la pagina e tutte le sue sottopagine.',

        CmsPagesPromptsDuplicateTitle: 'Duplica pagina',
        CmsPagesPromptsDuplicateMessage:
          'Inserisci un nuovo slug per la pagina duplicata. Questo influirà sul percorso.',
        CmsPagesPromptsDuplicateConfirm: 'Duplica',
        CmsPagesPromptsDuplicateCancel: 'Annulla',
        CmsPagesPromptsDuplicatePlaceholder: '{slug}-copia',

        CmsPagesPromptsMoveTitle: 'Sposta pagina',
        CmsPagesPromptsMoveMessage: 'Seleziona una nuova pagina genitore.',
        CmsPagesPromptsMoveConfirm: 'Sposta',
        CmsPagesPromptsMoveCancel: 'Annulla',

        CmsPagesPromptsRenameSlugTitle: 'Rinomina slug',
        CmsPagesPromptsRenameSlugMessage:
          'Inserisci un nuovo slug. Questo influirà sul percorso.',
        CmsPagesPromptsRenameSlugConfirm: 'Rinomina',
        CmsPagesPromptsRenameSlugCancel: 'Annulla',

        CmsPagesPromptsDeleteTitle: 'Elimina pagina',
        CmsPagesPromptsDeleteMessage:
          'Sei sicuro di voler eliminare questa pagina e tutte le sue sottopagine?',
        CmsPagesPromptsDeleteConfirm: 'Elimina',

        CmsPagesTableSubpagesHeading: 'Sottopagine',
        CmsPagesTableReorderEnable: 'Riordina',
        CmsPagesTableReorderDisable: 'Fatto',
        CmsPagesTableNewPage: 'Nuova pagina',
        CmsPagesTableColumnsTitle: 'Titolo',
        CmsPagesTableColumnsDescription: 'Descrizione',
        CmsPagesTableColumnsDate: 'Data',
        CmsPagesTableEmptyStateDescription:
          'Questa pagina non ha ancora sottopagine.',
        CmsPagesTableEmptyStateAction: 'Crea una nuova pagina',
        CmsPagesTableDateCreated: 'Creata il {date} alle {time}',
        CmsPagesTableDateUpdated: 'Ultima modifica il {date} alle {time}',
        CmsPagesTableDateEmpty: '-',
        CmsPagesTableReorderError:
          'Si è verificato un errore durante il riordino delle pagine.',
        CmsPagesTableDangerZoneHeading: 'Zona di pericolo',

        CmsPagesLabelsNoTitle: 'Nessun titolo',
        CmsPagesLabelsNoDescription: 'Nessuna descrizione',
        CmsPagesLabelsFallbackTitle: 'Pagina',
        CmsPagesLabelsYes: 'Sì',

        CmsPagesFormHeadingCreate: 'Crea una nuova pagina',
        CmsPagesFormHeadingEdit: 'Modifica la pagina',
        CmsPagesFormLeadCreate:
          'Una pagina rappresenta una disposizione di campi o blocchi visualizzati a un URL specifico.',
        CmsPagesFormLeadEdit:
          'Modifica la pagina. Migliora la SEO e la presenza sui social media.',
        CmsPagesFormTemplateCreate: 'Seleziona un template per la nuova pagina',
        CmsPagesFormTemplateEdit: 'Il template utilizzato per la pagina',
        CmsPagesFormTemplateHelperTextCreate:
          'Questo template verrà applicato alla nuova pagina, in base alla pagina genitore.',
        CmsPagesFormTemplateHelperTextEdit:
          'Se desideri modificare il template, crea una nuova pagina e trasferisci il contenuto.',
        CmsPagesFormTitleCreate: 'Inserisci un titolo per la nuova pagina',
        CmsPagesFormTitleEdit: 'Il titolo della pagina',
        CmsPagesFormTitleHelperTextCreate:
          "Il titolo della nuova pagina. Lo slug dell'URL verrà generato automaticamente dal titolo.",
        CmsPagesFormTitleHelperTextEdit: 'Il titolo della pagina.',
        CmsPagesFormDescriptionCreate:
          'Fornisci una descrizione per la nuova pagina',
        CmsPagesFormDescriptionEdit: 'La descrizione della pagina',
        CmsPagesFormDescriptionHelperTextCreate:
          "La descrizione verrà utilizzata dai motori di ricerca e dai social media. L'ideale è una lunghezza di 160-165 caratteri.",
        CmsPagesFormDescriptionHelperTextEdit:
          "La descrizione verrà utilizzata dai motori di ricerca e dai social media. L'ideale è una lunghezza di 160-165 caratteri.",
        CmsPagesFormParentPageCreate: 'Seleziona una pagina genitore',
        CmsPagesFormParentPageEdit: 'La pagina genitore della pagina',
        CmsPagesFormParentHelperTextCreate:
          'Questa fungerà da pagina genitore della nuova pagina.',
        CmsPagesFormParentHelperTextEdit:
          'Puoi spostare la pagina sotto una pagina genitore più adatta.',
        CmsPagesFormImageCreate: 'Immagine',
        CmsPagesFormImageEdit: 'Immagine',
        CmsPagesFormImageHelperTextCreate:
          "Aggiungi un'immagine alla pagina. Se non impostata, verrà utilizzata l'immagine della pagina genitore o del sito.",
        CmsPagesFormImageHelperTextEdit:
          "L'immagine della pagina. Se non impostata, verrà utilizzata l'immagine della pagina genitore o del sito.",
        CmsPagesFormPostCreate: 'Contrassegna come articolo',
        CmsPagesFormPostEdit: 'Articolo',
        CmsPagesFormPostHelperTextCreate:
          'Contrassegna questa pagina come articolo per aggiungere i campi data e autore.',
        CmsPagesFormPostHelperTextEdit:
          'Contrassegna questa pagina come articolo per aggiungere i campi data e autore.',
        CmsPagesFormPostDateCreate: 'Inserisci una data per la nuova pagina',
        CmsPagesFormPostDateEdit: 'La data di pubblicazione della pagina',
        CmsPagesFormPostDateHelperTextCreate:
          "La data verrà utilizzata per l'ordinamento degli articoli.",
        CmsPagesFormPostDateHelperTextEdit:
          "La data verrà utilizzata per l'ordinamento degli articoli.",
        CmsPagesFormPostAuthorCreate: 'Inserisci un autore per la nuova pagina',
        CmsPagesFormPostAuthorEdit: "L'autore della pagina",
        CmsPagesFormPostAuthorHelperTextCreate:
          "Verrà visualizzato come autore dell'articolo.",
        CmsPagesFormPostAuthorHelperTextEdit:
          "Verrà visualizzato come autore dell'articolo.",
        CmsPagesFormPostCategoryCreate:
          'Inserisci una categoria per la nuova pagina',
        CmsPagesFormPostCategoryEdit: 'La categoria della pagina',
        CmsPagesFormPostCategoryHelperTextCreate:
          'La categoria verrà utilizzata per la classificazione degli articoli.',
        CmsPagesFormPostCategoryHelperTextEdit:
          'La categoria verrà utilizzata per la classificazione degli articoli.',
        CmsPagesFormExcludeFromIndexCreate: "Escludi dall'indice",
        CmsPagesFormExcludeFromIndexEdit: "Escludi dall'indice",
        CmsPagesFormExcludeFromIndexHelperTextCreate:
          'Escludi questa pagina da tutti i campi indice (ad es. i punti in cui vengono elencate le pagine).',
        CmsPagesFormExcludeFromIndexHelperTextEdit:
          'Escludi questa pagina da tutti i campi indice (ad es. i punti in cui vengono elencate le pagine).',
        CmsPagesFormPlaceholdersTitle: 'Titolo',
        CmsPagesFormPlaceholdersSlug: 'slug',
        CmsPagesFormPlaceholdersDescription: 'Descrizione',
        CmsPagesFormPlaceholdersAuthor: 'Autore',
        CmsPagesFormPlaceholdersCategory: 'Categoria',
        CmsPagesFormHelperMediaDescription:
          "Carica una foto che rappresenti l'organizzazione.",
        CmsPagesFormErrorsSlugInUse: 'Lo slug è già in uso',
        CmsPagesFormErrorsParentRequired: 'La pagina genitore è obbligatoria',
        CmsPagesFormErrorsTemplateRequired: 'Il template è obbligatorio',
        CmsPagesFormErrorsDateRequired:
          'La data è obbligatoria per gli articoli del blog',
        CmsPagesFormErrorsAuthorRequired:
          "L'autore è obbligatorio per gli articoli del blog",
        CmsPagesFormButtonsPreview: 'Anteprima',
        CmsPagesFormButtonsEdit: 'Modifica pagina',
        CmsPagesFormButtonsCancel: 'Annulla',
        CmsPagesFormButtonsCreate: 'Crea pagina',
        CmsPagesFormButtonsSave: 'Salva pagina',

        CmsMediaTitle: 'Jaen CMS | Media',
        CmsMediaMenuLabel: 'Media',
        CmsMediaBreadcrumbsMedia: 'Media',

        CmsSettingsTitle: 'Jaen CMS | Impostazioni',
        CmsSettingsMenuLabel: 'Impostazioni',
        CmsSettingsBreadcrumbsSettings: 'Impostazioni',
        CmsSettingsNotificationsUpdated: 'Impostazioni aggiornate',
        CmsSettingsFormHeading: 'Impostazioni',
        CmsSettingsFormSiteInfoGroupTitle: 'Informazioni sul sito',
        CmsSettingsFormSiteInfoTitleLabel: 'Titolo',
        CmsSettingsFormSiteInfoTitlePlaceholder: 'Titolo',
        CmsSettingsFormSiteInfoTitleTooLong: 'Il titolo è troppo lungo',
        CmsSettingsFormSiteInfoUrlLabel: 'URL',
        CmsSettingsFormSiteInfoUrlPlaceholder: 'https://snek.at',
        CmsSettingsFormSiteInfoUrlInvalid:
          "L'URL deve iniziare con http:// o https://",
        CmsSettingsFormSiteInfoDescriptionLabel: 'Descrizione',
        CmsSettingsFormSiteInfoDescriptionPlaceholder:
          'La descrizione che appare nei motori di ricerca e sui social media.',
        CmsSettingsFormSiteInfoDescriptionHelper: 'Breve descrizione del sito.',
        CmsSettingsFormSiteInfoImageLabel: 'Immagine',
        CmsSettingsFormSiteInfoImageDescription:
          'Carica una foto che rappresenti il sito.',
        CmsSettingsFormOrganisationGroupTitle: 'Organizzazione',
        CmsSettingsFormOrganisationNameLabel: 'Nome',
        CmsSettingsFormOrganisationNamePlaceholder: 'Snek',
        CmsSettingsFormOrganisationNameTooLong: 'Il nome è troppo lungo',
        CmsSettingsFormOrganisationUrlLabel: 'URL',
        CmsSettingsFormOrganisationUrlPlaceholder: 'https://snek.at',
        CmsSettingsFormOrganisationUrlInvalid:
          "L'URL deve iniziare con http:// o https://",
        CmsSettingsFormOrganisationLogoLabel: 'Immagine',
        CmsSettingsFormOrganisationLogoDescription:
          "Carica una foto che rappresenti l'organizzazione.",
        CmsSettingsFormCancel: 'Annulla',
        CmsSettingsFormSave: 'Salva',

        CmsDebugTitle: 'Jaen CMS | Debug',
        CmsDebugBreadcrumbsDebug: 'Debug',

        CmsNotificationTitle: 'Jaen CMS | Notifica',
        CmsNotificationMenuLabel: 'Popup',
        CmsNotificationBreadcrumbsPopup: 'Popup',
        CmsNotificationCardTitle: 'Popup di notifica',
        CmsNotificationCardDescription:
          "Configura il popup di notifica. La notifica verrà mostrata quando l'utente visita la pagina.",
        CmsNotificationPreview: 'Anteprima',
        CmsNotificationNotificationsUpdated: 'Notifica aggiornata',
        CmsNotificationNotificationsUpdatedDescription:
          'La notifica è stata aggiornata',
        CmsNotificationFormTitleLabel: 'Titolo',
        CmsNotificationFormTitlePlaceholder: 'Novità',
        CmsNotificationFormTitleDescription: 'Il titolo della notifica',
        CmsNotificationFormMessageLabel: 'Messaggio',
        CmsNotificationFormMessageExample: 'Questo è un messaggio di esempio',
        CmsNotificationFormMessageDescription: 'Il messaggio della notifica',
        CmsNotificationFormEnterUrl: "Inserisci l'URL",
        CmsNotificationFormFromLabel: 'Da',
        CmsNotificationFormFromDescription:
          'La notifica verrà mostrata <b>dopo</b> questa data',
        CmsNotificationFormToLabel: 'A',
        CmsNotificationFormToDescription:
          'La notifica verrà mostrata <b>fino a</b> questa data',
        CmsNotificationFormPickDate: 'Scegli una data',
        CmsNotificationFormEnabledLabel:
          "Mostra il popup di notifica quando l'utente visita la pagina",
        CmsNotificationFormSubmit: 'Invia',

        // Accounts
        CmsAccountsErrorsLoadService:
          'Impossibile caricare gli utenti dal servizio di identità.',
        CmsAccountsErrorsLoadGeneric: 'Impossibile caricare gli utenti.',
        CmsAccountsNotificationsCreated: 'Account creato',
        CmsAccountsNotificationsCreatedDescription:
          "L'account {username} è stato creato",
        CmsAccountsNotificationsCreateFailed: "Impossibile creare l'account",
        CmsAccountsTitle: 'Account',
        CmsAccountsPageTitle: 'Jaen CMS | Account',
        CmsAccountsMenuLabel: 'Account',
        CmsAccountsBreadcrumbsAccounts: 'Account',
        CmsAccountsSubtitle:
          'Sfoglia e gestisci gli account utente del tuo tenant di identità.',
        CmsAccountsActionsCreate: 'Nuovo account',
        CmsAccountsSearchPlaceholder: 'Cerca per nome, email o nome di accesso',
        CmsAccountsErrorsLoadTitle: 'Impossibile caricare gli account',
        CmsAccountsCardUnnamed: 'Utente senza nome',
        CmsAccountsCardNoEmail: 'Nessuna email specificata',
        CmsAccountsCardUsername: 'Nome utente',
        CmsAccountsCardLoginNames: 'Nomi di accesso',
        CmsAccountsCardNoLoginNames: 'Nessun nome di accesso alternativo',
        CmsAccountsCardManage: 'Gestisci account',
        CmsAccountsEmptyTitle: 'Nessun account corrisponde alla ricerca',
        CmsAccountsEmptyHint:
          'Modifica il termine di ricerca o crea un nuovo account.',
        CmsAccountsCreateTitle: 'Crea un nuovo account',
        CmsAccountsCreateUsername: 'Nome utente',
        CmsAccountsCreateEmail: 'Email',
        CmsAccountsCreateFirstName: 'Nome',
        CmsAccountsCreateLastName: 'Cognome',
        CmsAccountsCreateInitialPassword: 'Password iniziale (facoltativa)',
        CmsAccountsCreateSendReset:
          "Invia un'email di reimpostazione della password se non viene impostata alcuna password",
        CmsAccountsActionsCancel: 'Annulla',
        CmsAccountsActionsCreateSubmit: 'Crea account',
        CmsAccountsErrorsDetailService:
          'Impossibile caricare il profilo utente dal servizio di identità.',
        CmsAccountsErrorsDetailGeneric:
          'Impossibile caricare il profilo utente.',
        CmsAccountsNotificationsActionFailed: 'Operazione non riuscita',
        CmsAccountsNotificationsSaved: 'Modifiche salvate',
        CmsAccountsNotificationsSavedDescription:
          'Il profilo è stato aggiornato.',
        CmsAccountsNotificationsSaveFailed: 'Salvataggio non riuscito',
        CmsAccountsNotificationsDeleted: 'Account eliminato',
        CmsAccountsNotificationsPasswordSet: 'Password impostata',
        CmsAccountsNotificationsRolesUpdated: 'Ruoli aggiornati',
        CmsAccountsDetailBack: 'Torna agli account',
        CmsAccountsErrorsDetailTitle: 'Impossibile caricare questo account',
        CmsAccountsDetailNoEmail: 'Nessuna email principale specificata',
        CmsAccountsDetailUsername: 'Nome utente',
        CmsAccountsDetailPreferredLogin: 'Nome di accesso preferito',
        CmsAccountsDetailState: "Stato dell'account",
        CmsAccountsDetailCreated: 'Creato',
        CmsAccountsDetailLastChange: 'Ultima modifica',
        CmsAccountsDetailResourceOwner: 'Organizzazione',
        CmsAccountsProfileTitle: 'Profilo',
        CmsAccountsProfileDisplayName: 'Nome visualizzato',
        CmsAccountsProfileLanguage: 'Lingua preferita',
        CmsAccountsProfileFirstName: 'Nome',
        CmsAccountsProfileLastName: 'Cognome',
        CmsAccountsProfileEmail: 'Email',
        CmsAccountsProfilePhone: 'Telefono',
        CmsAccountsProfileReset: 'Ripristina',
        CmsAccountsProfileSave: 'Salva modifiche',
        CmsAccountsRolesTitle: 'Ruoli di progetto',
        CmsAccountsRolesGrant: 'Assegna ruoli',
        CmsAccountsRolesEdit: 'Modifica',
        CmsAccountsNotificationsRolesRevoked: 'Ruoli revocati',
        CmsAccountsRolesRevoke: 'Revoca',
        CmsAccountsRolesEmpty: 'Nessun ruolo di progetto assegnato.',
        CmsAccountsActionsTitle: "Azioni sull'account",
        CmsAccountsActionsSetPassword: 'Imposta password',
        CmsAccountsNotificationsResetRequested:
          'Reimpostazione della password richiesta',
        CmsAccountsActionsRequestReset: 'Richiedi reimpostazione password',
        CmsAccountsNotificationsVerificationSent: 'Email di verifica inviata',
        CmsAccountsActionsResendVerification:
          "Invia di nuovo l'email di verifica",
        CmsAccountsNotificationsDeactivated: 'Account disattivato',
        CmsAccountsActionsDeactivate: 'Disattiva',
        CmsAccountsNotificationsReactivated: 'Account riattivato',
        CmsAccountsActionsReactivate: 'Riattiva',
        CmsAccountsNotificationsUnlocked: 'Account sbloccato',
        CmsAccountsActionsUnlock: 'Sblocca',
        CmsAccountsNotificationsLocked: 'Account bloccato',
        CmsAccountsActionsLock: 'Blocca',
        CmsAccountsActionsDelete: 'Elimina account',
        CmsAccountsDeleteTitle: 'Elimina account',
        CmsAccountsDeletePrompt:
          'Sei sicuro di voler eliminare {username}? Questa operazione non può essere annullata.',
        CmsAccountsPasswordTitle: 'Imposta una nuova password',
        CmsAccountsPasswordNew: 'Nuova password',
        CmsAccountsPasswordChangeRequired:
          'Richiedi la modifica al prossimo accesso',
        CmsAccountsRolesEditTitle: 'Modifica i ruoli assegnati',
        CmsAccountsRolesGrantTitle: 'Assegna ruoli di progetto',
        CmsAccountsRolesProject: 'Progetto',
        CmsAccountsRolesNoneAvailable:
          'Nessun ruolo disponibile per questo progetto.',
        CmsAccountsRolesSave: 'Salva ruoli',
        SettingsTabGeneral: 'Generale',
        SettingsTabPasswordSecurity: 'Password e sicurezza',
        SettingsProfileGenderUnspecified: 'Non specificato',
        SettingsProfileGenderMale: 'Maschio',
        SettingsProfileGenderFemale: 'Femmina',
        SettingsProfileGenderOther: 'Altro',
        SettingsUsernamePromptTitle: 'Cambia nome utente',
        SettingsUsernamePromptMessage: 'Inserisci il tuo nuovo nome utente',
        SettingsEmailPromptTitle: 'Cambia email',
        SettingsEmailPromptMessage: 'Inserisci la tua nuova email',
        SettingsPhonePromptTitle: 'Cambia numero di telefono',
        SettingsPhonePromptMessage: 'Inserisci il tuo nuovo numero di telefono',
        SettingsPhoneDeleteConfirmTitle: 'Elimina numero di telefono',
        SettingsPhoneDeleteConfirmMessage:
          'Sei sicuro di voler eliminare il tuo numero di telefono?',
        SettingsPhoneVerifyPromptTitle: 'Verifica numero di telefono',
        SettingsPhoneVerifyPromptMessage: 'Inserisci il codice di verifica',
        SettingsProfileTitle: 'Profilo',
        SettingsProfileAvatarNoFileSelected: 'Nessun file selezionato',
        SettingsProfileUsernameLabel: 'Nome utente',
        SettingsProfileUsernameEditAriaLabel: 'Modifica nome utente',
        SettingsProfileFirstNameLabel: 'Nome',
        SettingsProfileLastNameLabel: 'Cognome',
        SettingsProfileNicknameLabel: 'Nickname',
        SettingsProfileFullNameLabel: 'Nome completo',
        SettingsProfileGenderLabel: 'Genere',
        SettingsProfileLanguageLabel: 'Lingua',
        SettingsProfileLanguageNotSet: 'Non impostata',
        SettingsSaveButton: 'Salva',
        SettingsContactTitle: 'Informazioni di contatto',
        SettingsContactRefreshAriaLabel: 'Aggiorna',
        SettingsContactDescription:
          'Le informazioni fornite vengono utilizzate per inviarti comunicazioni importanti, come le email di reimpostazione della password.',
        SettingsContactEmailLabel: 'Email',
        SettingsContactEmailEditAriaLabel: 'Modifica email',
        SettingsContactVerified: 'Verificato',
        SettingsContactNotVerified: 'Non verificato',
        SettingsContactResendCodeButton: 'Invia di nuovo il codice',
        SettingsContactPhoneLabel: 'Numero di telefono',
        SettingsContactPhoneDeleteAriaLabel: 'Elimina numero di telefono',
        SettingsContactPhoneEditAriaLabel: 'Modifica numero di telefono',
        SettingsContactVerifyButton: 'Verifica',
        SettingsContactPhoneAddAriaLabel: 'Aggiungi numero di telefono',
        SettingsContactPhoneNone: 'Nessun numero di telefono specificato',
        SettingsPasswordTitle: 'Password',
        SettingsPasswordPolicyIntro:
          'Inserisci la nuova password rispettando i criteri indicati di seguito.',
        SettingsPasswordCurrentLabel: 'Password attuale',
        SettingsPasswordCurrentPlaceholder: 'Nuova password',
        SettingsPasswordPolicyMinLength:
          'Deve contenere almeno {minLength} caratteri. ({length} / {minLength})',
        SettingsPasswordPolicySymbol:
          'Deve includere un simbolo o un segno di punteggiatura.',
        SettingsPasswordPolicyNumber: 'Deve includere un numero.',
        SettingsPasswordPolicyUppercase:
          'Deve includere una lettera maiuscola.',
        SettingsPasswordPolicyLowercase:
          'Deve includere una lettera minuscola.',
        SettingsPasswordPolicyMatch: 'Le password corrispondono.',
        SettingsPasswordNewLabel: 'Nuova password',
        SettingsPasswordNewPlaceholder: 'Nuova password',
        SettingsPasswordConfirmLabel: 'Conferma password',
        SettingsPasswordConfirmPlaceholder: 'Conferma password',
        SettingsPasswordResetButton: 'Reimposta la password attuale',
        SettingsPasswordCancelButton: 'Annulla',
        SettingsPasswordHint:
          "Una password sicura aiuta a proteggere l'account",
        SettingsPasswordEditAriaLabel: 'Modifica email',
        ProfileFormTitle: 'Account',
        ProfileFormFirstNameLabel: 'Nome',
        ProfileFormLastNameLabel: 'Cognome',
        ProfileFormUsernameLabel: 'Nome utente',
        ProfileFormRequiredError: 'Questo campo è obbligatorio',
        ProfileFormImageLabel: 'Immagine',
        ProfileFormImageDescription:
          "Carica un'immagine del profilo per rendere il tuo account più facile da riconoscere.",
        ProfileFormUpdateButton: 'Aggiorna account',
        EmailFormTitle: 'Indirizzi email',
        EmailFormPrimaryLabel: 'Principale',
        EmailFormDeleteAriaLabel: 'Elimina indirizzo email',
        EmailFormPrimaryHelpText:
          "Gli indirizzi email principali vengono utilizzati per le comunicazioni relative all'account (ad es. reimpostazione della password).",
        EmailFormUnverifiedLabel: 'Non verificato',
        EmailFormResendVerificationLink: "Invia di nuovo l'email di verifica",
        EmailFormAddDescription: 'Aggiungi un indirizzo email al tuo account.',
        EmailFormRequiredError: 'Questo campo è obbligatorio',
        EmailFormInvalidEmailError: 'Indirizzo email non valido',
        EmailFormEmailPlaceholder: 'Email',
        EmailFormAddingLoadingText: 'Aggiunta in corso...',
        EmailFormAddButton: 'Aggiungi',
        PasswordFormTitle: 'Password',
        PasswordFormPasswordLabel: 'Password',
        PasswordFormRequiredError: 'Questo campo è obbligatorio',
        PasswordFormConfirmPasswordLabel: 'Conferma password',
        PasswordFormMismatchError: 'Le password non corrispondono',
        PasswordFormHelpText:
          'Assicurati che la password contenga almeno 15 caratteri OPPURE almeno 8 caratteri, inclusi un numero e una lettera minuscola.',
        PasswordFormUpdateButton: 'Aggiorna password',
        PasswordResetTryAnotherEmailButton: "Prova un'altra email",
        PasswordResetBackToWebsiteButton: 'Torna al sito',
        PasswordResetEmailHeading: 'Reimposta la password',
        PasswordResetPasswordHeading: 'Inserisci la tua nuova password',
        PasswordResetOtpHeading: 'Inserisci il codice',
        PasswordResetNoAccountPrompt: 'Non hai un account?',
        PasswordResetSignUpLink: 'Registrati',
        PasswordResetPasswordDescription:
          'Inserisci una nuova password per <b>{email}</b>.',
        PasswordResetOtpDescription:
          'Una password monouso (OTP) è stata inviata a <strong>{email}</strong>.',
        PasswordResetStepPasswordPasswordLabel: 'Password',
        PasswordResetStepPasswordConfirmPasswordLabel: 'Conferma password',
        PasswordResetStepPasswordRequiredError: 'Questo campo è obbligatorio',
        PasswordResetStepPasswordMismatchError: 'Le password non corrispondono',
        PasswordResetStepPasswordSubmitButton:
          'Invia email di reimpostazione password',
        SignupSuccessTitle: 'Registrazione completata.',
        SignupSuccessDescription:
          'Controlla la tua email per il link di verifica.',
        SignupErrorTitle: 'Impossibile completare la registrazione.',
        SignupBackToWebsiteButton: 'Torna al sito',
        SignupHeading: 'Crea il tuo account',
        SignupAlreadyUserPrompt: 'Hai già un account?',
        SignupLoginLink: 'Accedi',
        SignupFirstNameLabel: 'Nome',
        SignupFirstNameRequiredError: 'Il nome è obbligatorio',
        SignupLastNameLabel: 'Cognome',
        SignupLastNameRequiredError: 'Il cognome è obbligatorio',
        SignupEmailLabel: 'Email',
        SignupEmailRequiredError: "L'email è obbligatoria",
        SignupUsernameLabel: 'Nome utente',
        SignupSubmitButton: 'Registrati',
        PasswordFieldLabel: 'Password',
        PasswordFieldMaskAriaLabel: 'Nascondi password',
        PasswordFieldRevealAriaLabel: 'Mostra password',
        PasswordFieldRequiredError: 'La password è obbligatoria',
        MediaCloseSidebarAriaLabel: 'Chiudi la barra laterale',
        MediaPagesHeading: 'Pagine',
        DialogCloseLabel: 'Chiudi',
        CmsDebugVersionInformationHeading: 'Informazioni sulla versione',
        CmsDebugVersionInformationDescription:
          'Di seguito trovi le informazioni sulle versioni di Gatsby, Jaen e dei plugin installati nel tuo progetto.',
        CmsDebugGatsbyTitle: 'Gatsby',
        CmsDebugGatsbyDescription:
          'Gatsby è un popolare generatore di siti statici utilizzato per creare applicazioni web moderne. Di seguito trovi le informazioni sulle versioni di Gatsby e della Gatsby CLI installate nel tuo progetto.',
        CmsDebugGatsbyVersionLabel: 'Versione di Gatsby:',
        CmsDebugGatsbyCliVersionLabel: 'Versione della Gatsby CLI:',
        CmsDebugJaenTitle: 'Jaen',
        CmsDebugJaenDescription:
          'Jaen è un sistema di gestione dei contenuti (CMS) headless per gestire i contenuti del tuo sito web. Di seguito trovi le informazioni sulla versione di Jaen installata nel tuo progetto.',
        CmsDebugJaenVersionLabel: 'Versione di Jaen:',
        CmsDebugPluginsTitle: 'Plugin',
        CmsDebugPluginsDescription:
          "I plugin estendono le funzionalità del tuo sito web. Di seguito trovi l'elenco dei plugin installati e delle loro versioni.",
        CmsDebugWidgetsHeading: 'Widget',
        CmsDebugWidgetsDescription:
          "Di seguito trovi l'elenco dei widget e dei relativi dati. Questa è una funzionalità in anteprima e verrà migliorata in futuro.",
        CmsDebugWidgetsColumnName: 'Nome',
        CmsDebugWidgetsColumnCreatedAt: 'Creato il',
        CmsDebugWidgetsColumnModifiedAt: 'Modificato il',
        CmsDebugWidgetsColumnData: 'Dati',
        DynamicPageNotFound: 'Pagina non trovata',
        DynamicPageLoading: 'Caricamento...',
        FormMediaChooser: 'FormMediaChooser',
        JaenFrameMediaModal: 'JaenFrameMediaModal',
        MediaModal: 'MediaModal',
        EmailwerkTemplatesPageTitle: 'Template',
        EmailwerkBreadcrumbsRoot: 'Emailwerk',
        EmailwerkBreadcrumbsTemplates: 'Template',
        EmailwerkMenuGroupLabel: 'Emailwerk',
        EmailwerkTemplatesLoadFailedTitle:
          'Impossibile caricare i template ({name})',
        EmailwerkTemplatesAddPromptTitle: 'Aggiungi template',
        EmailwerkTemplatesAddPromptMessage:
          'Inserisci una descrizione per il nuovo template',
        EmailwerkTemplatesCreateFailedTitle: 'Impossibile creare il template',
        EmailwerkTemplatesHeading: 'Template email',
        EmailwerkTemplatesDefaultSender:
          'Mittente predefinito: <strong>{address}</strong>',
        EmailwerkTemplatesNoSenderConfigured: 'Nessun mittente configurato',
        EmailwerkTemplatesSenderVerifiedTitle: 'Mittente verificato',
        EmailwerkTemplatesSenderVerificationFailedTitle:
          'Verifica non riuscita',
        EmailwerkTemplatesAddButton: 'Aggiungi template',
        EmailwerkTemplatesTableDescription: 'Descrizione',
        EmailwerkTemplatesTableSubject: 'Oggetto',
        EmailwerkTemplatesTableTo: 'A',
        EmailwerkTemplatesTableReplyTo: 'Rispondi a',
        EmailwerkTemplatesTableUpdatedAt: 'Aggiornato il',
        EmailwerkTemplatesTableCreatedAt: 'Creato il',
        EmailwerkTemplatesNoTemplatesFound: 'Nessun template trovato',
        EmailwerkTemplateLoadFailedTitle:
          'Impossibile caricare il template ({name})',
        EmailwerkTemplateUpdatedTitle: 'Template aggiornato!',
        EmailwerkTemplateUpdatedDescription: 'Template {templateId} aggiornato',
        EmailwerkTemplateErrorTitle: 'Errore!',
        EmailwerkTemplateUpdateErrorDescription:
          "Errore durante l'aggiornamento del template {templateId}",
        EmailwerkTemplateDeleteConfirmTitle: 'Elimina template',
        EmailwerkTemplateDeleteConfirmMessage:
          'Sei sicuro di voler eliminare questo template?',
        EmailwerkTemplateDeleteConfirmButton: 'Elimina',
        EmailwerkTemplateDeleteCancelButton: 'Annulla',
        EmailwerkTemplateDeletedTitle: 'Template eliminato!',
        EmailwerkTemplateDeletedDescription: 'Template {templateId} eliminato',
        EmailwerkTemplateDeleteErrorDescription:
          "Errore durante l'eliminazione del template {templateId}",
        EmailwerkTemplateServerPreviewErrorDescription:
          "Errore durante il rendering dell'anteprima server",
        EmailwerkTemplateCopiedTitle: 'Copiato!',
        EmailwerkTemplateCopiedDescription:
          'ID template {templateId} copiato negli appunti',
        EmailwerkTemplateHeading: 'Template email',
        EmailwerkTemplateIdAddon: 'ID template',
        EmailwerkTemplateCopyIdAriaLabel: 'Copia ID template',
        EmailwerkTemplateDescriptionLabel: 'Descrizione',
        EmailwerkTemplateParentLabel: 'Genitore',
        EmailwerkTemplateParentPlaceholder: 'Nessun template',
        EmailwerkTemplateEngineLabel: 'Engine',
        EmailwerkTemplateVerifyReplyToLabel: 'Verifica Rispondi a',
        EmailwerkTemplateLinkedLabel: 'Collegati',
        EmailwerkTemplateNoLinkedTemplates: 'Nessun template collegato',
        EmailwerkTemplateEnvelopeHeading: 'Busta',
        EmailwerkTemplateSubjectLabel: 'Oggetto',
        EmailwerkTemplateToHeading: 'A',
        EmailwerkTemplateDeleteToFieldAriaLabel: 'Elimina campo destinatario',
        EmailwerkTemplateEmailAddressPlaceholder:
          'Inserisci un indirizzo email',
        EmailwerkTemplateAddToButton: 'Aggiungi destinatario',
        EmailwerkTemplateReplyToLabel: 'Rispondi a',
        EmailwerkTemplateContentHeading: 'Contenuto',
        EmailwerkTemplatePreviewHeading: 'Anteprima',
        EmailwerkTemplateRenderedPreviewHeading: 'Anteprima renderizzata',
        EmailwerkTemplateRenderPreviewButton: 'Genera anteprima',
        EmailwerkTemplateVariablesHeading: 'Variabili',
        EmailwerkTemplateVariablesTableName: 'Nome',
        EmailwerkTemplateVariablesTableType: 'Tipo',
        EmailwerkTemplateVariablesTableDescription: 'Descrizione',
        EmailwerkTemplateVariablesTableDefaultValue: 'Valore predefinito',
        EmailwerkTemplateVariablesTableRequired: 'Obbligatoria',
        EmailwerkTemplateVariablesTableConstant: 'Costante',
        EmailwerkTemplateVariablesRemoveButton: 'Rimuovi',
        EmailwerkTemplateAddVariableButton: 'Aggiungi variabile',
        EmailwerkTemplateDeleteButton: 'Elimina',
        EmailwerkTemplateCancelButton: 'Annulla',
        EmailwerkTemplateSaveButton: 'Salva',
        EmailwerkEmailPageTitle: 'Email',
        EmailwerkEmailBreadcrumbsEmail: 'Email',
        EmailwerkEmailValidationTemplateRequired: 'Il template è obbligatorio',
        EmailwerkEmailValidationSubjectRequired: "L'oggetto è obbligatorio",
        EmailwerkEmailValidationMessageRequired: 'Il messaggio è obbligatorio',
        EmailwerkEmailValidationToRequired: 'Il destinatario è obbligatorio',
        EmailwerkEmailValidationInvalidEmail:
          'Uno o più indirizzi email non validi',
        EmailwerkEmailValidationInvalidBccEmail:
          'Uno o più indirizzi email BCC non validi',
        EmailwerkEmailValidationConsentRequired: 'Il consenso è obbligatorio.',
        EmailwerkEmailTemplatesNotFound: 'Nessun template trovato',
        EmailwerkEmailTemplatesFetchGraphqlError:
          'Impossibile recuperare i template a causa di un errore GraphQL.',
        EmailwerkEmailTemplatesFetchUnknownError:
          'Si è verificato un errore sconosciuto durante il recupero dei template.',
        EmailwerkEmailTemplatesFetchErrorTitle:
          'Errore durante il recupero dei template',
        EmailwerkEmailTemplatesFetchErrorDescription:
          'Si è verificato un errore durante il recupero dei template.',
        EmailwerkEmailMessagePlaceholder: 'Inserisci qui il tuo messaggio',
        EmailwerkEmailPreviewNoContent: 'Nessun contenuto disponibile',
        EmailwerkEmailNoTemplateSelectedError: 'Nessun template selezionato.',
        EmailwerkEmailSendFailedTitle: 'Invio email non riuscito',
        EmailwerkEmailSentTitle: 'Email inviata',
        EmailwerkEmailSentDescription: "L'email è stata inviata con successo.",
        EmailwerkEmailSubmissionErrorTitle: 'Errore di invio',
        EmailwerkEmailUnexpectedError: 'Si è verificato un errore imprevisto.',
        EmailwerkEmailFormHeading: 'Invia email',
        EmailwerkEmailPreviewButton: 'Anteprima',
        EmailwerkEmailTemplateLabel: 'Template email',
        EmailwerkEmailTemplatesLoading: 'Caricamento dei template...',
        EmailwerkEmailErrorAlertTitle: 'Errore!',
        EmailwerkEmailNoTemplatesAlertTitle: 'Nessun template trovato!',
        EmailwerkEmailNoTemplatesAlertDescription:
          'Non ci sono template email disponibili. Creane prima uno.',
        EmailwerkEmailTemplateSelectPlaceholder: 'Seleziona un template email',
        EmailwerkEmailUnnamedTemplate: 'Template senza nome',
        EmailwerkEmailTemplateHelperText: "Il template dell'email.",
        EmailwerkEmailToLabel: 'A',
        EmailwerkEmailToPlaceholder: 'jane.doe@snek.at',
        EmailwerkEmailToHelperText:
          "Il destinatario o i destinatari dell'email. Aggiungi più destinatari separandoli con una virgola.",
        EmailwerkEmailSubjectLabel: 'Oggetto',
        EmailwerkEmailSubjectPlaceholder: 'Ciao',
        EmailwerkEmailSubjectHelperText: "L'oggetto dell'email.",
        EmailwerkEmailMessageLabel: 'Messaggio',
        EmailwerkEmailEditorBold: 'Grassetto',
        EmailwerkEmailEditorItalic: 'Corsivo',
        EmailwerkEmailEditorUnderline: 'Sottolineato',
        EmailwerkEmailEditorHeading1: 'Titolo 1',
        EmailwerkEmailEditorHeading2: 'Titolo 2',
        EmailwerkEmailEditorHeading3: 'Titolo 3',
        EmailwerkEmailEditorBulletList: 'Elenco puntato',
        EmailwerkEmailEditorOrderedList: 'Elenco numerato',
        EmailwerkEmailEditorQuote: 'Citazione',
        EmailwerkEmailEditorSetLink: 'Inserisci link',
        EmailwerkEmailEditorUnsetLink: 'Rimuovi link',
        EmailwerkEmailEditorLinkPrompt: "Inserisci l'URL",
        EmailwerkEmailMessageHelperText: "Il messaggio dell'email.",
        EmailwerkEmailBccLabel: 'BCC',
        EmailwerkEmailBccPlaceholder: 'john.doe@snek.at',
        EmailwerkEmailBccHelperText:
          "Destinatari nascosti aggiuntivi dell'email. Aggiungi più destinatari separandoli con una virgola.",
        EmailwerkEmailConsentLabel:
          'Selezionando questa casella accetti che, facendo clic sul pulsante "Invia", verrà inviata un\'email.',
        EmailwerkEmailSendButton: 'Invia',
        EmailwerkEmailPreviewTitle: 'Anteprima email',
        EmailwerkEmailPreviewNoTemplate: 'Nessun template selezionato',
        EmailwerkEmailPreviewNoSubject: 'Nessun oggetto',
        EmailwerkEmailPreviewCloseButton: 'Chiudi',
        EmailwerkSenderModalSubmitError:
          "Si è verificato un errore durante l'invio del modulo.",
        EmailwerkSenderModalUnknownError:
          'Si è verificato un errore sconosciuto.',
        EmailwerkSenderModalActionFailed: 'Azione sul mittente non riuscita.',
        EmailwerkSenderModalOpenButton: 'Gestisci mittenti',
        EmailwerkSenderModalTitle: 'Mittenti',
        EmailwerkSenderModalErrorAlertTitle: 'Errore!',
        EmailwerkSenderModalColumnAddress: 'Indirizzo',
        EmailwerkSenderModalColumnTransport: 'Trasporto',
        EmailwerkSenderModalBadgeDefault: 'predefinito',
        EmailwerkSenderModalBadgeDisabled: 'disattivato',
        EmailwerkSenderModalMakeDefaultButton: 'Imposta come predefinito',
        EmailwerkSenderModalVerifyButton: 'Verifica',
        EmailwerkSenderModalDeleteButton: 'Elimina',
        EmailwerkSenderModalEmpty: 'Nessun mittente configurato.',
        EmailwerkSenderModalAddHeading: 'Aggiungi mittente SMTP',
        EmailwerkSenderModalValidationAddressRequired:
          "L'indirizzo è obbligatorio",
        EmailwerkSenderModalAddressLabel: 'Indirizzo email',
        EmailwerkSenderModalAddressPlaceholder: 'noreply@example.com',
        EmailwerkSenderModalDisplayNameLabel: 'Nome visualizzato',
        EmailwerkSenderModalValidationHostRequired:
          "L'host SMTP è obbligatorio",
        EmailwerkSenderModalHostLabel: 'Host SMTP',
        EmailwerkSenderModalValidationPortRequired:
          'La porta SMTP è obbligatoria',
        EmailwerkSenderModalPortLabel: 'Porta SMTP',
        EmailwerkSenderModalSecureLabel: 'Sicuro',
        EmailwerkSenderModalValidationUsernameRequired:
          'Il nome utente SMTP è obbligatorio',
        EmailwerkSenderModalUsernameLabel: 'Nome utente SMTP',
        EmailwerkSenderModalValidationPasswordRequired:
          'La password SMTP è obbligatoria',
        EmailwerkSenderModalPasswordLabel: 'Password SMTP',
        EmailwerkSenderModalIsDefaultLabel: 'Imposta come mittente predefinito',
        EmailwerkSenderModalCreateButton: 'Crea mittente',
        EmailwerkSenderModalCloseButton: 'Chiudi'
      }
    }
  }

  if (code === 'ja-JP') {
    return {
      code,
      strings: {
        Language: '日本語',

        AuthLogin: 'ログイン',
        AuthSignup: '新規登録',
        AuthLogout: 'ログアウト',
        AuthSettings: '設定',

        CmsLabelsRoot: 'CMS',

        CmsDashboardTitle: 'Jaen CMS',
        CmsDashboardMenuLabel: 'ダッシュボード',
        CmsDashboardMenuGroupLabel: 'Jaen CMS',

        CmsFrameStartEditing: '編集を開始',
        CmsFrameStopEditing: '編集を終了',
        CmsFrameSaveDraft: '下書きを保存',
        CmsFrameImportDraft: '下書きをインポート',
        CmsFrameDiscardChanges: '変更を破棄',
        CmsFrameDiscardAll: '破棄',
        CmsFrameDiscardAllTitle: '未公開の変更をすべて破棄',
        CmsFrameDiscardAllConfirm:
          '{pages, plural, other {#ページ}}の未公開の変更{fields, plural, other {#件}}が全員分取り消されます{who}{when}。サイトは最後の公開の状態に戻ります。',
        CmsFrameDiscardAllConfirmWho: '（作成者: {editors}）',
        CmsFrameDiscardAllConfirmWhen: '（{since} 以降）',
        CmsFrameDiscardAllConfirmText: 'すべて破棄',
        CmsFrameDiscardAllCancelText: '編集を続ける',
        CmsFrameDiscardNothing: '下書きと公開済みの内容に違いはありません。',
        CmsFrameDiscardedTitle: '未公開の変更が破棄されました',
        CmsFrameDiscardedDescription:
          '{who} が {at} にこのサイトの未公開の変更をすべて破棄しました。表示されているのは公開済みの内容です。',
        CmsFrameDiscardedByAnAdmin: '管理者',
        CmsFrameSaveStateSaving: '保存中',
        CmsFrameSaveStateSaved: '{at} に保存',
        CmsFrameSaveStateSavedUnpublished: '{at} に保存、未公開',
        CmsFramePublished: 'すべて公開済み',
        CmsFrameSaveStateOffline: 'オフライン、{count} 件の変更が待機中',
        CmsFrameSaveStateError: '保存に失敗しました。再試行します',
        CmsFrameSaveStatePending: 'まだ保存されていません',
        CmsFramePublish:
          '{isPublishing, select, true {公開処理中} other {変更を公開}}',
        CmsFrameNewMedia: '新規メディア',
        CmsFrameGuest: 'ゲスト',
        CmsFrameNotificationsEditModeTitle: '編集モード',
        CmsFrameNotificationsEditModeOn: 'ページを編集できるようになりました',
        CmsFrameNotificationsEditModeOff: 'ページを編集できなくなりました',
        CmsFrameNotificationsSaved: '保存しました',
        CmsFrameNotificationsSavedDescription: '変更を保存しました',
        CmsFrameNotificationsImported: 'インポートしました',
        CmsFrameNotificationsImportedDescription: '変更をインポートしました',
        CmsFrameNotificationsImportFailed: 'インポートに失敗しました',
        CmsFrameNotificationsImportFailedDescription:
          '変更をインポートできませんでした',
        CmsFrameNotificationsDiscarded: '破棄しました',
        CmsFrameNotificationsDiscardedDescription: '変更を破棄しました',

        CmsPagesTitle: 'Jaen CMS | ページ',
        CmsPagesMenuLabel: 'ページ',

        CmsPagesBreadcrumbsPages: 'ページ',
        CmsPagesBreadcrumbsNew: '新規',

        CmsPagesNotificationsCreated: 'ページを作成しました',
        CmsPagesNotificationsCreatedDescription:
          'ページ「{title}」を作成しました',
        CmsPagesNotificationsUpdated: 'ページを更新しました',
        CmsPagesNotificationsUpdatedDescription:
          'ページ「{title}」を更新しました',
        CmsPagesNotificationsDeleted: 'ページを削除しました',
        CmsPagesNotificationsDeletedDescription:
          'ページ「{slug}」を削除しました',
        CmsPagesNotificationsDuplicated: 'ページを複製しました',
        CmsPagesNotificationsDuplicatedDescription:
          'ページ「{slug}」を複製しました',
        CmsPagesNotificationsMoved: 'ページを移動しました',
        CmsPagesNotificationsMovedDescription: 'ページ「{slug}」を移動しました',
        CmsPagesNotificationsSlugUpdated: 'スラッグを更新しました',
        CmsPagesNotificationsSlugUpdatedDescription:
          'スラッグを {slug} に更新しました',
        CmsPagesNotificationsDuplicateFailed: 'ページを複製できませんでした',
        CmsPagesNotificationsMoveFailed: 'ページを移動できませんでした',
        CmsPagesNotificationsSlugUpdateFailed: 'スラッグを更新できませんでした',

        CmsPagesActionsDuplicate: 'ページを複製',
        CmsPagesActionsMove: 'ページを移動',
        CmsPagesActionsUpdateSlug: 'スラッグを更新',
        CmsPagesActionsRenameSlug: 'スラッグを変更',
        CmsPagesActionsDelete: 'ページを削除',
        CmsPagesActionsDeleteThis: 'このページを削除',

        CmsPagesDescriptionsDuplicate:
          'この操作により、ページとそのサブページが複製されます。',
        CmsPagesDescriptionsMove:
          'この操作により、ページとすべてのサブページが移動されます。',
        CmsPagesDescriptionsUpdateSlug:
          'この操作によりスラッグが変更され、このページとすべてのサブページのパスに影響します。',
        CmsPagesDescriptionsDelete:
          'この操作により、ページとすべてのサブページが削除されます。',

        CmsPagesPromptsDuplicateTitle: 'ページを複製',
        CmsPagesPromptsDuplicateMessage:
          '複製するページの新しいスラッグを入力してください。パスに影響します。',
        CmsPagesPromptsDuplicateConfirm: '複製',
        CmsPagesPromptsDuplicateCancel: 'キャンセル',
        CmsPagesPromptsDuplicatePlaceholder: '{slug}-copy',

        CmsPagesPromptsMoveTitle: 'ページを移動',
        CmsPagesPromptsMoveMessage: '新しい親ページを選択してください。',
        CmsPagesPromptsMoveConfirm: '移動',
        CmsPagesPromptsMoveCancel: 'キャンセル',

        CmsPagesPromptsRenameSlugTitle: 'スラッグを変更',
        CmsPagesPromptsRenameSlugMessage:
          '新しいスラッグを入力してください。パスに影響します。',
        CmsPagesPromptsRenameSlugConfirm: '変更',
        CmsPagesPromptsRenameSlugCancel: 'キャンセル',

        CmsPagesPromptsDeleteTitle: 'ページを削除',
        CmsPagesPromptsDeleteMessage:
          'このページとすべてのサブページを削除してもよろしいですか？',
        CmsPagesPromptsDeleteConfirm: '削除',

        CmsPagesTableSubpagesHeading: 'サブページ',
        CmsPagesTableReorderEnable: '並べ替え',
        CmsPagesTableReorderDisable: '完了',
        CmsPagesTableNewPage: '新規ページ',
        CmsPagesTableColumnsTitle: 'タイトル',
        CmsPagesTableColumnsDescription: '説明',
        CmsPagesTableColumnsDate: '日付',
        CmsPagesTableEmptyStateDescription:
          'このページにはまだサブページがありません。',
        CmsPagesTableEmptyStateAction: '新しいページを作成',
        CmsPagesTableDateCreated: '作成日時: {date} {time}',
        CmsPagesTableDateUpdated: '最終更新日時: {date} {time}',
        CmsPagesTableDateEmpty: '-',
        CmsPagesTableReorderError: 'ページの並べ替え中に問題が発生しました。',
        CmsPagesTableDangerZoneHeading: '危険な操作',

        CmsPagesLabelsNoTitle: 'タイトルなし',
        CmsPagesLabelsNoDescription: '説明なし',
        CmsPagesLabelsFallbackTitle: 'ページ',
        CmsPagesLabelsYes: 'はい',

        CmsPagesFormHeadingCreate: '新規ページの作成',
        CmsPagesFormHeadingEdit: 'ページの編集',
        CmsPagesFormLeadCreate:
          'ページとは、特定の URL に表示されるフィールドやブロックの構成を指します。',
        CmsPagesFormLeadEdit:
          'ページを編集します。SEO と SNS でのプレゼンスを高めましょう。',
        CmsPagesFormTemplateCreate: '新規ページのテンプレートを選択',
        CmsPagesFormTemplateEdit: 'このページに使用されているテンプレート',
        CmsPagesFormTemplateHelperTextCreate:
          'このテンプレートは、親ページに基づいて新規ページに適用されます。',
        CmsPagesFormTemplateHelperTextEdit:
          'テンプレートを変更する場合は、新しいページを作成してコンテンツを移行してください。',
        CmsPagesFormTitleCreate: '新規ページのタイトルを入力',
        CmsPagesFormTitleEdit: 'ページのタイトル',
        CmsPagesFormTitleHelperTextCreate:
          '新規ページのタイトルです。URL スラッグはタイトルから自動的に生成されます。',
        CmsPagesFormTitleHelperTextEdit: 'ページのタイトルです。',
        CmsPagesFormDescriptionCreate: '新規ページの説明を入力',
        CmsPagesFormDescriptionEdit: 'ページの説明',
        CmsPagesFormDescriptionHelperTextCreate:
          '説明は検索エンジンや SNS で使用されます。160〜165 文字を目安にしてください。',
        CmsPagesFormDescriptionHelperTextEdit:
          '説明は検索エンジンや SNS で使用されます。160〜165 文字を目安にしてください。',
        CmsPagesFormParentPageCreate: '親ページを選択',
        CmsPagesFormParentPageEdit: 'このページの親ページ',
        CmsPagesFormParentHelperTextCreate: '新規ページの親ページとなります。',
        CmsPagesFormParentHelperTextEdit:
          'より適切な親ページにページを移動することもできます。',
        CmsPagesFormImageCreate: '画像',
        CmsPagesFormImageEdit: '画像',
        CmsPagesFormImageHelperTextCreate:
          'ページに画像を設定します。未設定の場合は、親ページまたはサイトの画像が使用されます。',
        CmsPagesFormImageHelperTextEdit:
          'ページの画像です。未設定の場合は、親ページまたはサイトの画像が使用されます。',
        CmsPagesFormPostCreate: '投稿として設定',
        CmsPagesFormPostEdit: '投稿',
        CmsPagesFormPostHelperTextCreate:
          'このページを投稿として設定すると、日付と著者のフィールドが追加されます。',
        CmsPagesFormPostHelperTextEdit:
          'このページを投稿として設定すると、日付と著者のフィールドが追加されます。',
        CmsPagesFormPostDateCreate: '新規ページの日付を入力',
        CmsPagesFormPostDateEdit: 'ページの公開日',
        CmsPagesFormPostDateHelperTextCreate:
          '日付は投稿の並べ替えに使用されます。',
        CmsPagesFormPostDateHelperTextEdit:
          '日付は投稿の並べ替えに使用されます。',
        CmsPagesFormPostAuthorCreate: '新規ページの著者を入力',
        CmsPagesFormPostAuthorEdit: 'ページの著者',
        CmsPagesFormPostAuthorHelperTextCreate:
          '投稿の著者として表示されます。',
        CmsPagesFormPostAuthorHelperTextEdit: '投稿の著者として表示されます。',
        CmsPagesFormPostCategoryCreate: '新規ページのカテゴリーを入力',
        CmsPagesFormPostCategoryEdit: 'ページのカテゴリー',
        CmsPagesFormPostCategoryHelperTextCreate:
          'カテゴリーは投稿の分類に使用されます。',
        CmsPagesFormPostCategoryHelperTextEdit:
          'カテゴリーは投稿の分類に使用されます。',
        CmsPagesFormExcludeFromIndexCreate: 'インデックスから除外',
        CmsPagesFormExcludeFromIndexEdit: 'インデックスから除外',
        CmsPagesFormExcludeFromIndexHelperTextCreate:
          'このページをすべてのインデックスフィールド（ページが一覧表示される場所など）から除外します。',
        CmsPagesFormExcludeFromIndexHelperTextEdit:
          'このページをすべてのインデックスフィールド（ページが一覧表示される場所など）から除外します。',
        CmsPagesFormPlaceholdersTitle: 'タイトル',
        CmsPagesFormPlaceholdersSlug: 'slug',
        CmsPagesFormPlaceholdersDescription: '説明',
        CmsPagesFormPlaceholdersAuthor: '著者',
        CmsPagesFormPlaceholdersCategory: 'カテゴリー',
        CmsPagesFormHelperMediaDescription:
          '組織を表す写真をアップロードしてください。',
        CmsPagesFormErrorsSlugInUse: 'このスラッグはすでに使用されています',
        CmsPagesFormErrorsParentRequired: '親ページは必須です',
        CmsPagesFormErrorsTemplateRequired: 'テンプレートは必須です',
        CmsPagesFormErrorsDateRequired: 'ブログ投稿には日付が必須です',
        CmsPagesFormErrorsAuthorRequired: 'ブログ投稿には著者が必須です',
        CmsPagesFormButtonsPreview: 'プレビュー',
        CmsPagesFormButtonsEdit: 'ページを編集',
        CmsPagesFormButtonsCancel: 'キャンセル',
        CmsPagesFormButtonsCreate: 'ページを作成',
        CmsPagesFormButtonsSave: 'ページを保存',

        CmsMediaTitle: 'Jaen CMS | メディア',
        CmsMediaMenuLabel: 'メディア',
        CmsMediaBreadcrumbsMedia: 'メディア',

        CmsSettingsTitle: 'Jaen CMS | 設定',
        CmsSettingsMenuLabel: '設定',
        CmsSettingsBreadcrumbsSettings: '設定',
        CmsSettingsNotificationsUpdated: '設定を更新しました',
        CmsSettingsFormHeading: '設定',
        CmsSettingsFormSiteInfoGroupTitle: 'サイト情報',
        CmsSettingsFormSiteInfoTitleLabel: 'タイトル',
        CmsSettingsFormSiteInfoTitlePlaceholder: 'タイトル',
        CmsSettingsFormSiteInfoTitleTooLong: 'タイトルが長すぎます',
        CmsSettingsFormSiteInfoUrlLabel: 'URL',
        CmsSettingsFormSiteInfoUrlPlaceholder: 'https://snek.at',
        CmsSettingsFormSiteInfoUrlInvalid:
          'URL は http:// または https:// で始まる必要があります',
        CmsSettingsFormSiteInfoDescriptionLabel: '説明',
        CmsSettingsFormSiteInfoDescriptionPlaceholder:
          '検索エンジンや SNS に表示される説明です。',
        CmsSettingsFormSiteInfoDescriptionHelper: 'サイトの簡単な説明です。',
        CmsSettingsFormSiteInfoImageLabel: '画像',
        CmsSettingsFormSiteInfoImageDescription:
          'サイトを表す写真をアップロードしてください。',
        CmsSettingsFormOrganisationGroupTitle: '組織',
        CmsSettingsFormOrganisationNameLabel: '名前',
        CmsSettingsFormOrganisationNamePlaceholder: 'Snek',
        CmsSettingsFormOrganisationNameTooLong: '名前が長すぎます',
        CmsSettingsFormOrganisationUrlLabel: 'URL',
        CmsSettingsFormOrganisationUrlPlaceholder: 'https://snek.at',
        CmsSettingsFormOrganisationUrlInvalid:
          'URL は http:// または https:// で始まる必要があります',
        CmsSettingsFormOrganisationLogoLabel: '画像',
        CmsSettingsFormOrganisationLogoDescription:
          '組織を表す写真をアップロードしてください。',
        CmsSettingsFormCancel: 'キャンセル',
        CmsSettingsFormSave: '保存',

        CmsDebugTitle: 'Jaen CMS | デバッグ',
        CmsDebugBreadcrumbsDebug: 'デバッグ',

        CmsNotificationTitle: 'Jaen CMS | 通知',
        CmsNotificationMenuLabel: 'ポップアップ',
        CmsNotificationBreadcrumbsPopup: 'ポップアップ',
        CmsNotificationCardTitle: '通知ポップアップ',
        CmsNotificationCardDescription:
          '通知ポップアップを設定します。ユーザーがページを訪れたときに通知が表示されます。',
        CmsNotificationPreview: 'プレビュー',
        CmsNotificationNotificationsUpdated: '通知を更新しました',
        CmsNotificationNotificationsUpdatedDescription: '通知が更新されました',
        CmsNotificationFormTitleLabel: 'タイトル',
        CmsNotificationFormTitlePlaceholder: 'お知らせ',
        CmsNotificationFormTitleDescription: '通知のタイトルです。',
        CmsNotificationFormMessageLabel: 'メッセージ',
        CmsNotificationFormMessageExample: 'これはサンプルメッセージです',
        CmsNotificationFormMessageDescription: '通知のメッセージです。',
        CmsNotificationFormEnterUrl: 'URL を入力してください',
        CmsNotificationFormFromLabel: '開始日',
        CmsNotificationFormFromDescription:
          'この日付<b>以降</b>に通知が表示されます。',
        CmsNotificationFormToLabel: '終了日',
        CmsNotificationFormToDescription:
          'この日付<b>まで</b>通知が表示されます。',
        CmsNotificationFormPickDate: '日付を選択',
        CmsNotificationFormEnabledLabel:
          'ユーザーがページを訪れたときに通知ポップアップを表示する',
        CmsNotificationFormSubmit: '送信',

        // Accounts
        CmsAccountsErrorsLoadService:
          'ID サービスからユーザーを読み込めませんでした。',
        CmsAccountsErrorsLoadGeneric: 'ユーザーを読み込めませんでした。',
        CmsAccountsNotificationsCreated: 'アカウントを作成しました',
        CmsAccountsNotificationsCreatedDescription:
          'アカウント「{username}」を作成しました',
        CmsAccountsNotificationsCreateFailed:
          'アカウントを作成できませんでした',
        CmsAccountsTitle: 'アカウント',
        CmsAccountsPageTitle: 'Jaen CMS | アカウント',
        CmsAccountsMenuLabel: 'アカウント',
        CmsAccountsBreadcrumbsAccounts: 'アカウント',
        CmsAccountsSubtitle:
          'ID テナントのユーザーアカウントを閲覧・管理します。',
        CmsAccountsActionsCreate: '新規アカウント',
        CmsAccountsSearchPlaceholder: '名前、メールアドレス、ログイン名で検索',
        CmsAccountsErrorsLoadTitle: 'アカウントを読み込めません',
        CmsAccountsCardUnnamed: '名前のないユーザー',
        CmsAccountsCardNoEmail: 'メールアドレス未設定',
        CmsAccountsCardUsername: 'ユーザー名',
        CmsAccountsCardLoginNames: 'ログイン名',
        CmsAccountsCardNoLoginNames: '別のログイン名はありません',
        CmsAccountsCardManage: 'アカウントを管理',
        CmsAccountsEmptyTitle: '検索に一致するアカウントがありません',
        CmsAccountsEmptyHint:
          '検索条件を変更するか、新しいアカウントを作成してください。',
        CmsAccountsCreateTitle: '新規アカウントの作成',
        CmsAccountsCreateUsername: 'ユーザー名',
        CmsAccountsCreateEmail: 'メールアドレス',
        CmsAccountsCreateFirstName: '名',
        CmsAccountsCreateLastName: '姓',
        CmsAccountsCreateInitialPassword: '初期パスワード（任意）',
        CmsAccountsCreateSendReset:
          'パスワードが未設定の場合、パスワードリセットメールを送信する',
        CmsAccountsActionsCancel: 'キャンセル',
        CmsAccountsActionsCreateSubmit: 'アカウントを作成',
        CmsAccountsErrorsDetailService:
          'ID サービスからユーザープロフィールを読み込めませんでした。',
        CmsAccountsErrorsDetailGeneric:
          'ユーザープロフィールを読み込めませんでした。',
        CmsAccountsNotificationsActionFailed: '操作に失敗しました',
        CmsAccountsNotificationsSaved: '変更を保存しました',
        CmsAccountsNotificationsSavedDescription:
          'プロフィールを更新しました。',
        CmsAccountsNotificationsSaveFailed: '保存に失敗しました',
        CmsAccountsNotificationsDeleted: 'アカウントを削除しました',
        CmsAccountsNotificationsPasswordSet: 'パスワードを設定しました',
        CmsAccountsNotificationsRolesUpdated: 'ロールを更新しました',
        CmsAccountsDetailBack: 'アカウント一覧に戻る',
        CmsAccountsErrorsDetailTitle: 'このアカウントを読み込めません',
        CmsAccountsDetailNoEmail: 'プライマリメールアドレスが未設定です',
        CmsAccountsDetailUsername: 'ユーザー名',
        CmsAccountsDetailPreferredLogin: '優先ログイン名',
        CmsAccountsDetailState: 'アカウントの状態',
        CmsAccountsDetailCreated: '作成日時',
        CmsAccountsDetailLastChange: '最終更新日時',
        CmsAccountsDetailResourceOwner: '組織',
        CmsAccountsProfileTitle: 'プロフィール',
        CmsAccountsProfileDisplayName: '表示名',
        CmsAccountsProfileLanguage: '優先言語',
        CmsAccountsProfileFirstName: '名',
        CmsAccountsProfileLastName: '姓',
        CmsAccountsProfileEmail: 'メールアドレス',
        CmsAccountsProfilePhone: '電話番号',
        CmsAccountsProfileReset: 'リセット',
        CmsAccountsProfileSave: '変更を保存',
        CmsAccountsRolesTitle: 'プロジェクトロール',
        CmsAccountsRolesGrant: 'ロールを付与',
        CmsAccountsRolesEdit: '編集',
        CmsAccountsNotificationsRolesRevoked: 'ロールを取り消しました',
        CmsAccountsRolesRevoke: '取り消し',
        CmsAccountsRolesEmpty: '付与されたプロジェクトロールはありません。',
        CmsAccountsActionsTitle: 'アカウント操作',
        CmsAccountsActionsSetPassword: 'パスワードを設定',
        CmsAccountsNotificationsResetRequested:
          'パスワードリセットをリクエストしました',
        CmsAccountsActionsRequestReset: 'パスワードリセットをリクエスト',
        CmsAccountsNotificationsVerificationSent: '確認メールを送信しました',
        CmsAccountsActionsResendVerification: '確認メールを再送信',
        CmsAccountsNotificationsDeactivated: 'アカウントを無効化しました',
        CmsAccountsActionsDeactivate: '無効化',
        CmsAccountsNotificationsReactivated: 'アカウントを再有効化しました',
        CmsAccountsActionsReactivate: '再有効化',
        CmsAccountsNotificationsUnlocked: 'アカウントのロックを解除しました',
        CmsAccountsActionsUnlock: 'ロック解除',
        CmsAccountsNotificationsLocked: 'アカウントをロックしました',
        CmsAccountsActionsLock: 'ロック',
        CmsAccountsActionsDelete: 'アカウントを削除',
        CmsAccountsDeleteTitle: 'アカウントを削除',
        CmsAccountsDeletePrompt:
          '「{username}」を削除してもよろしいですか？この操作は元に戻せません。',
        CmsAccountsPasswordTitle: '新しいパスワードの設定',
        CmsAccountsPasswordNew: '新しいパスワード',
        CmsAccountsPasswordChangeRequired:
          '次回ログイン時にパスワードの変更を必須にする',
        CmsAccountsRolesEditTitle: '付与されたロールの編集',
        CmsAccountsRolesGrantTitle: 'プロジェクトロールの付与',
        CmsAccountsRolesProject: 'プロジェクト',
        CmsAccountsRolesNoneAvailable:
          'このプロジェクトで利用可能なロールはありません。',
        CmsAccountsRolesSave: 'ロールを保存',
        SettingsTabGeneral: '一般',
        SettingsTabPasswordSecurity: 'パスワードとセキュリティ',
        SettingsProfileGenderUnspecified: '未指定',
        SettingsProfileGenderMale: '男性',
        SettingsProfileGenderFemale: '女性',
        SettingsProfileGenderOther: 'その他',
        SettingsUsernamePromptTitle: 'ユーザー名を変更',
        SettingsUsernamePromptMessage: '新しいユーザー名を入力してください',
        SettingsEmailPromptTitle: 'メールアドレスを変更',
        SettingsEmailPromptMessage: '新しいメールアドレスを入力してください',
        SettingsPhonePromptTitle: '電話番号を変更',
        SettingsPhonePromptMessage: '新しい電話番号を入力してください',
        SettingsPhoneDeleteConfirmTitle: '電話番号を削除',
        SettingsPhoneDeleteConfirmMessage:
          '電話番号を削除してもよろしいですか？',
        SettingsPhoneVerifyPromptTitle: '電話番号を確認',
        SettingsPhoneVerifyPromptMessage: '確認コードを入力してください',
        SettingsProfileTitle: 'プロフィール',
        SettingsProfileAvatarNoFileSelected: 'ファイルが選択されていません',
        SettingsProfileUsernameLabel: 'ユーザー名',
        SettingsProfileUsernameEditAriaLabel: 'ユーザー名を編集',
        SettingsProfileFirstNameLabel: '名',
        SettingsProfileLastNameLabel: '姓',
        SettingsProfileNicknameLabel: 'ニックネーム',
        SettingsProfileFullNameLabel: '氏名',
        SettingsProfileGenderLabel: '性別',
        SettingsProfileLanguageLabel: '言語',
        SettingsProfileLanguageNotSet: '未設定',
        SettingsSaveButton: '保存',
        SettingsContactTitle: '連絡先情報',
        SettingsContactRefreshAriaLabel: '再読み込み',
        SettingsContactDescription:
          '登録された連絡先は、パスワードリセットメールなどの重要なお知らせの送信に使用されます。',
        SettingsContactEmailLabel: 'メールアドレス',
        SettingsContactEmailEditAriaLabel: 'メールアドレスを編集',
        SettingsContactVerified: '確認済み',
        SettingsContactNotVerified: '未確認',
        SettingsContactResendCodeButton: 'コードを再送信',
        SettingsContactPhoneLabel: '電話番号',
        SettingsContactPhoneDeleteAriaLabel: '電話番号を削除',
        SettingsContactPhoneEditAriaLabel: '電話番号を編集',
        SettingsContactVerifyButton: '確認',
        SettingsContactPhoneAddAriaLabel: '電話番号を追加',
        SettingsContactPhoneNone: '電話番号が登録されていません',
        SettingsPasswordTitle: 'パスワード',
        SettingsPasswordPolicyIntro:
          '以下のポリシーに従って新しいパスワードを入力してください。',
        SettingsPasswordCurrentLabel: '現在のパスワード',
        SettingsPasswordCurrentPlaceholder: '新しいパスワード',
        SettingsPasswordPolicyMinLength:
          '{minLength} 文字以上である必要があります。（{length} / {minLength}）',
        SettingsPasswordPolicySymbol:
          '記号または句読点を含める必要があります。',
        SettingsPasswordPolicyNumber: '数字を含める必要があります。',
        SettingsPasswordPolicyUppercase: '大文字を含める必要があります。',
        SettingsPasswordPolicyLowercase: '小文字を含める必要があります。',
        SettingsPasswordPolicyMatch: 'パスワードが一致しています。',
        SettingsPasswordNewLabel: '新しいパスワード',
        SettingsPasswordNewPlaceholder: '新しいパスワード',
        SettingsPasswordConfirmLabel: 'パスワードの確認',
        SettingsPasswordConfirmPlaceholder: 'パスワードを再入力',
        SettingsPasswordResetButton: '現在のパスワードをリセット',
        SettingsPasswordCancelButton: 'キャンセル',
        SettingsPasswordHint: '安全なパスワードはアカウントの保護に役立ちます',
        SettingsPasswordEditAriaLabel: 'メールアドレスを編集',
        ProfileFormTitle: 'アカウント',
        ProfileFormFirstNameLabel: '名',
        ProfileFormLastNameLabel: '姓',
        ProfileFormUsernameLabel: 'ユーザー名',
        ProfileFormRequiredError: 'この項目は必須です',
        ProfileFormImageLabel: '画像',
        ProfileFormImageDescription:
          'プロフィール画像をアップロードすると、アカウントを見分けやすくなります。',
        ProfileFormUpdateButton: 'アカウントを更新',
        EmailFormTitle: 'メールアドレス',
        EmailFormPrimaryLabel: 'プライマリ',
        EmailFormDeleteAriaLabel: 'メールアドレスを削除',
        EmailFormPrimaryHelpText:
          'プライマリメールアドレスは、パスワードリセットなどアカウントに関する連絡に使用されます。',
        EmailFormUnverifiedLabel: '未確認',
        EmailFormResendVerificationLink: '確認メールを再送信',
        EmailFormAddDescription: 'アカウントにメールアドレスを追加します。',
        EmailFormRequiredError: 'この項目は必須です',
        EmailFormInvalidEmailError: 'メールアドレスが無効です',
        EmailFormEmailPlaceholder: 'メールアドレス',
        EmailFormAddingLoadingText: '追加中...',
        EmailFormAddButton: '追加',
        PasswordFormTitle: 'パスワード',
        PasswordFormPasswordLabel: 'パスワード',
        PasswordFormRequiredError: 'この項目は必須です',
        PasswordFormConfirmPasswordLabel: 'パスワードの確認',
        PasswordFormMismatchError: 'パスワードが一致しません',
        PasswordFormHelpText:
          'パスワードは 15 文字以上、または数字と小文字を含む 8 文字以上にしてください。',
        PasswordFormUpdateButton: 'パスワードを更新',
        PasswordResetTryAnotherEmailButton: '別のメールアドレスを試す',
        PasswordResetBackToWebsiteButton: 'サイトに戻る',
        PasswordResetEmailHeading: 'パスワードのリセット',
        PasswordResetPasswordHeading: '新しいパスワードを入力',
        PasswordResetOtpHeading: 'コードを入力',
        PasswordResetNoAccountPrompt: 'アカウントをお持ちでない方は',
        PasswordResetSignUpLink: '新規登録',
        PasswordResetPasswordDescription:
          '<b>{email}</b> の新しいパスワードを入力してください。',
        PasswordResetOtpDescription:
          '<strong>{email}</strong> にワンタイムパスワード（OTP）を送信しました。',
        PasswordResetStepPasswordPasswordLabel: 'パスワード',
        PasswordResetStepPasswordConfirmPasswordLabel: 'パスワードの確認',
        PasswordResetStepPasswordRequiredError: 'この項目は必須です',
        PasswordResetStepPasswordMismatchError: 'パスワードが一致しません',
        PasswordResetStepPasswordSubmitButton: 'パスワードリセットメールを送信',
        SignupSuccessTitle: '登録が完了しました。',
        SignupSuccessDescription:
          'メールに記載された確認リンクをご確認ください。',
        SignupErrorTitle: '登録できませんでした。',
        SignupBackToWebsiteButton: 'サイトに戻る',
        SignupHeading: 'アカウントを作成',
        SignupAlreadyUserPrompt: 'すでにアカウントをお持ちの方は',
        SignupLoginLink: 'ログイン',
        SignupFirstNameLabel: '名',
        SignupFirstNameRequiredError: '名は必須です',
        SignupLastNameLabel: '姓',
        SignupLastNameRequiredError: '姓は必須です',
        SignupEmailLabel: 'メールアドレス',
        SignupEmailRequiredError: 'メールアドレスは必須です',
        SignupUsernameLabel: 'ユーザー名',
        SignupSubmitButton: '新規登録',
        PasswordFieldLabel: 'パスワード',
        PasswordFieldMaskAriaLabel: 'パスワードを隠す',
        PasswordFieldRevealAriaLabel: 'パスワードを表示',
        PasswordFieldRequiredError: 'パスワードは必須です',
        MediaCloseSidebarAriaLabel: 'サイドバーを閉じる',
        MediaPagesHeading: 'ページ',
        DialogCloseLabel: '閉じる',
        CmsDebugVersionInformationHeading: 'バージョン情報',
        CmsDebugVersionInformationDescription:
          'プロジェクトにインストールされている Gatsby、Jaen、プラグインのバージョン情報を以下に表示します。',
        CmsDebugGatsbyTitle: 'Gatsby',
        CmsDebugGatsbyDescription:
          'Gatsby は、モダンな Web アプリケーションの構築に広く使われている静的サイトジェネレーターです。プロジェクトにインストールされている Gatsby と Gatsby CLI のバージョン情報を以下に表示します。',
        CmsDebugGatsbyVersionLabel: 'Gatsby のバージョン:',
        CmsDebugGatsbyCliVersionLabel: 'Gatsby CLI のバージョン:',
        CmsDebugJaenTitle: 'Jaen',
        CmsDebugJaenDescription:
          'Jaen は、Web サイトのコンテンツを管理するためのヘッドレス CMS です。プロジェクトにインストールされている Jaen のバージョン情報を以下に表示します。',
        CmsDebugJaenVersionLabel: 'Jaen のバージョン:',
        CmsDebugPluginsTitle: 'プラグイン',
        CmsDebugPluginsDescription:
          'プラグインは Web サイトの機能を拡張します。インストールされているプラグインとそのバージョンの一覧を以下に表示します。',
        CmsDebugWidgetsHeading: 'ウィジェット',
        CmsDebugWidgetsDescription:
          'ウィジェットとそのデータの一覧を以下に表示します。これはプレビュー機能であり、今後改善される予定です。',
        CmsDebugWidgetsColumnName: '名前',
        CmsDebugWidgetsColumnCreatedAt: '作成日時',
        CmsDebugWidgetsColumnModifiedAt: '更新日時',
        CmsDebugWidgetsColumnData: 'データ',
        DynamicPageNotFound: 'ページが見つかりません',
        DynamicPageLoading: '読み込み中...',
        FormMediaChooser: 'FormMediaChooser',
        JaenFrameMediaModal: 'JaenFrameMediaModal',
        MediaModal: 'MediaModal',
        EmailwerkTemplatesPageTitle: 'テンプレート',
        EmailwerkBreadcrumbsRoot: 'Emailwerk',
        EmailwerkBreadcrumbsTemplates: 'テンプレート',
        EmailwerkMenuGroupLabel: 'Emailwerk',
        EmailwerkTemplatesLoadFailedTitle:
          'テンプレートを読み込めませんでした（{name}）',
        EmailwerkTemplatesAddPromptTitle: 'テンプレートを追加',
        EmailwerkTemplatesAddPromptMessage:
          '新しいテンプレートの説明を入力してください',
        EmailwerkTemplatesCreateFailedTitle:
          'テンプレートを作成できませんでした',
        EmailwerkTemplatesHeading: 'メールテンプレート',
        EmailwerkTemplatesDefaultSender:
          'デフォルトの送信者: <strong>{address}</strong>',
        EmailwerkTemplatesNoSenderConfigured: '送信者が設定されていません',
        EmailwerkTemplatesSenderVerifiedTitle: '送信者を確認しました',
        EmailwerkTemplatesSenderVerificationFailedTitle: '確認に失敗しました',
        EmailwerkTemplatesAddButton: 'テンプレートを追加',
        EmailwerkTemplatesTableDescription: '説明',
        EmailwerkTemplatesTableSubject: '件名',
        EmailwerkTemplatesTableTo: '宛先',
        EmailwerkTemplatesTableReplyTo: '返信先',
        EmailwerkTemplatesTableUpdatedAt: '更新日時',
        EmailwerkTemplatesTableCreatedAt: '作成日時',
        EmailwerkTemplatesNoTemplatesFound: 'テンプレートが見つかりません',
        EmailwerkTemplateLoadFailedTitle:
          'テンプレートを読み込めませんでした（{name}）',
        EmailwerkTemplateUpdatedTitle: 'テンプレートを更新しました',
        EmailwerkTemplateUpdatedDescription:
          'テンプレート ID {templateId} を更新しました',
        EmailwerkTemplateErrorTitle: 'エラー',
        EmailwerkTemplateUpdateErrorDescription:
          'テンプレート {templateId} を更新できませんでした',
        EmailwerkTemplateDeleteConfirmTitle: 'テンプレートを削除',
        EmailwerkTemplateDeleteConfirmMessage:
          'このテンプレートを削除してもよろしいですか？',
        EmailwerkTemplateDeleteConfirmButton: '削除',
        EmailwerkTemplateDeleteCancelButton: 'キャンセル',
        EmailwerkTemplateDeletedTitle: 'テンプレートを削除しました',
        EmailwerkTemplateDeletedDescription:
          'テンプレート ID {templateId} を削除しました',
        EmailwerkTemplateDeleteErrorDescription:
          'テンプレート {templateId} を削除できませんでした',
        EmailwerkTemplateServerPreviewErrorDescription:
          'サーバープレビューをレンダリングできませんでした',
        EmailwerkTemplateCopiedTitle: 'コピーしました',
        EmailwerkTemplateCopiedDescription:
          'テンプレート ID {templateId} をクリップボードにコピーしました',
        EmailwerkTemplateHeading: 'メールテンプレート',
        EmailwerkTemplateIdAddon: 'テンプレート ID',
        EmailwerkTemplateCopyIdAriaLabel: 'テンプレート ID をコピー',
        EmailwerkTemplateDescriptionLabel: '説明',
        EmailwerkTemplateParentLabel: '親テンプレート',
        EmailwerkTemplateParentPlaceholder: 'テンプレートなし',
        EmailwerkTemplateEngineLabel: 'エンジン',
        EmailwerkTemplateVerifyReplyToLabel: '返信先を確認',
        EmailwerkTemplateLinkedLabel: 'リンク済み',
        EmailwerkTemplateNoLinkedTemplates:
          'リンクされたテンプレートはありません',
        EmailwerkTemplateEnvelopeHeading: 'エンベロープ',
        EmailwerkTemplateSubjectLabel: '件名',
        EmailwerkTemplateToHeading: '宛先',
        EmailwerkTemplateDeleteToFieldAriaLabel: '宛先を削除',
        EmailwerkTemplateEmailAddressPlaceholder: 'メールアドレスを入力',
        EmailwerkTemplateAddToButton: '宛先を追加',
        EmailwerkTemplateReplyToLabel: '返信先',
        EmailwerkTemplateContentHeading: 'コンテンツ',
        EmailwerkTemplatePreviewHeading: 'プレビュー',
        EmailwerkTemplateRenderedPreviewHeading: 'レンダリング済みプレビュー',
        EmailwerkTemplateRenderPreviewButton: 'プレビューをレンダリング',
        EmailwerkTemplateVariablesHeading: '変数',
        EmailwerkTemplateVariablesTableName: '名前',
        EmailwerkTemplateVariablesTableType: '型',
        EmailwerkTemplateVariablesTableDescription: '説明',
        EmailwerkTemplateVariablesTableDefaultValue: 'デフォルト値',
        EmailwerkTemplateVariablesTableRequired: '必須',
        EmailwerkTemplateVariablesTableConstant: '定数',
        EmailwerkTemplateVariablesRemoveButton: '削除',
        EmailwerkTemplateAddVariableButton: '変数を追加',
        EmailwerkTemplateDeleteButton: '削除',
        EmailwerkTemplateCancelButton: 'キャンセル',
        EmailwerkTemplateSaveButton: '保存',
        EmailwerkEmailPageTitle: 'メール',
        EmailwerkEmailBreadcrumbsEmail: 'メール',
        EmailwerkEmailValidationTemplateRequired: 'テンプレートは必須です',
        EmailwerkEmailValidationSubjectRequired: '件名は必須です',
        EmailwerkEmailValidationMessageRequired: 'メッセージは必須です',
        EmailwerkEmailValidationToRequired: '宛先は必須です',
        EmailwerkEmailValidationInvalidEmail: 'メールアドレスが無効です',
        EmailwerkEmailValidationInvalidBccEmail:
          'BCC のメールアドレスが無効です',
        EmailwerkEmailValidationConsentRequired: '同意が必要です',
        EmailwerkEmailTemplatesNotFound: 'テンプレートが見つかりません',
        EmailwerkEmailTemplatesFetchGraphqlError:
          'GraphQL エラーによりテンプレートを取得できませんでした。',
        EmailwerkEmailTemplatesFetchUnknownError:
          'テンプレートの取得中に不明なエラーが発生しました。',
        EmailwerkEmailTemplatesFetchErrorTitle:
          'テンプレートを取得できませんでした',
        EmailwerkEmailTemplatesFetchErrorDescription:
          'テンプレートの取得中にエラーが発生しました。',
        EmailwerkEmailMessagePlaceholder: 'ここにメッセージを入力',
        EmailwerkEmailPreviewNoContent: 'コンテンツがありません',
        EmailwerkEmailNoTemplateSelectedError:
          'テンプレートが選択されていません。',
        EmailwerkEmailSendFailedTitle: 'メールを送信できませんでした',
        EmailwerkEmailSentTitle: 'メールを送信しました',
        EmailwerkEmailSentDescription: 'メールは正常に送信されました。',
        EmailwerkEmailSubmissionErrorTitle: '送信エラー',
        EmailwerkEmailUnexpectedError: '予期しないエラーが発生しました。',
        EmailwerkEmailFormHeading: 'メールを送信',
        EmailwerkEmailPreviewButton: 'プレビュー',
        EmailwerkEmailTemplateLabel: 'メールテンプレート',
        EmailwerkEmailTemplatesLoading: 'テンプレートを読み込み中...',
        EmailwerkEmailErrorAlertTitle: 'エラー',
        EmailwerkEmailNoTemplatesAlertTitle: 'テンプレートが見つかりません',
        EmailwerkEmailNoTemplatesAlertDescription:
          '利用できるメールテンプレートがありません。先にテンプレートを作成してください。',
        EmailwerkEmailTemplateSelectPlaceholder: 'メールテンプレートを選択',
        EmailwerkEmailUnnamedTemplate: '名前のないテンプレート',
        EmailwerkEmailTemplateHelperText: 'メールに使用するテンプレートです。',
        EmailwerkEmailToLabel: '宛先',
        EmailwerkEmailToPlaceholder: 'jane.doe@snek.at',
        EmailwerkEmailToHelperText:
          'メールの受信者です。複数の受信者はカンマで区切って入力してください。',
        EmailwerkEmailSubjectLabel: '件名',
        EmailwerkEmailSubjectPlaceholder: 'こんにちは',
        EmailwerkEmailSubjectHelperText: 'メールの件名です。',
        EmailwerkEmailMessageLabel: 'メッセージ',
        EmailwerkEmailEditorBold: '太字',
        EmailwerkEmailEditorItalic: '斜体',
        EmailwerkEmailEditorUnderline: '下線',
        EmailwerkEmailEditorHeading1: '見出し 1',
        EmailwerkEmailEditorHeading2: '見出し 2',
        EmailwerkEmailEditorHeading3: '見出し 3',
        EmailwerkEmailEditorBulletList: '箇条書きリスト',
        EmailwerkEmailEditorOrderedList: '番号付きリスト',
        EmailwerkEmailEditorQuote: '引用',
        EmailwerkEmailEditorSetLink: 'リンクを設定',
        EmailwerkEmailEditorUnsetLink: 'リンクを解除',
        EmailwerkEmailEditorLinkPrompt: 'URL を入力してください',
        EmailwerkEmailMessageHelperText: 'メールの本文です。',
        EmailwerkEmailBccLabel: 'BCC',
        EmailwerkEmailBccPlaceholder: 'john.doe@snek.at',
        EmailwerkEmailBccHelperText:
          'メールの非表示の追加受信者です。複数の受信者はカンマで区切って入力してください。',
        EmailwerkEmailConsentLabel:
          'このボックスにチェックを入れると、「送信」ボタンをクリックした時点でメールが送信されることに同意したものとみなされます。',
        EmailwerkEmailSendButton: '送信',
        EmailwerkEmailPreviewTitle: 'メールプレビュー',
        EmailwerkEmailPreviewNoTemplate: 'テンプレートが選択されていません',
        EmailwerkEmailPreviewNoSubject: '件名なし',
        EmailwerkEmailPreviewCloseButton: '閉じる',
        EmailwerkSenderModalSubmitError:
          'フォームの送信中にエラーが発生しました。',
        EmailwerkSenderModalUnknownError: '不明なエラーが発生しました。',
        EmailwerkSenderModalActionFailed: '送信者の操作に失敗しました。',
        EmailwerkSenderModalOpenButton: '送信者を管理',
        EmailwerkSenderModalTitle: '送信者',
        EmailwerkSenderModalErrorAlertTitle: 'エラー',
        EmailwerkSenderModalColumnAddress: 'アドレス',
        EmailwerkSenderModalColumnTransport: 'トランスポート',
        EmailwerkSenderModalBadgeDefault: 'デフォルト',
        EmailwerkSenderModalBadgeDisabled: '無効',
        EmailwerkSenderModalMakeDefaultButton: 'デフォルトにする',
        EmailwerkSenderModalVerifyButton: '確認',
        EmailwerkSenderModalDeleteButton: '削除',
        EmailwerkSenderModalEmpty: '送信者はまだ設定されていません。',
        EmailwerkSenderModalAddHeading: 'SMTP 送信者を追加',
        EmailwerkSenderModalValidationAddressRequired: 'アドレスは必須です',
        EmailwerkSenderModalAddressLabel: 'メールアドレス',
        EmailwerkSenderModalAddressPlaceholder: 'noreply@example.com',
        EmailwerkSenderModalDisplayNameLabel: '表示名',
        EmailwerkSenderModalValidationHostRequired: 'SMTP ホストは必須です',
        EmailwerkSenderModalHostLabel: 'SMTP ホスト',
        EmailwerkSenderModalValidationPortRequired: 'SMTP ポートは必須です',
        EmailwerkSenderModalPortLabel: 'SMTP ポート',
        EmailwerkSenderModalSecureLabel: 'セキュア接続',
        EmailwerkSenderModalValidationUsernameRequired:
          'SMTP ユーザー名は必須です',
        EmailwerkSenderModalUsernameLabel: 'SMTP ユーザー名',
        EmailwerkSenderModalValidationPasswordRequired:
          'SMTP パスワードは必須です',
        EmailwerkSenderModalPasswordLabel: 'SMTP パスワード',
        EmailwerkSenderModalIsDefaultLabel: 'デフォルトの送信者に設定',
        EmailwerkSenderModalCreateButton: '送信者を作成',
        EmailwerkSenderModalCloseButton: '閉じる'
      }
    }
  }

  return {
    code,
    strings: {
      Language: 'English',

      AuthLogin: 'Login',
      AuthSignup: 'Sign up',
      AuthLogout: 'Logout',
      AuthSettings: 'Settings',

      CmsLabelsRoot: 'CMS',

      CmsDashboardTitle: 'Jaen CMS',
      CmsDashboardMenuLabel: 'Dashboard',
      CmsDashboardMenuGroupLabel: 'Jaen CMS',

      CmsFrameStartEditing: 'Start editing',
      CmsFrameStopEditing: 'Stop editing',
      CmsFrameSaveDraft: 'Save draft',
      CmsFrameImportDraft: 'Import draft',
      CmsFrameDiscardChanges: 'Discard changes',
      CmsFrameDiscardAll: 'Discard',
      CmsFrameDiscardAllTitle: 'Discard all unpublished changes',
      CmsFrameDiscardAllConfirm:
        '{fields, plural, one {# unpublished change} other {# unpublished changes}} on {pages, plural, one {# page} other {# pages}} will be undone for everybody{who}{when}. The site goes back to what the last publish made.',
      CmsFrameDiscardAllConfirmWho: ', written by {editors}',
      CmsFrameDiscardAllConfirmWhen: ', since {since}',
      CmsFrameDiscardAllConfirmText: 'Discard everything',
      CmsFrameDiscardAllCancelText: 'Keep editing',
      CmsFrameDiscardNothing:
        'Nothing in the draft differs from what is published.',
      CmsFrameDiscardedTitle: 'Unpublished changes discarded',
      CmsFrameDiscardedDescription:
        '{who} discarded every unpublished change of this site at {at}. What you see is what is published.',
      CmsFrameDiscardedByAnAdmin: 'An administrator',
      CmsFrameSaveStateSaving: 'Saving',
      CmsFrameSaveStateSaved: 'Saved {at}',
      CmsFrameSaveStateSavedUnpublished: 'Saved {at}, not published',
      CmsFramePublished: 'Everything published',
      CmsFrameSaveStateOffline:
        'Offline, {count, plural, one {# change} other {# changes}} waiting',
      CmsFrameSaveStateError: 'Save failed, retrying',
      CmsFrameSaveStatePending: 'Not saved yet',
      CmsFramePublish:
        '{isPublishing, select, true {Publish in progress} other {Publish changes}}',
      CmsFrameNewMedia: 'New media',
      CmsFrameGuest: 'Guest',
      CmsFrameNotificationsEditModeTitle: 'Edit mode',
      CmsFrameNotificationsEditModeOn: 'You can now edit the page',
      CmsFrameNotificationsEditModeOff: 'You can no longer edit the page',
      CmsFrameNotificationsSaved: 'Saved',
      CmsFrameNotificationsSavedDescription: 'Your changes have been saved',
      CmsFrameNotificationsImported: 'Imported',
      CmsFrameNotificationsImportedDescription:
        'Your changes have been imported',
      CmsFrameNotificationsImportFailed: 'Failed to import',
      CmsFrameNotificationsImportFailedDescription:
        'Your changes could not be imported',
      CmsFrameNotificationsDiscarded: 'Discarded',
      CmsFrameNotificationsDiscardedDescription:
        'Your changes have been discarded',

      CmsPagesTitle: 'Jaen CMS | Pages',
      CmsPagesMenuLabel: 'Pages',

      CmsPagesBreadcrumbsPages: 'Pages',
      CmsPagesBreadcrumbsNew: 'New',

      CmsPagesNotificationsCreated: 'Page created',
      CmsPagesNotificationsCreatedDescription: 'Page {title} has been created',
      CmsPagesNotificationsUpdated: 'Page updated',
      CmsPagesNotificationsUpdatedDescription: 'Page {title} has been updated',
      CmsPagesNotificationsDeleted: 'Page deleted',
      CmsPagesNotificationsDeletedDescription: 'Page {slug} has been deleted',
      CmsPagesNotificationsDuplicated: 'Page duplicated',
      CmsPagesNotificationsDuplicatedDescription:
        'Page {slug} has been duplicated',
      CmsPagesNotificationsMoved: 'Page moved',
      CmsPagesNotificationsMovedDescription: 'Page {slug} has been moved',
      CmsPagesNotificationsSlugUpdated: 'Slug updated',
      CmsPagesNotificationsSlugUpdatedDescription:
        'Slug has been updated to {slug}',
      CmsPagesNotificationsDuplicateFailed: 'Could not duplicate page',
      CmsPagesNotificationsMoveFailed: 'Could not move page',
      CmsPagesNotificationsSlugUpdateFailed: 'Could not update slug',

      CmsPagesActionsDuplicate: 'Duplicate page',
      CmsPagesActionsMove: 'Move page',
      CmsPagesActionsUpdateSlug: 'Update slug',
      CmsPagesActionsRenameSlug: 'Rename slug',
      CmsPagesActionsDelete: 'Delete page',
      CmsPagesActionsDeleteThis: 'Delete this page',

      CmsPagesDescriptionsDuplicate:
        'This will duplicate the page with its subpages.',
      CmsPagesDescriptionsMove: 'This will move the page and all its subpages.',
      CmsPagesDescriptionsUpdateSlug:
        'This will rename the slug and thus affects the path of the page and all its subpages.',
      CmsPagesDescriptionsDelete:
        'This will delete the page and all its subpages.',

      CmsPagesPromptsDuplicateTitle: 'Duplicate page',
      CmsPagesPromptsDuplicateMessage:
        'Please enter a new slug for the duplicated page. This will affect the path.',
      CmsPagesPromptsDuplicateConfirm: 'Duplicate',
      CmsPagesPromptsDuplicateCancel: 'Cancel',
      CmsPagesPromptsDuplicatePlaceholder: '{slug}-copy',

      CmsPagesPromptsMoveTitle: 'Move page',
      CmsPagesPromptsMoveMessage: 'Please select a new parent page.',
      CmsPagesPromptsMoveConfirm: 'Move',
      CmsPagesPromptsMoveCancel: 'Cancel',

      CmsPagesPromptsRenameSlugTitle: 'Rename slug',
      CmsPagesPromptsRenameSlugMessage:
        'Please enter a new slug. This will affect the path.',
      CmsPagesPromptsRenameSlugConfirm: 'Rename',
      CmsPagesPromptsRenameSlugCancel: 'Cancel',

      CmsPagesPromptsDeleteTitle: 'Delete page',
      CmsPagesPromptsDeleteMessage:
        'Are you sure you want to delete this page and all its subpages?',
      CmsPagesPromptsDeleteConfirm: 'Delete',

      CmsPagesTableSubpagesHeading: 'Subpages',
      CmsPagesTableReorderEnable: 'Reorder',
      CmsPagesTableReorderDisable: 'Done',
      CmsPagesTableNewPage: 'New page',
      CmsPagesTableColumnsTitle: 'Title',
      CmsPagesTableColumnsDescription: 'Description',
      CmsPagesTableColumnsDate: 'Date',
      CmsPagesTableEmptyStateDescription:
        "This page doesn't have any subpages yet.",
      CmsPagesTableEmptyStateAction: 'Create a new page',
      CmsPagesTableDateCreated: 'Created {date} at {time}',
      CmsPagesTableDateUpdated: 'Last modified {date} at {time}',
      CmsPagesTableDateEmpty: '-',
      CmsPagesTableReorderError:
        'Something went wrong while reordering the pages.',
      CmsPagesTableDangerZoneHeading: 'Danger zone',

      CmsPagesLabelsNoTitle: 'No title',
      CmsPagesLabelsNoDescription: 'No description',
      CmsPagesLabelsFallbackTitle: 'Page',
      CmsPagesLabelsYes: 'Yes',

      CmsPagesFormHeadingCreate: 'Create a New Page',
      CmsPagesFormHeadingEdit: 'Edit the Page',
      CmsPagesFormLeadCreate:
        'A page represents an arrangement of fields or blocks that are presented on a specific URL.',
      CmsPagesFormLeadEdit:
        'Edit the page. Enhance SEO and social media presence.',
      CmsPagesFormTemplateCreate: 'Select a Template for the New Page',
      CmsPagesFormTemplateEdit: 'The template used for the page',
      CmsPagesFormTemplateHelperTextCreate:
        'This template will be applied to the new page, based on the parent page.',
      CmsPagesFormTemplateHelperTextEdit:
        'If you wish to modify the template, create a new page and transfer the content.',
      CmsPagesFormTitleCreate: 'Enter a Title for the New Page',
      CmsPagesFormTitleEdit: 'The title of the page',
      CmsPagesFormTitleHelperTextCreate:
        'The title of the new page. The URL slug will be automatically generated from the title.',
      CmsPagesFormTitleHelperTextEdit: 'The title of the page.',
      CmsPagesFormDescriptionCreate: 'Provide a Description for the New Page',
      CmsPagesFormDescriptionEdit: 'The description of the page',
      CmsPagesFormDescriptionHelperTextCreate:
        'The description will be utilized by search engines and social media. Aim for 160-165 characters.',
      CmsPagesFormDescriptionHelperTextEdit:
        'The description will be utilized by search engines and social media. Aim for 160-165 characters.',
      CmsPagesFormParentPageCreate: 'Select a Parent Page',
      CmsPagesFormParentPageEdit: 'The parent page of the page',
      CmsPagesFormParentHelperTextCreate:
        'This serves as the parent page of the new page.',
      CmsPagesFormParentHelperTextEdit:
        'You have the option to relocate the page to a more suitable parent page.',
      CmsPagesFormImageCreate: 'Image',
      CmsPagesFormImageEdit: 'Image',
      CmsPagesFormImageHelperTextCreate:
        'Include an image on the page. If left unset, the image of the parent page or site will be utilized.',
      CmsPagesFormImageHelperTextEdit:
        'The image of the page. If left unset, the image of the parent page or site will be utilized.',
      CmsPagesFormPostCreate: 'Mark as a Post',
      CmsPagesFormPostEdit: 'Post',
      CmsPagesFormPostHelperTextCreate:
        'Designate this page as a post to incorporate a date and author field.',
      CmsPagesFormPostHelperTextEdit:
        'Designate this page as a post to incorporate a date and author field.',
      CmsPagesFormPostDateCreate: 'Enter a Date for the New Page',
      CmsPagesFormPostDateEdit: 'The publication date of the page',
      CmsPagesFormPostDateHelperTextCreate:
        'The date will be employed for post sorting.',
      CmsPagesFormPostDateHelperTextEdit:
        'The date will be employed for post sorting.',
      CmsPagesFormPostAuthorCreate: 'Enter an Author for the New Page',
      CmsPagesFormPostAuthorEdit: 'The author of the page',
      CmsPagesFormPostAuthorHelperTextCreate:
        'This will be displayed as the author of the post.',
      CmsPagesFormPostAuthorHelperTextEdit:
        'This will be displayed as the author of the post.',
      CmsPagesFormPostCategoryCreate: 'Enter a Category for the New Page',
      CmsPagesFormPostCategoryEdit: 'The category of the page',
      CmsPagesFormPostCategoryHelperTextCreate:
        'The category will be used for post classification.',
      CmsPagesFormPostCategoryHelperTextEdit:
        'The category will be used for post classification.',
      CmsPagesFormExcludeFromIndexCreate: 'Exclude from Index',
      CmsPagesFormExcludeFromIndexEdit: 'Exclude from Index',
      CmsPagesFormExcludeFromIndexHelperTextCreate:
        'Exclude this page from all index fields (e.g., locations where pages are listed).',
      CmsPagesFormExcludeFromIndexHelperTextEdit:
        'Exclude this page from all index fields (e.g., locations where pages are listed).',
      CmsPagesFormPlaceholdersTitle: 'Title',
      CmsPagesFormPlaceholdersSlug: 'slug',
      CmsPagesFormPlaceholdersDescription: 'Description',
      CmsPagesFormPlaceholdersAuthor: 'Author',
      CmsPagesFormPlaceholdersCategory: 'Category',
      CmsPagesFormHelperMediaDescription:
        'Upload a photo to represent the organization.',
      CmsPagesFormErrorsSlugInUse: 'Slug is already in use',
      CmsPagesFormErrorsParentRequired: 'Parent is required',
      CmsPagesFormErrorsTemplateRequired: 'Template is required',
      CmsPagesFormErrorsDateRequired: 'Date is required for blog posts',
      CmsPagesFormErrorsAuthorRequired: 'Author is required for blog posts',
      CmsPagesFormButtonsPreview: 'Preview',
      CmsPagesFormButtonsEdit: 'Edit page',
      CmsPagesFormButtonsCancel: 'Cancel',
      CmsPagesFormButtonsCreate: 'Create page',
      CmsPagesFormButtonsSave: 'Save page',

      CmsMediaTitle: 'Jaen CMS | Media',
      CmsMediaMenuLabel: 'Media',
      CmsMediaBreadcrumbsMedia: 'Media',

      CmsSettingsTitle: 'Jaen CMS | Settings',
      CmsSettingsMenuLabel: 'Settings',
      CmsSettingsBreadcrumbsSettings: 'Settings',
      CmsSettingsNotificationsUpdated: 'Settings updated',
      CmsSettingsFormHeading: 'Settings',
      CmsSettingsFormSiteInfoGroupTitle: 'Site Info',
      CmsSettingsFormSiteInfoTitleLabel: 'Title',
      CmsSettingsFormSiteInfoTitlePlaceholder: 'Title',
      CmsSettingsFormSiteInfoTitleTooLong: 'Title is too long',
      CmsSettingsFormSiteInfoUrlLabel: 'URL',
      CmsSettingsFormSiteInfoUrlPlaceholder: 'https://snek.at',
      CmsSettingsFormSiteInfoUrlInvalid:
        'URL must start with http:// or https://',
      CmsSettingsFormSiteInfoDescriptionLabel: 'Description',
      CmsSettingsFormSiteInfoDescriptionPlaceholder:
        'The description that appears in search engines and social media.',
      CmsSettingsFormSiteInfoDescriptionHelper:
        'Brief description for your site.',
      CmsSettingsFormSiteInfoImageLabel: 'Image',
      CmsSettingsFormSiteInfoImageDescription:
        'Upload a photo to represent the site.',
      CmsSettingsFormOrganisationGroupTitle: 'Organisation',
      CmsSettingsFormOrganisationNameLabel: 'Name',
      CmsSettingsFormOrganisationNamePlaceholder: 'Snek',
      CmsSettingsFormOrganisationNameTooLong: 'Name is too long',
      CmsSettingsFormOrganisationUrlLabel: 'URL',
      CmsSettingsFormOrganisationUrlPlaceholder: 'https://snek.at',
      CmsSettingsFormOrganisationUrlInvalid:
        'URL must start with http:// or https://',
      CmsSettingsFormOrganisationLogoLabel: 'Image',
      CmsSettingsFormOrganisationLogoDescription:
        'Upload a photo to represent the organization.',
      CmsSettingsFormCancel: 'Cancel',
      CmsSettingsFormSave: 'Save',

      CmsDebugTitle: 'Jaen CMS | Debug',
      CmsDebugBreadcrumbsDebug: 'Debug',

      CmsNotificationTitle: 'Jaen CMS | Notification',
      CmsNotificationMenuLabel: 'Popup',
      CmsNotificationBreadcrumbsPopup: 'Popup',
      CmsNotificationCardTitle: 'Notification Popup',
      CmsNotificationCardDescription:
        'Configure the notification popup. The notification will be shown when the user visits the page.',
      CmsNotificationPreview: 'Preview',
      CmsNotificationNotificationsUpdated: 'Notification updated',
      CmsNotificationNotificationsUpdatedDescription:
        'The notification has been updated',
      CmsNotificationFormTitleLabel: 'Title',
      CmsNotificationFormTitlePlaceholder: 'News',
      CmsNotificationFormTitleDescription: 'The title of the notification',
      CmsNotificationFormMessageLabel: 'Message',
      CmsNotificationFormMessageExample: 'This is a example message',
      CmsNotificationFormMessageDescription: 'The message of the notification',
      CmsNotificationFormEnterUrl: 'Enter the URL',
      CmsNotificationFormFromLabel: 'From',
      CmsNotificationFormFromDescription:
        'The notification will be shown <b>after</b> this date',
      CmsNotificationFormToLabel: 'To',
      CmsNotificationFormToDescription:
        'The notification will be shown <b>until</b> this date',
      CmsNotificationFormPickDate: 'Pick a date',
      CmsNotificationFormEnabledLabel:
        'Show notification popup when the user visits the page',
      CmsNotificationFormSubmit: 'Submit',

      // Accounts
      CmsAccountsErrorsLoadService:
        'Failed to load users from the identity service.',
      CmsAccountsErrorsLoadGeneric: 'Failed to load users.',
      CmsAccountsNotificationsCreated: 'Account created',
      CmsAccountsNotificationsCreatedDescription:
        'Account {username} has been created',
      CmsAccountsNotificationsCreateFailed: 'Could not create account',
      CmsAccountsTitle: 'Accounts',
      CmsAccountsPageTitle: 'Jaen CMS | Accounts',
      CmsAccountsMenuLabel: 'Accounts',
      CmsAccountsBreadcrumbsAccounts: 'Accounts',
      CmsAccountsSubtitle:
        'Browse and manage the user accounts of your identity tenant.',
      CmsAccountsActionsCreate: 'New account',
      CmsAccountsSearchPlaceholder: 'Search by name, email or login name',
      CmsAccountsErrorsLoadTitle: 'Unable to load accounts',
      CmsAccountsCardUnnamed: 'Unnamed user',
      CmsAccountsCardNoEmail: 'No email provided',
      CmsAccountsCardUsername: 'Username',
      CmsAccountsCardLoginNames: 'Login names',
      CmsAccountsCardNoLoginNames: 'No alternate login names',
      CmsAccountsCardManage: 'Manage account',
      CmsAccountsEmptyTitle: 'No accounts match your search',
      CmsAccountsEmptyHint: 'Adjust the search term or create a new account.',
      CmsAccountsCreateTitle: 'Create a new account',
      CmsAccountsCreateUsername: 'Username',
      CmsAccountsCreateEmail: 'Email',
      CmsAccountsCreateFirstName: 'First name',
      CmsAccountsCreateLastName: 'Last name',
      CmsAccountsCreateInitialPassword: 'Initial password (optional)',
      CmsAccountsCreateSendReset:
        'Send a password reset email when no password is set',
      CmsAccountsActionsCancel: 'Cancel',
      CmsAccountsActionsCreateSubmit: 'Create account',
      CmsAccountsErrorsDetailService:
        'Failed to load the user profile from the identity service.',
      CmsAccountsErrorsDetailGeneric: 'Failed to load the user profile.',
      CmsAccountsNotificationsActionFailed: 'Action failed',
      CmsAccountsNotificationsSaved: 'Changes saved',
      CmsAccountsNotificationsSavedDescription: 'The profile has been updated.',
      CmsAccountsNotificationsSaveFailed: 'Save failed',
      CmsAccountsNotificationsDeleted: 'Account deleted',
      CmsAccountsNotificationsPasswordSet: 'Password set',
      CmsAccountsNotificationsRolesUpdated: 'Roles updated',
      CmsAccountsDetailBack: 'Back to accounts',
      CmsAccountsErrorsDetailTitle: 'Unable to load this account',
      CmsAccountsDetailNoEmail: 'No primary email provided',
      CmsAccountsDetailUsername: 'Username',
      CmsAccountsDetailPreferredLogin: 'Preferred login',
      CmsAccountsDetailState: 'Account state',
      CmsAccountsDetailCreated: 'Created',
      CmsAccountsDetailLastChange: 'Last change',
      CmsAccountsDetailResourceOwner: 'Organization',
      CmsAccountsProfileTitle: 'Profile',
      CmsAccountsProfileDisplayName: 'Display name',
      CmsAccountsProfileLanguage: 'Preferred language',
      CmsAccountsProfileFirstName: 'First name',
      CmsAccountsProfileLastName: 'Last name',
      CmsAccountsProfileEmail: 'Email',
      CmsAccountsProfilePhone: 'Phone',
      CmsAccountsProfileReset: 'Reset',
      CmsAccountsProfileSave: 'Save changes',
      CmsAccountsRolesTitle: 'Project roles',
      CmsAccountsRolesGrant: 'Grant roles',
      CmsAccountsRolesEdit: 'Edit',
      CmsAccountsNotificationsRolesRevoked: 'Roles revoked',
      CmsAccountsRolesRevoke: 'Revoke',
      CmsAccountsRolesEmpty: 'No project roles granted.',
      CmsAccountsActionsTitle: 'Account actions',
      CmsAccountsActionsSetPassword: 'Set password',
      CmsAccountsNotificationsResetRequested: 'Password reset requested',
      CmsAccountsActionsRequestReset: 'Request password reset',
      CmsAccountsNotificationsVerificationSent: 'Verification email sent',
      CmsAccountsActionsResendVerification: 'Resend email verification',
      CmsAccountsNotificationsDeactivated: 'Account deactivated',
      CmsAccountsActionsDeactivate: 'Deactivate',
      CmsAccountsNotificationsReactivated: 'Account reactivated',
      CmsAccountsActionsReactivate: 'Reactivate',
      CmsAccountsNotificationsUnlocked: 'Account unlocked',
      CmsAccountsActionsUnlock: 'Unlock',
      CmsAccountsNotificationsLocked: 'Account locked',
      CmsAccountsActionsLock: 'Lock',
      CmsAccountsActionsDelete: 'Delete account',
      CmsAccountsDeleteTitle: 'Delete account',
      CmsAccountsDeletePrompt:
        'Are you sure you want to delete {username}? This cannot be undone.',
      CmsAccountsPasswordTitle: 'Set a new password',
      CmsAccountsPasswordNew: 'New password',
      CmsAccountsPasswordChangeRequired: 'Require a change on next sign-in',
      CmsAccountsRolesEditTitle: 'Edit granted roles',
      CmsAccountsRolesGrantTitle: 'Grant project roles',
      CmsAccountsRolesProject: 'Project',
      CmsAccountsRolesNoneAvailable: 'No roles available for this project.',
      CmsAccountsRolesSave: 'Save roles'
    }
  }
}
